import { Row, Col, Form, Accordion } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItemText,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
} from "@mui/material";
import UploadIcon from "@mui/icons-material/DriveFolderUpload";
import AddBoxIcon from "@mui/icons-material/AddBox";
import SyncIcon from "@mui/icons-material/SyncSharp";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useLoader } from "../../context/LoaderContext";
import {
  Add,
  GetAccountDetails,
  GetAccountLogo,
  GetAccountMetaDataFields,
  GetClientDetails,
  GetClients,
  GetFolders,
} from "../../api/accountsApi/accountsApi";
import { useLocation, useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-enterprise";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PermDeviceInformationRoundedIcon from "@mui/icons-material/PermDeviceInformationRounded";
import {
  AccountDetailsContext,
  AccountEnabledAvailableFundFolder,
  AccountMetadataFieldsModel,
  AccountModel,
  AccountPreWorkInstructionModel,
  AccountProcessStageModel,
  ArchiveLevelRules,
  CustomProcessModel,
  DownStreamExportRule,
  FieldModel,
  FundFoldersModel,
  HelpModel,
  QueryModel,
} from "../../types/AccountModel";
import { GetActiveFileLocation, GetMetadataColumns } from "../../api/commonApi";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSnackbar } from "../Common/SnackbarContext";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import LocalStorageUtil from "../../utils/localStorage";
import styles from "./NewAccountConfiguration.module.css";

interface Option {
  value: number;
  label: string;
}

interface Category {
  label: string;
  options: Option[];
}

const NewAccountConfiguration: React.FC = () => {
  const { showSnackbar } = useSnackbar();
  const [activeKeys, setActiveKeys] = useState<string[]>([]);
  const [checkedCategories, setCheckedCategories] = useState<any>([]);
  const [activeStepNew, setActiveStepNew] = useState(0);
  const [steps, setSteps] = useState([
    { key: "Basic Information", label: "Basic Information", isDone: true },
    { key: "Prework", label: "Prework", isDone: false },
    { key: "Downstream", label: "Downstream Summary", isDone: false },
    { key: "eDelivery", label: "eDelivery", isDone: false },
    { key: "Active DocID export", label: "Active DocID export", isDone: false },
    { key: "Archival Report", label: "Archival Report", isDone: false },
    { key: "Turbo Proofs", label: "Turbo Proofs", isDone: false },
    { key: "Post-Work", label: "Post Work", isDone: false },
    {
      key: "Metadata Configuration",
      label: "Metadata Configuration",
      isDone: true,
    },
    { key: "Help Documents", label: "Help Documents", isDone: true },
  ]);
  const setSelectedAccountDetails = useState<any[]>([])[1]; // NOSONAR
  const [basicAccountDetails, setBasicAccountDetails] = useState<any[]>([]);
  const [preworkAccountDetails, setPreworkAccountDetails] = useState<any[]>([]);
  const [downstreamAccountDetails, setDownstreamAccountDetails] = useState<
    any[]
  >([]);
  const [edeliveryAccountDetails, setEdeliveryAccountDetails] = useState<any[]>(
    [],
  );
  const [activeDocIdExportAccountDetails, setActiveDocIdExportAccountDetails] =
    useState<any[]>([]);
  const [archivalReportAccountDetails, setArchivalReportAccountDetails] =
    useState<any[]>([]);
  const [turboProofsAccountDetails, setTurboProofsAccountDetails] = useState<
    any[]
  >([]);
  const setPostWorkAccountDetails = useState<any[]>([])[1]; // NOSONAR
  const [processStages, setProcessStages] = useState<any[]>([]);
  const [processAllStage, setProcessAllStage] = useState<any[]>([]);
  const [responsedAccountId, setResponsedAccountId] = useState<number>(0);
  const [responsedAccountDownStreamId, setResponsedAccountDownStreamId] =
    useState<number>(0);
  const [responsedAccountPreworkId, setResponsedAccountPreworkId] =
    useState<number>(0);
  const [accountEdeliveryId, setAccountEdeliveryId] = useState<number>(0);

  // #region Basic Information Tab 1
  const [clientName, setClientName] = useState<any[]>([]);
  const [clientId, setClientId] = useState<number>(0);
  const [validationClientId, setValidationClientId] = useState<string | null>(
    "",
  );
  const [accountName, setAccountName] = useState<string>("");
  const [customerCode, setCustomerCode] = useState<string>("");
  const [validationCustomerCode, setValidationCustomerCode] = useState<
    string | null
  >("");
  const [isDownloadByDefault, setIsDownloadByDefault] =
    useState<boolean>(false);
  const [contactName, setContactName] = useState<string>("");
  const [validationContactName, setValidationContactName] = useState<
    string | null
  >("");
  const [contactPhoneNumber, setContactPhoneNumber] = useState<string>("");
  const [validationContactPhoneNumber, setValidationContactPhoneNumber] =
    useState<string | null>("");
  const [contactEmail, setContactEmail] = useState<string>("");
  const [validationContactEmail, setValidationContactEmail] = useState<
    string | null
  >("");
  const [validationDynamicContactName] = useState<string | null>("");
  const [validationDynamicContactPhoneNumber, ,] = useState<string | null>(""); // NOSONAR
  const [validationDynamicContactEmail] = useState<string | null>("");
  const [apiKeys, setApiKeys] = useState<string>("");
  const [validationApiKeys, setValidationApiKeys] = useState<string | null>("");
  const setIsPrework = useState<boolean>(false)[1]; // NOSONAR
  const setIsDownstream = useState<boolean>(false)[1]; // NOSONAR
  const setIsEDelivery = useState<boolean>(false)[1]; // NOSONAR
  const setIsActiveDocIdExport = useState<boolean>(false)[1]; // NOSONAR
  const setIsArchivalReport = useState<boolean>(false)[1]; // NOSONAR
  const setIsTurboProofs = useState<boolean>(false)[1]; // NOSONAR
  const setIsPostWork = useState<boolean>(false)[1]; // NOSONAR
  const [isMenuExpand, setIsMenuExpand] = useState<boolean>(false);
  const [isDashboardCountShow, setIsDashboardCountShow] =
    useState<boolean>(false);
  const [isFolderAccessRightsShow, setIsFolderAccessRightsShow] =
    useState<boolean>(false);
  const [isPasswordNotificationShow, setIsPasswordNotificationShow] =
    useState<boolean>(false);
  const [isUserPreferencesShow, setIsUserPreferencesShow] =
    useState<boolean>(false);
  const [rows, setRows] = useState([{ name: "", phoneNumber: "", email: "" }]);
  const { setLoading } = useLoader();
  const [logoBase64, setLogoBase64] = useState<string>("");
  const [availableFolderData, setAvailableFolderData] = useState<any[]>([]);
  const [enabledFolderData, setEnabledFolderData] = useState<any[]>([]);
  const [passwordNotificationDays, setPasswordNotificationDays] =
    useState<string>("");
  const [
    validationPasswordNotificationDays,
    setValidationPasswordNotificationDays,
  ] = useState<string | null>(null);

  const [userExpiryNoticationDays, setUserExpiryNoticationDays] =
    useState<string>("");
  const [
    validationUserExpireNotificationDays,
    setValidationUserExpireNotificationDays,
  ] = useState<string | null>(null);

  const [dashboardInterval, setDashboardInterval] = useState<string>("");
  const [validationDashboardInterval, setValidationDashboardInterval] =
    useState<string | null>(null);
  let selectedClientId: number = 0;
  const location = useLocation();
  let accountId = location?.state?.["accountId"];
  let contextName = location?.state?.["contextName"];
  let businessUnitId = location?.state?.["businessUnitId"];

  const setRowData = useState<any[]>([])[1]; // NOSONAR
  const [activeFileLocations, setActiveFileLocations] = useState<any[]>([]);
  const [metadataColumns, setMetadataColumns] = useState<any[]>([]);
  const [validationMessage, setValidationMessage] = useState<string | null>(
    null,
  );
  const [instructionName, setInstructionName] = useState<string>("");
  const [validationInstructionName, setValidationInstructionName] = useState<
    string | null
  >("");

  const [metadataFields, setMetadataFields] = useState<any[]>([]);
  const [rowDataTurbo, setRowDataTurbo] = useState<any[]>([]);
  const [rowDataPostWork, setRowDataPostWork] = useState<any[]>([]);
  const [isLevelOneCheck, setIsLevelOneCheck] = useState<boolean>(false);
  // #endregion

  // #region Prework Tab 2
  const [isSecondrayPreFlightEnable, setIsSecondrayPreFlightEnable] =
    useState<boolean>(false);
  const [docIdFormat, setDocIdFormat] = useState<number>(0);
  const [isFtpFolderEnable, setIsFtpFolderEnable] = useState<boolean>(false);
  const [isPdfEnable, setIsPdfEnable] = useState<boolean>(false);
  const [isExcelEnable, setIsExcelEnable] = useState<boolean>(false);
  const [isWordEnable, setIsWordEnable] = useState<boolean>(false);
  const [fileSize, setFileSize] = useState<number | string>(0);
  const setValidationFileSize = useState<string | null>("")[1]; // NOSONAR
  const [isOtherFileFormat, setIsOtherFileFormat] = useState<boolean>(false);
  const [otherFileType, setOtherFileType] = useState<string>("");
  const [enableUIUpload, setEnableUIUpload] = useState<boolean>(false);
  const [isZipEnable, setIsZipEnable] = useState<boolean>(false);
  const [validationZipFile, setValidationZipFile] = useState<string | null>("");
  const [ftpSourceFTPLocationId, setFtpSourceFTPLocationId] =
    useState<number>(0);
  const [localShareFTPLocationId, setLocalShareFTPLocationId] =
    useState<number>(0);
  const [secondaryPreflightFTPLocationId, setSecondaryPreflightFTPLocationId] =
    useState<number>(0);
  const [fromPreflightFTPLocationId, setFromPreflightFTPLocationId] =
    useState<number>(0);
  const [finalFolderFTPLocationId, setFinalFolderFTPLocationId] =
    useState<number>(0);
  const [isTriggerProofWorkFlowEnabled, setIsTriggerProofWorkFlowEnabled] =
    useState<boolean>(false);
  const [triggerProofExport1LocationId, setTriggerProofExport1LocationId] =
    useState<number>(0);
  const [triggerProofExport2LocationId, setTriggerProofExport2LocationId] =
    useState<number>(0);
  const [proofExp1CanprefixjobCode, setProofExp1CanprefixjobCode] =
    useState<boolean>(false);
  const [proofExp2CanprefixjobCode, setProofExp2CanprefixjobCode] =
    useState<boolean>(false);
  const [triggerProofExport3LocationId, setTriggerProofExport3LocationId] =
    useState<number>(0);
  const [triggerProofExport3Naming, setTriggerProofExport3Naming] =
    useState<string>("");
  const [
    triggerProofExport3MetaDataDefinitionId,
    setTriggerProofExport3MetaDataDefinitionId,
  ] = useState<number>(0);
  const [isExportLocation3and4Show, setIsExportLocation3and4Show] =
    useState<boolean>(false);
  const [triggerProofExport4LocationId, setTriggerProofExport4LocationId] =
    useState<number>(0);
  const [triggerProofExport4Naming, setTriggerProofExport4Naming] =
    useState<string>("");
  const [triggerProd2Export4Naming, setTriggerProd2Export4Naming] =
    useState<string>("");
  const [
    triggerProd2Export4MetaDataDefinitionId,
    setTriggerProd2Export4MetaDataDefinitionId,
  ] = useState<number>(0);
  const [isExportLocation3and4Prod2Show, setIsExportLocation3and4Prod2Show] =
    useState<boolean>(false);
  const [
    triggerProofExport4MetaDataDefinitionId,
    setTriggerProofExport4MetaDataDefinitionId,
  ] = useState<number>(0);
  const [
    triggerProofExport3ReturnLocationId,
    setTriggerProofExport3ReturnLocationId,
  ] = useState<number>(0);
  const [
    triggerProofExport3ReturnArchivalLocationId,
    setTriggerProofExport3ReturnArchivalLocationId,
  ] = useState<number>(0);
  const [
    triggerProofExport4ReturnLocationId,
    setTriggerProofExport4ReturnLocationId,
  ] = useState<number>(0);
  const [isExportLocation3and4ProofShow, setIsExportLocation3and4ProofShow] =
    useState<boolean>(false);
  const [isExportLocation3and4ProdShow, setIsExportLocation3and4ProdShow] =
    useState<boolean>(false);
  const [triggerProdExport1LocationId, setTriggerProdExport1LocationId] =
    useState<number>(0);
  const [prodExp1CanprefixjobCode, setProdExp1CanprefixjobCode] =
    useState<boolean>(false);
  const [triggerProdExport2LocationId, setTriggerProdExport2LocationId] =
    useState<number>(0);
  const [prodExp2CanprefixjobCode, setProdExp2CanprefixjobCode] =
    useState<boolean>(false);
  const [triggerProdExport3LocationId, setTriggerProdExport3LocationId] =
    useState<number>(0);
  const [triggerProdExport3Naming, setTriggerProdExport3Naming] =
    useState<string>("");
  const [
    triggerProdExport3MetaDataDefinitionId,
    setTriggerProdExport3MetaDataDefinitionId,
  ] = useState<number>(0);
  const [triggerProdExport4LocationId, setTriggerProdExport4LocationId] =
    useState<number>(0);
  const [isTriggerProdWorkFlowEnabled, setIsTriggerProdWorkFlowEnabled] =
    useState<boolean>(false);
  const [toPreFlightFileNameConvention, setToPreFlightFileNameConvention] =
    useState<string>("");
  const [fromPreFlightFileNameConvention, setFromPreFlightFileNameConvention] =
    useState<string>("");
  const [preworkEmailRequired, setPreworkEmailRequired] =
    useState<boolean>(false);
  const [isAllowReprocess, setIsAllowReprocess] = useState<boolean>(false);
  const [printReadyEmailRequired, setPrintReadyEmailRequired] =
    useState<boolean>(false);
  const [
    primaryPreflightReturnEmailRequired,
    setPrimaryPreflightReturnEmailRequired,
  ] = useState<boolean>(false);
  const [exportToFinalEmailRequired, setExportToFinalEmailRequired] =
    useState<boolean>(false);
  const [preworkWarningEmailRequired, setPreworkWarningEmailRequired] =
    useState<boolean>(false);
  const [preworkExpirationEmailRequired, setPreworkExpirationEmailRequired] =
    useState<boolean>(false);
  const [documentRenameEmailRequired, setDocumentRenameEmailRequired] =
    useState<boolean>(false);
  const [documentRejectEmailRequired, setDocumentRejectEmailRequired] =
    useState<boolean>(false);
  const [documentDeleteEmailRequired, setDocumentDeleteEmailRequired] =
    useState<boolean>(false);
  const [
    triggerProofExport1EmailRequired,
    setTriggerProofExport1EmailRequired,
  ] = useState<boolean>(false);
  const [
    triggerProofExport2EmailRequired,
    setTriggerProofExport2EmailRequired,
  ] = useState<boolean>(false);
  const [
    triggerProofExport3EmailRequired,
    setTriggerProofExport3EmailRequired,
  ] = useState<boolean>(false);
  const [
    triggerProofExport4EmailRequired,
    setTriggerProofExport4EmailRequired,
  ] = useState<boolean>(false);
  const [
    triggerProofExport3ReturnEmailRequired,
    setTriggerProofExport3ReturnEmailRequired,
  ] = useState<boolean>(false);
  const [
    triggerProofExport4ReturnEmailRequired,
    setTriggerProofExport4ReturnEmailRequired,
  ] = useState<boolean>(false);
  const [triggerProdExport1EmailRequired, setTriggerProdExport1EmailRequired] =
    useState<boolean>(false);
  const [triggerProdExport2EmailRequired, setTriggerProdExport2EmailRequired] =
    useState<boolean>(false);
  const [triggerProdExport3EmailRequired, setTriggerProdExport3EmailRequired] =
    useState<boolean>(false);
  const [triggerProdExport4EmailRequired, setTriggerProdExport4EmailRequired] =
    useState<boolean>(false);
  const [preworkRowData, setPreworkRowData] = useState<any[]>([]);
  // #endregion

  // #region Downstream Summary Tab 3
  const [MetaddataSourceDefinitions, setMetaddataSourceDefinitions] = useState<
    any[]
  >([]);
  const [isDAOEnabled, setIsDAOEnabled] = useState<boolean>(false);
  const [isDSAEnabled, setIsDSAEnabled] = useState<boolean>(false);
  const [isNoSubProcessEnabled, setIsNoSubProcessEnabled] =
    useState<boolean>(false);
  const [isNewProcessEnabled, setIsNewProcessEnabled] =
    useState<boolean>(false);
  const [
    isPDFExportLocation3DownstreamShow,
    setIsPDFExportLocation3DownstreamShow,
  ] = useState<boolean>(false);
  const [
    isNewProcessPDFExportLocation3DownstreamShow,
    setIsNewProcessPDFExportLocation3DownstreamShow,
  ] = useState<boolean>(false);
  const [isNewProcessPdfEnabled, setIsNewProcessPdfEnabled] =
    useState<boolean>(false);
  const [isNewProcessPdfMetadataEnabled, setIsNewProcessPdfMetadataEnabled] =
    useState<boolean>(false);
  const [isPdfSplitEnabled, setIsPdfSplitEnabled] = useState<boolean>(false);
  const [isBulkUploadEnabled, setIsBulkUploadEnabled] =
    useState<boolean>(false);
  const [newProcessExportFTPLocationId, setNewProcessExportFTPLocationId] =
    useState<number>(0);
  const [level, setLevel] = useState<number>(0);
  const [
    newProcessExportNamingConvention,
    setNewProcessExportNamingConvention,
  ] = useState<string>("");
  const [exportFolderlevel2, setExportFolderlevel2] = useState<string>("");
  const [validationExportFolderlevel2, setValidationExportFolderlevel2] =
    useState<string | null>("");
  const [downStreamExportRules, setDownStreamExportRules] = useState<any[]>([]);
  const [checkedItems, setCheckedItems] = useState<number[]>([]);
  const [pdfSourceFTPLocationId, setPdfSourceFTPLocationId] =
    useState<number>(0);
  const [pdfArchiveFTPLocationId, setPdfArchiveFTPLocationId] =
    useState<number>(0);
  const [metadataSourceFTPLocationId, setMetadataSourceFTPLocationId] =
    useState<number>(0);
  const [metadataArchiveFTPLocationId, setMetadataArchiveFTPLocationId] =
    useState<number>(0);
  const [
    sourceIngestionMetadtaDefinitionID,
    setSourceIngestionMetadtaDefinitionID,
  ] = useState<number>(0);
  const [hasHeader, setHasHeader] = useState<boolean>(false);
  const [daoExportNamingConvention, setDaoExportNamingConvention] =
    useState<string>("");
  const [toSecondaryFTPLocationId, setToSecondaryFTPLocationId] =
    useState<number>(0);
  const [fromSecondaryFTPLocationId, setFromSecondaryFTPLocationId] =
    useState<number>(0);
  const [
    fromSecondaryArchiveFTPLocationId,
    setFromSecondaryArchiveFTPLocationId,
  ] = useState<number>(0);
  const [exportFilenameWithoutUnderscore, setExportFilenameWithoutUnderscore] =
    useState<boolean>(false);
  const [daoReturnMetadataDefinitionID, setDaoReturnMetadataDefinitionID] =
    useState<number>(0);
  const [toDownSampleFTPLocationId, setToDownSampleFTPLocationId] =
    useState<number>(0);
  const [fromDownSamplingFTPLocationId, setFromDownSamplingFTPLocationId] =
    useState<number>(0);
  const [
    fromDownSamplingArchiveFTPLocationId,
    setFromDownSamplingArchiveFTPLocationId,
  ] = useState<number>(0);
  const [dsaReturnMetadataDefinitionID, setDsaReturnMetadataDefinitionID] =
    useState<number>(0);
  const [webReadyFtpLocationId, setWebReadyFtpLocationId] = useState<number>(0);
  const [webReadyArchiveFtpLocationId, setWebReadyArchiveFtpLocationId] =
    useState<number>(0);
  const [exportFtpLocationId, setExportFtpLocationId] = useState<number>(0);
  const [isDSAllowReprocess, setIsDSAllowReprocess] = useState<boolean>(false);
  const [isDisplayRuleMapping, setIsDisplayRuleMapping] =
    useState<boolean>(false);
  const [displayRuleMappingId, setDisplayRuleMappingId] = useState<number>(0);
  const [recentRecordDays, setRecentRecordDays] = useState<number>(0);
  const [indexFileProcessedMailRequired, setIndexFileProcessedMailRequired] =
    useState<boolean>(false);
  const [
    exportSecondaryPreFlightMailRequired,
    setExportSecondaryPreFlightMailRequired,
  ] = useState<boolean>(false);
  const [
    secondaryPreFlightReturnMailRequired,
    setSecondaryPreFlightReturnMailRequired,
  ] = useState<boolean>(false);
  const [
    secondaryPreFlightWarningMailRequired,
    setSecondaryPreFlightWarningMailRequired,
  ] = useState<boolean>(false);
  const [
    secondaryPreflightFailureRequired,
    setSecondaryPreflightFailureRequired,
  ] = useState<boolean>(false);
  const [exportDownSampleMailRequired, setExportDownSampleMailRequired] =
    useState<boolean>(false);
  const [downStreamReturnMailRequired, setDownStreamReturnMailRequired] =
    useState<boolean>(false);
  const [downsampleWarningMailRequired, setDownsampleWarningMailRequired] =
    useState<boolean>(false);
  const [downsampleFailureMailRequired, setDownsampleFailureMailRequired] =
    useState<boolean>(false);
  const [
    metadataRejectedReasonsMailRequired,
    setMetadataRejectedReasonsMailRequired,
  ] = useState<boolean>(false);

  // #endregion

  // #region e-Delivery Tab 4
  const [eDeliveryFtpLocationId, setEDeliveryFtpLocationId] =
    useState<number>(0);
  const [fundFolderType, setFundFolderType] = useState<number>(0);
  const [secondaryeDeliveryFTPLocationId, setSecondaryeDeliveryFTPLocationId] =
    useState<number>(0);
  const [secondaryFundFolderType, setSecondaryFundFolderType] =
    useState<number>(0);
  const [
    printReadyEdeliveryReturnFTPLocationId,
    setPrintReadyEdeliveryReturnFTPLocationId,
  ] = useState<number>(0);
  const [
    webReadyEdeliveryReturnFTPLocationId,
    setWebReadyEdeliveryReturnFTPLocationId,
  ] = useState<number>(0);
  const [
    printReadyEdeliveryReturnArchiveFTPLocationId,
    setPrintReadyEdeliveryReturnArchiveFTPLocationId,
  ] = useState<number>(0);
  const [
    webReadyEdeliveryReturnArchiveFTPLocationId,
    setWebReadyEdeliveryReturnArchiveFTPLocationId,
  ] = useState<number>(0);
  const [
    edeliveryReturnPrintReadyMetadataDefinitionID,
    setEdeliveryReturnPrintReadyMetadataDefinitionID,
  ] = useState<number>(0);
  const [
    edeliveryReturnWebreadyMetadatadefinitionID,
    setEdeliveryReturnWebreadyMetadatadefinitionID,
  ] = useState<number>(0);
  const [edeliveryReturn, setEdeliveryReturn] = useState<boolean>(false);
  const [secondaryEmailexportRequired, setSecondaryEmailexportRequired] =
    useState<boolean>(false);
  const [exportEmailRequired, setExportEmailRequired] =
    useState<boolean>(false);
  const [secondaryFileNameConvention, setSecondaryFileNameConvention] =
    useState<string>("");
  const [edeliveryFileNameConvention, setEdeliveryFileNameConvention] =
    useState<string>("");
  const [frequencyHrs, setFrequencyHrs] = useState<number>(0);
  const [frequencyMins, setFrequencyMins] = useState<number>(0);
  // #endregion

  // #region Active DocID export Tab 5
  const [searchCriterias, setSearchCriterias] = useState<any[]>([]);
  const setSearchCriteriaID = useState<number>(0)[1]; // NOSONAR
  const setFieldValue = useState<string>("")[1]; // NOSONAR
  const [accountActiveDocExportId, setAccountActiveDocExportId] =
    useState<number>(0);
  const [exportDocFTPLocationId, setExportDocFTPLocationId] =
    useState<number>(0);
  const [exportDocFTPLocationId2, setExportDocFTPLocationId2] =
    useState<number>(0);
  const [exportDocFTPLocationId3, setExportDocFTPLocationId3] =
    useState<number>(0);
  const [exportEmailRequiredActiveDocId, setExportEmailRequiredActiveDocId] =
    useState<boolean>(false);
  const [exportFileNameConvention, setExportFileNameConvention] =
    useState<string>("");
  const [exportFrequencyHour, setExportFrequencyHour] = useState<number>(0);
  const [exportFrequencyMin, setExportFrequencyMin] = useState<number>(0);
  const [categories, setCategories] = useState<Category[]>([]);
  // #endregion

  // #region Archival Report Tab 6
  const [checkedItemsArchiveWebReady, setCheckedItemsArchiveWebReady] =
    useState<number[]>([]);
  const [checkedItemsArchivePrintReady, setCheckedItemsArchivePrintReady] =
    useState<number[]>([]);
  const [validationWebReadyLevel2, setValidationWebReadyLevel2] = useState<
    string | null
  >("");
  const [validationPrintReadyLevel2, setValidationPrintReadyLevel2] = useState<
    string | null
  >("");
  const [archivalFolderConfigId, setArchivalFolderConfigId] =
    useState<number>(0);
  const [archivalLocationId, setArchivalLocationId] = useState<number>(0);
  const [archivalFileNameConvention, setArchivalFileNameConvention] =
    useState<string>("");
  const [archivalEmailRequired, setArchivalEmailRequired] =
    useState<boolean>(false);
  const [
    archivalReqApprovalEmailRequired,
    setArchivalReqApprovalEmailRequired,
  ] = useState<boolean>(false);
  const [archivalWebReadyLevel2, setArchivalWebReadyLevel2] =
    useState<string>("");
  const [archivalPrintReadyLevel2, setArchivalPrintReadyLevel2] =
    useState<string>("");
  const setArchivalExport1FolderId = useState<number>(0)[1]; // NOSONAR
  const setArchivalExport2FolderId = useState<number>(0)[1]; // NOSONAR
  const [exportFolderData, setExportFolderData] = useState<any[]>([]);

  // #endregion

  // #region Turbo Proofs Tab 7
  const [accountCustomProcessId, setAccountCustomProcessId] =
    useState<number>(0);
  const [processStageId, setProcessStageId] = useState<number>(0);
  const [fundFolderId, setFundFolderId] = useState<number>(0);
  const [turboCanFTPFolderUpload, setTurboCanFTPFolderUpload] =
    useState<boolean>(false);
  const [turboPdfType, setTurboPdfType] = useState<boolean>(false);
  const [turboExcelType, setTurboExcelType] = useState<boolean>(false);
  const [turboWordDocType, setTurboWordDocType] = useState<boolean>(false);
  const [turbofileSize, setTurbofileSize] = useState<number>(0);
  const [turboEnableUIUpload, setTurboEnableUIUpload] =
    useState<boolean>(false);
  const [turboftpSourceLocationId, setTurboftpSourceLocationId] =
    useState<number>(0);
  const [turboLevel1Folder, setTurboLevel1Folder] =
    useState<string>("TURBO PROOFS");
  const [turboLevel2Folder, setTurboLevel2Folder] = useState<string>("");
  const [turboLevel3Folder, setTurboLevel3Folder] = useState<string>("");
  const [turboLevel4Folder, setTurboLevel4Folder] = useState<string>("");
  const [turboLevel5Folder, setTurboLevel5Folder] = useState<string>("");
  const [turboLevel6Folder, setTurboLevel6Folder] = useState<string>("");
  const [turboLevel2FolderEdit, setTurboLevel2FolderEdit] =
    useState<string>("");
  const [textAddOrUpdateTurbo, setTextAddOrUpdateTurbo] =
    useState<string>("Add");

  //#endregion

  //#region Post work tab 8
  const [
    accountPostworkAccountCustomProcessId,
    setPostworkAccountCustomProcessId,
  ] = useState<number>(0); // NOSONAR
  const [postworkProcessStageId, setPostworkProcessStageId] =
    useState<number>(0);
  const [postworkfundFolderId, setPostworkfundFolderId] = useState<number>(0);
  const [postWorkCanFTPFolderUpload, setPostWorkCanFTPFolderUpload] =
    useState<boolean>(false);
  const [postWorkPdfType, setPostWorkPdfType] = useState<boolean>(false);
  const [postWorkExcelType, setPostWorkExceltype] = useState<boolean>(false); // NOSONAR
  const [postWorkWordDocType, setPostWorkWordDocType] =
    useState<boolean>(false);
  const [postWorkfileSize, setPostWorkfileSize] = useState<number>(0);
  const [postWorkEnableUIUpload, setPostWorkEnableUIUpload] =
    useState<boolean>(false);
  const [postWorkftpSourceLocationId, setPostWorkftpSourceLocationId] =
    useState<number>(0);
  const [postWorkLevel1Folder, setPostWorkLevel1Folder] =
    useState<string>("POST-WORK");
  const [postWorkLevel2Folder, setPostWorkLevel2Folder] = useState<string>("");
  const [postWorkLevel3Folder, setPostWorkLevel3Folder] = useState<string>("");
  const [postWorkLevel4Folder, setPostWorkLevel4Folder] = useState<string>("");
  const [postWorkLevel5Folder, setPostWorkLevel5Folder] = useState<string>("");
  const [postWorkLevel6Folder, setPostWorkLevel6Folder] = useState<string>("");
  const [postWorkLevel2FolderEdit, setPostWorkLevel2FolderEdit] =
    useState<string>("");
  const [textAddOrUpdatePostWork, setTextAddOrUpdatePostWork] =
    useState<string>("Add");
  // #endregion

  // #region Help Documents Tab 10
  const navigation = useNavigate();
  const [helpDocumentId, setHelpDocumentId] = useState<number>(0);
  const [helpDocRowData, setHelpDocRowData] = useState<any[]>([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [confirmDialogMessage, setConfirmDialogMessage] = useState<string>("");
  const [dialogBoxTitle, setDialogBoxTitle] = useState<string>("");
  const [helpDocName, setHelpDocName] = useState<string>("");
  const [validationHelpDocName, setValidationHelpDocName] = useState<
    string | null
  >("");
  const [helpDocDescription, setHelpDocDescription] = useState<string>("");
  const [validationHelpDocDescription, setValidationHelpDocDescription] =
    useState<string | null>("");
  const [, setHelpDocFile] = useState<any>(null); // NOSONAR
  const [turboDeleteFile, setTurboDeleteFile] = useState("");
  const [postWorkDeleteFile, setPostWorkDeleteFile] = useState("");
  // #endregion
  useEffect(() => {
    try {
      clearStateData();
      if (accountId !== undefined && accountId !== 0) {
        getAccountData();
      }
    } catch (error) {
      showSnackbar("Error in fetching data: " + error, true);
    } finally {
      console.log("Finished fetching account data for accountId:", accountId);
    }
  }, [accountId]);

  useEffect(() => {
    getClientData();
  }, []);

  useEffect(() => {
    if (metadataFields.length > 0) {
      setMetadataFields((prevFields) =>
        prevFields.map((metadataField: any) => {
          const allActive = metadataField.group.every(isGroupItemActive);
          return {
            ...metadataField,
            group: metadataField.group.map(cloneGroupItem),
            categorychecked: allActive,
          };
        }),
      );
    }
  }, [metadataFields]);

  // Helper functions moved outside to avoid deep nesting
  function isGroupItemActive(groupItem: any) {
    return groupItem.active === true;
  }

  function cloneGroupItem(groupItem: any) {
    return { ...groupItem };
  }

  const clearStateData = () => {
    setBasicAccountDetails([]);
    setPreworkAccountDetails([]);
    setDownstreamAccountDetails([]);
    setEdeliveryAccountDetails([]);
    setActiveDocIdExportAccountDetails([]);
    setArchivalReportAccountDetails([]);
    setTurboProofsAccountDetails([]);
    setPostWorkAccountDetails([]);
    setHelpDocRowData([]);
    setActiveFileLocations([]);
    setMetadataColumns([]);
    setCategories([]);
    setRowData([]);

    //#region Basic Information Tab 1
    setProcessStages([]);
    setProcessAllStage([]);
    setResponsedAccountId(0);
    getAccountLogo(0);
    setSelectedAccountDetails([]);
    setAccountName("");
    setCustomerCode("");
    setApiKeys("");
    setContactName("");
    setContactPhoneNumber("");
    setContactEmail("");
    setIsMenuExpand(false);
    setIsDashboardCountShow(false);
    setIsFolderAccessRightsShow(false);
    setIsPasswordNotificationShow(false);
    setIsUserPreferencesShow(false);
    setPasswordNotificationDays("");
    setUserExpiryNoticationDays("");
    setDashboardInterval("");
    setAvailableFolderData([]);
    setEnabledFolderData([]);
    setIsLevelOneCheck(false);
    //#endregion

    //#region Prework Tab 2
    setResponsedAccountDownStreamId(0);
    setResponsedAccountPreworkId(0);
    setIsSecondrayPreFlightEnable(false);
    setIsFtpFolderEnable(false);
    setIsPdfEnable(false);
    setIsExcelEnable(false);
    setIsWordEnable(false);
    setFileSize(0);
    setIsOtherFileFormat(false);
    setOtherFileType("");
    setEnableUIUpload(false);
    setFtpSourceFTPLocationId(0);
    setLocalShareFTPLocationId(0);
    setSecondaryPreflightFTPLocationId(0);
    setFromPreflightFTPLocationId(0);
    setFinalFolderFTPLocationId(0);
    setIsTriggerProofWorkFlowEnabled(false);
    setIsTriggerProdWorkFlowEnabled(false);
    setTriggerProofExport1LocationId(0);
    setTriggerProofExport2LocationId(0);
    setProofExp1CanprefixjobCode(false);
    setProofExp2CanprefixjobCode(false);
    setTriggerProofExport3LocationId(0);
    setTriggerProofExport3Naming("");
    setTriggerProofExport3MetaDataDefinitionId(0);
    setTriggerProofExport4LocationId(0);
    setTriggerProofExport4Naming("");
    setTriggerProofExport4MetaDataDefinitionId(0);
    setTriggerProofExport3ReturnLocationId(0);
    setTriggerProofExport3ReturnArchivalLocationId(0);
    setTriggerProofExport4ReturnLocationId(0);
    setTriggerProdExport1LocationId(0);
    setProdExp1CanprefixjobCode(false);
    setTriggerProdExport2LocationId(0);
    setProdExp2CanprefixjobCode(false);
    setTriggerProdExport3LocationId(0);
    setTriggerProdExport3Naming("");
    setTriggerProdExport3MetaDataDefinitionId(0);
    setTriggerProdExport4LocationId(0);
    setToPreFlightFileNameConvention("");
    setFromPreFlightFileNameConvention("");
    setPreworkEmailRequired(false);
    setIsAllowReprocess(false);
    setPrintReadyEmailRequired(false);
    setPrimaryPreflightReturnEmailRequired(false);
    setExportToFinalEmailRequired(false);
    setPreworkWarningEmailRequired(false);
    setPreworkExpirationEmailRequired(false);
    setDocumentRenameEmailRequired(false);
    setDocumentRejectEmailRequired(false);
    setDocumentDeleteEmailRequired(false);
    setTriggerProofExport1EmailRequired(false);
    setTriggerProofExport2EmailRequired(false);
    setTriggerProofExport3EmailRequired(false);
    setTriggerProofExport4EmailRequired(false);
    setTriggerProofExport3ReturnEmailRequired(false);
    setTriggerProofExport4ReturnEmailRequired(false);
    setTriggerProdExport1EmailRequired(false);
    setTriggerProdExport2EmailRequired(false);
    setTriggerProdExport3EmailRequired(false);
    setTriggerProdExport4EmailRequired(false);
    setIsZipEnable(false);
    setValidationZipFile("");
    setPreworkRowData([]);
    //#endregion

    //#region Downstream Summary Tab 3
    setValidationExportFolderlevel2("");
    setExportFolderlevel2("");
    setIsPDFExportLocation3DownstreamShow(false);
    setIsNewProcessPDFExportLocation3DownstreamShow(false);
    setMetaddataSourceDefinitions([]);
    setIsDAOEnabled(false);
    setIsDSAEnabled(false);
    setIsNoSubProcessEnabled(false);
    setIsNewProcessEnabled(true);
    setIsPdfSplitEnabled(false);
    setIsBulkUploadEnabled(false);
    setNewProcessExportFTPLocationId(0);
    setNewProcessExportNamingConvention("");
    setPdfSourceFTPLocationId(0);
    setPdfArchiveFTPLocationId(0);
    setMetadataSourceFTPLocationId(0);
    setMetadataArchiveFTPLocationId(0);
    setSourceIngestionMetadtaDefinitionID(0);
    setHasHeader(false);
    setDaoExportNamingConvention("");
    setToSecondaryFTPLocationId(0);
    setFromSecondaryFTPLocationId(0);
    setFromSecondaryArchiveFTPLocationId(0);
    setExportFilenameWithoutUnderscore(false);
    setDaoReturnMetadataDefinitionID(0);
    setToDownSampleFTPLocationId(0);
    setFromDownSamplingFTPLocationId(0);
    setFromDownSamplingArchiveFTPLocationId(0);
    setDsaReturnMetadataDefinitionID(0);
    setWebReadyFtpLocationId(0);
    setWebReadyArchiveFtpLocationId(0);
    setExportFtpLocationId(0);
    setIsDSAllowReprocess(false);
    setDisplayRuleMappingId(0);
    setRecentRecordDays(0);
    setIndexFileProcessedMailRequired(false);
    setExportSecondaryPreFlightMailRequired(false);
    setSecondaryPreFlightReturnMailRequired(false);
    setSecondaryPreFlightWarningMailRequired(false);
    setSecondaryPreflightFailureRequired(false);
    setExportDownSampleMailRequired(false);
    setDownStreamReturnMailRequired(false);
    setDownsampleWarningMailRequired(false);
    setDownsampleFailureMailRequired(false);
    setMetadataRejectedReasonsMailRequired(false);
    setDownStreamExportRules([]);

    //#endregion

    //#region e-Delivery Tab 4
    setAccountEdeliveryId(0);
    setEDeliveryFtpLocationId(0);
    setFundFolderType(0);
    setSecondaryeDeliveryFTPLocationId(0);
    setSecondaryFundFolderType(0);
    setPrintReadyEdeliveryReturnFTPLocationId(0);
    setWebReadyEdeliveryReturnFTPLocationId(0);
    setPrintReadyEdeliveryReturnArchiveFTPLocationId(0);
    setWebReadyEdeliveryReturnArchiveFTPLocationId(0);
    setEdeliveryReturnPrintReadyMetadataDefinitionID(0);
    setEdeliveryReturnWebreadyMetadatadefinitionID(0);
    setEdeliveryReturn(false);
    setSecondaryEmailexportRequired(false);
    setExportEmailRequired(false);
    setSecondaryFileNameConvention("");
    setEdeliveryFileNameConvention("");
    setFrequencyHrs(0);
    setFrequencyMins(0);

    //#endregion

    //#region Active DocID export Tab 5
    setSearchCriterias([]);
    setSearchCriteriaID(0);
    setFieldValue("");
    setAccountActiveDocExportId(0);
    setExportDocFTPLocationId(0);
    setExportDocFTPLocationId2(0);
    setExportDocFTPLocationId3(0);
    setExportEmailRequiredActiveDocId(false);
    setExportFileNameConvention("");
    setExportFrequencyHour(0);
    setExportFrequencyMin(0);

    //#endregion

    //#region Archival Report Tab 6
    setArchivalFolderConfigId(0);
    setArchivalLocationId(0);
    setArchivalFileNameConvention("");
    setArchivalEmailRequired(false);
    setArchivalReqApprovalEmailRequired(false);
    setExportFolderData([]);
    setArchivalWebReadyLevel2("");
    setArchivalPrintReadyLevel2("");
    setArchivalExport1FolderId(0);
    setArchivalExport2FolderId(0);

    //#endregion

    //#region Turbo Proofs Tab 7
    setAccountCustomProcessId(0);
    setProcessStageId(0);
    setFundFolderId(0);
    setTurboCanFTPFolderUpload(false);
    setTurboPdfType(false);
    setTurboExcelType(false);
    setTurboWordDocType(false);
    setTurbofileSize(0);
    setTurboEnableUIUpload(false);
    setTurboftpSourceLocationId(0);
    setRowDataTurbo([]);
    setTurboLevel1Folder("TURBO PROOFS");
    setTurboLevel2Folder("");
    setTurboLevel3Folder("");
    setTurboLevel4Folder("");
    setTurboLevel5Folder("");
    setTurboLevel6Folder("");
    setTurboLevel2FolderEdit("");
    setTextAddOrUpdateTurbo("Add");
    //#endregion

    //#region Post work tab 8
    setPostworkAccountCustomProcessId(0);
    setPostworkProcessStageId(0);
    setPostworkfundFolderId(0);
    setPostWorkCanFTPFolderUpload(false);
    setPostWorkPdfType(false);
    setPostWorkExceltype(false);
    setPostWorkWordDocType(false);
    setPostWorkfileSize(0);
    setPostWorkEnableUIUpload(false);
    setPostWorkftpSourceLocationId(0);
    setRowDataPostWork([]);
    setPostWorkLevel1Folder("POST-WORK");
    setPostWorkLevel2Folder("");
    setPostWorkLevel3Folder("");
    setPostWorkLevel4Folder("");
    setPostWorkLevel5Folder("");
    setPostWorkLevel6Folder("");
    setPostWorkLevel2FolderEdit("");
    setTextAddOrUpdatePostWork("Add");

    //#endregion

    //#region Metadata Configuration Tab 9
    setMetadataFields([]);
    setMetadataColumns([]);

    //#endregion

    //#region Help Documents Tab 10
    setHelpDocumentId(0);
    setHelpDocRowData([]);
    setHelpDocName("");
    setValidationHelpDocName("");
    setHelpDocDescription("");
    setValidationHelpDocDescription("");
    setHelpDocFile(null);
    //#endregion
  };

  const updateStepsBasedOnAccount = (stages: any) => {
    const updatedSteps = steps.map((step) => {
      if (
        stages.some(
          (stage: any) =>
            stage.stageName.toLowerCase() === step.key.toLowerCase(),
        )
      ) {
        return { ...step, isDone: true };
      }
      return step;
    });
    setSteps(updatedSteps);
    const basicInformationIndex = steps.findIndex(
      (x) => x.key === "Basic Information",
    );
    setActiveStepNew(basicInformationIndex);
  };

  const handleNextSubmitNew = () => {
    const currentStepLabel = filteredSteps[activeStepNew]?.label;
    if (currentStepLabel === "Basic Information") {
      if (accountId === 0 && (clientId === undefined || clientId === 0)) {
        setValidationClientId("Please select Account Name");
      } else if (customerCode === undefined || customerCode === "") {
        setValidationCustomerCode("Please enter the Customer Code");
      } else if (apiKeys === undefined || apiKeys === "") {
        setValidationApiKeys("Please enter the API Key");
      } else if (contactName === undefined || contactName === "") {
        setValidationContactName("Please enter the Contact Name");
      } else if (
        contactPhoneNumber === undefined ||
        contactPhoneNumber === ""
      ) {
        setValidationContactPhoneNumber(
          "Please enter the Contact Phone Number",
        );
      } else if (contactEmail === undefined || contactEmail === "") {
        setValidationContactEmail("Please enter the Email");
      } else {
        setActiveStepNew((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (currentStepLabel === "eDelivery") {
      getMetadataFields();
      setActiveStepNew((prevActiveStep) => prevActiveStep + 1);
    } else {
      setActiveStepNew((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStepNew((prevActiveStep) => prevActiveStep - 1);
  };

  const filteredSteps = steps.filter(
    (step) =>
      step.key === "Basic Information" ||
      processStages.some(
        (stage) => stage.stageName.toLowerCase() === step.key.toLowerCase(),
      ) ||
      step.key === "Metadata Configuration" ||
      step.key === "Help Documents",
  );

  const getStageChecked = (stageName: string): boolean => {
    switch (stageName) {
      case "Prework":
        return processStages.some((stage) => stage.stageName === stageName);
      case "Downstream":
        return processStages.some((stage) => stage.stageName === stageName);
      case "eDelivery":
        return processStages.some((stage) => stage.stageName === stageName);
      case "Active DocID export":
        return processStages.some((stage) => stage.stageName === stageName);
      case "Archival Report":
        return processStages.some((stage) => stage.stageName === stageName);
      case "TURBO PROOFS":
        return processStages.some((stage) => stage.stageName === stageName);
      case "POST-WORK":
        return processStages.some((stage) => stage.stageName === stageName);
      default:
        return false;
    }
  };
  const handleStageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    stageName: string,
  ) => {
    const isChecked = event.target.checked;
    switch (stageName) {
      case "Prework":
        setIsPrework(isChecked);
        break;
      case "Downstream":
        setIsDownstream(isChecked);
        break;
      case "eDelivery":
        setIsEDelivery(isChecked);
        break;
      case "Active DocID export":
        setIsActiveDocIdExport(isChecked);
        break;
      case "Archival Report":
        setIsArchivalReport(isChecked);
        break;
      case "TURBO PROOFS":
        setIsTurboProofs(isChecked);
        break;
      case "POST-WORK":
        setIsPostWork(isChecked);
        break;
      default:
        break;
    }

    // Update steps based on checked stages
    const updatedSteps = steps.map((step) => {
      if (step.key === stageName) {
        return { ...step, isDone: isChecked };
      }
      return step;
    });
    setSteps(updatedSteps);
  };

  //#region Drag and drop

  // Handle drag end
  const handleDragEnd = (result: any) => {
    const { source, destination } = result;

    // If no destination, do nothing
    if (!destination) return;

    // If dropped in the same list, reorder the list
    if (source.droppableId === destination.droppableId) {
      const items =
        source.droppableId === "available"
          ? Array.from(availableFolderData)
          : Array.from(enabledFolderData);

      const [movedItem] = items.splice(source.index, 1);
      items.splice(destination.index, 0, movedItem);

      if (source.droppableId === "available") {
        setAvailableFolderData(items);
      } else {
        setEnabledFolderData(items);
      }
    } else {
      // Moving between lists
      const sourceItems =
        source.droppableId === "available"
          ? Array.from(availableFolderData)
          : Array.from(enabledFolderData);
      const destinationItems =
        destination.droppableId === "available"
          ? Array.from(availableFolderData)
          : Array.from(enabledFolderData);

      const [movedItem] = sourceItems.splice(source.index, 1);
      destinationItems.splice(destination.index, 0, movedItem);

      if (source.droppableId === "available") {
        setAvailableFolderData(sourceItems);
        setEnabledFolderData(destinationItems);
      } else {
        setAvailableFolderData(destinationItems);
        setEnabledFolderData(sourceItems);
      }
    }
  };

  //#endregion

  const renderStepContent = (stepKey: string) => {
    switch (stepKey) {
      case "Basic Information":
        return (
          <div>
            {" "}
            <Form>
              <h4
                className="form-heading"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                BASIC INFORMATION
              </h4>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Col md={3}>
                  <Form.Group controlId="formCustomer">
                    <Form.Label className="input-labels">
                      Enter the Customer Name{" "}
                      <span
                        style={{ color: "var(--aggrid-text-color)" }}
                        className="required"
                      >
                        *
                      </span>
                    </Form.Label>
                    {accountId === 0 && (
                      <Form.Select
                        name="client"
                        value={clientId}
                        onChange={handleAccountNameChange}
                        style={{ fontSize: "11px" }}
                      >
                        <option value="0">Select</option>
                        {clientName.map((client: any) => (
                          <option
                            key={client.businessUnitId}
                            value={client.businessUnitId}
                          >
                            {client.businessUnitName}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                    {accountId !== 0 && (
                      <Tooltip title="Enter the Customer Name" arrow>
                        <Form.Control
                          type="text"
                          value={accountName}
                          placeholder="Enter the Customer Name"
                          onChange={handleCustmerNameChange}
                          style={{ fontSize: "11px" }}
                        />
                      </Tooltip>
                    )}
                    {accountId === 0 && validationClientId && (
                      <Form.Text style={{ color: "red" }}>
                        {validationClientId}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="customerCode">
                    <Form.Label className="input-labels">
                      Enter the Customer Code{" "}
                      <span
                        className="required"
                        style={{ color: "var(--aggrid-text-color)" }}
                      >
                        *
                      </span>
                    </Form.Label>
                    <Tooltip title="Enter the Customer Code" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the Customer Code"
                        onChange={handleCustomerCodeChange}
                        value={customerCode}
                        required
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationCustomerCode && (
                      <Form.Text style={{ color: "red" }}>
                        {validationCustomerCode}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group controlId="logo">
                    <Form.Label className="input-labels">
                      Logo{" "}
                      <span
                        className="required"
                        style={{ color: "var(--aggrid-text-color)" }}
                      >
                        *
                      </span>
                    </Form.Label>
                    <br />
                    <div
                      style={{
                        border: "1px dashed #afaaaa",
                        width: "100%",
                        height: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 10px",
                      }}
                    >
                      <img
                        src={`${logoBase64}`}
                        className="img img-responsive"
                        style={{
                          width: "95%",
                          height: "65px",
                          border: "1px dashed #afaaaa",
                          background: "white",
                          borderRadius: "5px",
                        }}
                        alt="customer logo"
                      />

                      <input
                        type="file"
                        multiple
                        onChange={handelUploadIcon}
                        style={{
                          display: "none",
                        }}
                        id="file-upload-input"
                      />

                      <label
                        htmlFor="file-upload-input"
                        style={{ cursor: "pointer", marginLeft: "1.875em" }}
                      >
                        <Tooltip
                          title="Click to Upload the customer logo"
                          arrow
                        >
                          <UploadIcon />
                        </Tooltip>
                      </label>
                    </div>
                    <small
                      className="recom-msg"
                      title="{{'Info' | i18n : 'Info'}}"
                    >
                      <br />
                      <i className="fa fa-info-circle" aria-hidden="true"></i> :
                      225 x 45 px in *.png
                    </small>
                  </Form.Group>
                </Col>
                <Col md={3} style={{ marginLeft: "50px" }}>
                  <Form.Group controlId="apiKey">
                    <Form.Label className="input-labels">
                      API Key{" "}
                      <span
                        style={{ color: "var(--aggrid-text-color)" }}
                        className="required"
                      >
                        *
                      </span>
                    </Form.Label>
                    <Tooltip title="Enter the API key" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the API Key"
                        value={apiKeys}
                        onChange={handleApiKeyChange}
                        required
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationApiKeys && (
                      <Form.Text style={{ color: "red" }}>
                        {validationApiKeys}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkDownloadByDefault"
                    label="Download By Default"
                    checked={isDownloadByDefault}
                    onChange={handleDownloadByDefaultChange}
                  />
                </Col>
              </Row>
              <h4
                className="form-heading"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                Contact Information
              </h4>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Col md={3}>
                  <Form.Group controlId="formName">
                    <Form.Label className="input-labels">
                      Name{" "}
                      <span
                        className="required"
                        style={{ color: "var(--aggrid-text-color)" }}
                      >
                        *
                      </span>
                    </Form.Label>
                    <Tooltip title="Enter the Name" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the Name"
                        value={contactName}
                        onChange={handleContactNameChange}
                        required
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationContactName && (
                      <Form.Text style={{ color: "red" }}>
                        {validationContactName}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="formPhoneNumber">
                    <Form.Label className="input-labels">
                      Phone Number{" "}
                      <span
                        className="required"
                        style={{ color: "var(--aggrid-text-color)" }}
                      >
                        *
                      </span>
                    </Form.Label>
                    <Tooltip title="Enter the Phone Number" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the Phone Number"
                        value={contactPhoneNumber}
                        onChange={handleContactPhoneChange}
                        required
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationContactPhoneNumber && (
                      <Form.Text style={{ color: "red" }}>
                        {validationContactPhoneNumber}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="formEmail">
                    <Form.Label className="input-labels">
                      Email{" "}
                      <span
                        className="required"
                        style={{ color: "var(--aggrid-text-color)" }}
                      >
                        *
                      </span>
                    </Form.Label>
                    <Tooltip title="Enter the Email" arrow>
                      <Form.Control
                        type="email"
                        placeholder="Enter the Email"
                        value={contactEmail}
                        onChange={handleContactEmailChange}
                        required
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationContactEmail && (
                      <Form.Text style={{ color: "red" }}>
                        {validationContactEmail}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Tooltip title="Click to Add Contact" arrow>
                    <AddBoxIcon
                      style={{
                        marginTop: "30px",
                        marginLeft: "10px",
                        color: "var(--aggrid-text-color)",
                      }}
                      onClick={handleAddRow}
                    />
                  </Tooltip>
                </Col>
              </Row>
              {rows.map((row, index) => (
                <>
                  {index > 0 && (
                    <Row
                      className="mb-3"
                      style={{
                        color: "var(--aggrid-text-color)",
                        fontSize: "11px",
                      }}
                    >
                      <Col md={3}>
                        <Form.Group controlId="formName">
                          <Form.Label className="input-labels">
                            Name{" "}
                            <span
                              className="required"
                              style={{
                                color: "var(--aggrid-text-color)",
                              }}
                            >
                              *
                            </span>
                          </Form.Label>
                          <Tooltip title="Enter the Name" arrow>
                            <Form.Control
                              type="text"
                              placeholder="Enter the Name"
                              value={row.name}
                              onChange={(e) =>
                                handleDynamicContactNameChange(index, e)
                              }
                              required
                              style={{ fontSize: "11px" }}
                            />
                          </Tooltip>
                          {validationDynamicContactName && (
                            <Form.Text style={{ color: "red" }}>
                              {validationDynamicContactName}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group controlId="formPhoneNumber">
                          <Form.Label className="input-labels">
                            Phone Number{" "}
                            <span
                              className="required"
                              style={{
                                color: "var(--aggrid-text-color)",
                              }}
                            >
                              *
                            </span>
                          </Form.Label>
                          <Tooltip title="Enter the Phone Number" arrow>
                            <Form.Control
                              type="text"
                              placeholder="Enter the Phone Number"
                              value={row.phoneNumber}
                              onChange={(e) =>
                                handleDynamicContactPhoneChange(index, e)
                              }
                              required
                              style={{ fontSize: "11px" }}
                            />
                          </Tooltip>
                          {validationDynamicContactPhoneNumber && (
                            <Form.Text style={{ color: "red" }}>
                              {validationDynamicContactPhoneNumber}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group controlId="formEmail">
                          <Form.Label className="input-labels">
                            Email{" "}
                            <span
                              className="required"
                              style={{
                                color: "var(--aggrid-text-color)",
                              }}
                            >
                              *
                            </span>
                          </Form.Label>
                          <Tooltip title="Enter the Email" arrow>
                            <Form.Control
                              type="email"
                              placeholder="Enter the Email"
                              value={row.email}
                              onChange={(e) =>
                                handleDynamicContactEmailChange(index, e)
                              }
                              required
                              style={{ fontSize: "11px" }}
                            />
                          </Tooltip>
                          {validationDynamicContactEmail && (
                            <Form.Text style={{ color: "red" }}>
                              {validationDynamicContactEmail}
                            </Form.Text>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        {index === rows.length - 1 && (
                          <Tooltip title="Click to Add Contact" arrow>
                            <AddBoxIcon
                              style={{
                                marginTop: "30px",
                                marginLeft: "10px",
                                color: "var(--aggrid-text-color)",
                              }}
                              onClick={handleAddRow}
                            />
                          </Tooltip>
                        )}
                        {index > 0 && (
                          <Tooltip title="Click to Remove Contact" arrow>
                            <DeleteForeverIcon
                              style={{
                                marginLeft: "10px",
                                marginTop: "30px",
                                color: "var(--button-color)",
                              }}
                              onClick={() => handleRemoveRow(index)}
                            ></DeleteForeverIcon>
                          </Tooltip>
                        )}
                      </Col>
                    </Row>
                  )}
                </>
              ))}
              <h4
                className="form-heading"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                PREDEFINED PROCESS STAGES
              </h4>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Form.Label className="input-labels">
                  Select Checkbox to enable stages
                </Form.Label>
              </Row>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                  display: "flex",
                }}
              >
                {processAllStage?.map((stage) => (
                  <Col md={3} key={stage.stageName}>
                    <Form.Check
                      type="checkbox"
                      id={`chk${stage.stageName.replace(/\s+/g, "")}`}
                      label={stage.stageName}
                      checked={getStageChecked(stage.stageName)}
                      onChange={(e) => handleStageChange(e, stage.stageName)}
                    />
                  </Col>
                ))}
              </Row>
              <h4
                className="form-heading"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                Configure Browse Folder Structure *
              </h4>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                <Form.Label className="input-labels">
                  Drag and Drop item to enable/disable
                </Form.Label>
              </Row>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Row
                  className="mb-3"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  <Col md={3}>
                    <Form.Label className="input-labels">Available</Form.Label>
                    <Droppable droppableId="available">
                      {(provided: any) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{
                            height: "300px",
                            overflow: "auto",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "8px",
                          }}
                        >
                          {availableFolderData.map((folder, index) => (
                            <Draggable
                              key={folder.fundFolderId}
                              draggableId={folder.fundFolderId.toString()}
                              index={index}
                            >
                              {(provided: any) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{
                                    ...provided.draggableProps.style,
                                    padding: "8px",
                                    marginBottom: "4px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    cursor: "grab",
                                  }}
                                >
                                  {index + 1} . {folder.folderName}
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </Col>
                  <Col md={1} style={{ width: "10px" }}>
                    <Tooltip title="Please click to reset" arrow>
                      <SyncIcon
                        style={{
                          marginTop: "160px",
                          marginLeft: ".5em",
                          color: "var(--aggrid-text-color)",
                        }}
                        onClick={handleResetFundFolder}
                      />
                    </Tooltip>
                  </Col>
                  <Col md={3} style={{ marginLeft: "2em" }}>
                    <Form.Label
                      className="input-labels"
                      style={{ marginLeft: "2em" }}
                    >
                      Enabled
                    </Form.Label>
                    <Droppable droppableId="enabled">
                      {(provided: any) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={{
                            height: "300px",
                            overflow: "auto",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "8px",
                            marginLeft: "2em",
                          }}
                        >
                          {enabledFolderData.map((folder, index) => (
                            <Draggable
                              key={folder.fundFolderId}
                              draggableId={folder.fundFolderId.toString()}
                              index={index}
                            >
                              {(provided: any) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={{
                                    ...provided.draggableProps.style,
                                    padding: "8px",
                                    marginBottom: "4px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    cursor: "grab",
                                  }}
                                >
                                  {index + 1} . {folder.folderName}
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </Col>
                  <Col md={3} style={{ marginLeft: "1.5em" }}>
                    <Form.Label className="input-labels">
                      Enable Level One Folder
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="chkLevelOneCheck"
                      label="Level one Check"
                      checked={isLevelOneCheck}
                      onChange={handleLevelOneCheckChange}
                    />
                  </Col>
                </Row>
              </DragDropContext>
              <h4
                className="form-heading"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                Navigation Menu option
              </h4>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                <Form.Label className="input-labels">
                  Navigation Menu - Auto Expand
                </Form.Label>
              </Row>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkMenuExpand"
                    checked={isMenuExpand}
                    label="Navigation main menu expand option"
                    onChange={handleMenuExpandChange}
                  />
                </Col>
              </Row>
              <h4
                className="form-heading"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                Metrics
              </h4>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkShowDashboardCount"
                    label="Show Dashboard Count"
                    checked={isDashboardCountShow}
                    onChange={handleDashboardCountChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkShowFolderAccessRights"
                    label="Show Folder Access Rights"
                    checked={isFolderAccessRightsShow}
                    onChange={handleFolderAccessRightsChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkPasswordNotification"
                    label="Password Notification"
                    checked={isPasswordNotificationShow}
                    onChange={handlePasswordNotificationChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkShowUserPreferences"
                    label="Show User Preferences"
                    checked={isUserPreferencesShow}
                    onChange={handleUserPreferencesChange}
                  />
                </Col>
              </Row>
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Col md={3}>
                  <Form.Group controlId="FormPasswordNotificationDays">
                    <Form.Label className="input-labels">
                      User Password Notification(in days)
                    </Form.Label>
                    <Tooltip title="Enter the Password Notification Days" arrow>
                      <Form.Control
                        type="text"
                        id="txtPasswordNotificationDays"
                        placeholder="Enter the Password Notification Days"
                        value={passwordNotificationDays}
                        onChange={handlePasswordNotificationDaysChange}
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationPasswordNotificationDays && (
                      <Form.Text style={{ color: "red" }}>
                        {validationPasswordNotificationDays}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group controlId="FormUserExpireNotificationDays">
                    <Form.Label className="input-labels">
                      User Expire Notification(in days)
                    </Form.Label>
                    <Tooltip
                      title="Enter the User Expire Notification Days"
                      arrow
                    >
                      <Form.Control
                        type="text"
                        id="txtUserExpireNotificationDays"
                        placeholder="Enter the User Expire Notification Days"
                        value={userExpiryNoticationDays}
                        onChange={handleUserExpirydNotificationDaysChange}
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationUserExpireNotificationDays && (
                      <Form.Text style={{ color: "red" }}>
                        {validationUserExpireNotificationDays}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="FormDashboardInterval">
                    <Form.Label className="input-labels">
                      Dashboard Interval(in sec)
                    </Form.Label>
                    <Tooltip title="Enter the Dashboard Interval" arrow>
                      <Form.Control
                        type="text"
                        id="txtDashboardInterval"
                        placeholder="Enter the Dashboard Interval"
                        value={dashboardInterval}
                        onChange={handleDashboardIntervalChange}
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationDashboardInterval && (
                      <Form.Text style={{ color: "red" }}>
                        {validationDashboardInterval}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </div>
        );
      case "Prework":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              PreWork : Sub-Process Configuration
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Group controlId="formCustomer">
                  <Form.Label className="input-labels">
                    Select checkbox to enable stage
                  </Form.Label>
                  <Form.Check
                    type="checkbox"
                    id="chkPreworkPreflight"
                    label="Prework Preflight"
                    checked={isSecondrayPreFlightEnable}
                    onChange={handlePreworkPreflightChange}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Group controlId="formCustomer">
                  <Form.Label className="input-labels">
                    DOCID INPUT FORMAT{" "}
                    <span
                      className="required"
                      style={{ color: "var(--aggrid-text-color)" }}
                    >
                      *
                    </span>
                  </Form.Label>
                  <Tooltip title="Select your DocID Input Format" arrow>
                    <Form.Select
                      id="docIdFormat"
                      value={docIdFormat}
                      onChange={handleDolcIdChange}
                      style={{ fontSize: "11px" }}
                    >
                      <option value="1">DocID Format1</option>
                      <option value="2">DocID Format2</option>
                    </Form.Select>
                  </Tooltip>
                </Form.Group>
              </Col>
              <Col md={1} style={{ marginTop: "2.5em", marginLeft: "-1em" }}>
                <Tooltip
                  title="<<File name = DocID_Description.pdf
         Format 1: DocID = DocID (Before the first underscore)
         Format 2: DocID = DocID_Description (Complete file name minus the extension of the file)>>"
                  arrow
                >
                  <PermDeviceInformationRoundedIcon
                    style={{
                      color: "var(--aggrid-text-color)",
                      alignItems: "center",
                    }}
                  />
                </Tooltip>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Upload Settings
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Upload Settings
                </Form.Label>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">File formats:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  File size allowed :
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkFTPFolderUpload"
                  type="checkbox"
                  label="FTP Folder Upload"
                  checked={isFtpFolderEnable}
                  onChange={handleFtpFolderUploadChange}
                />
              </Col>
              <Col md={3}>
                <Form.Group
                  controlId="formFileTypes"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Check
                    id="chkPDF"
                    type="checkbox"
                    label="PDF"
                    checked={isPdfEnable}
                    style={{ marginRight: "10px" }}
                    onChange={handlePdfChange}
                  />
                  <Form.Check
                    id="chkExcel"
                    type="checkbox"
                    label="Excel"
                    checked={isExcelEnable}
                    style={{ marginRight: "10px" }}
                    onChange={handleExcelChange}
                  />
                  <Form.Check
                    id="chkWordDoc"
                    type="checkbox"
                    label="Word Doc"
                    checked={isWordEnable}
                    onChange={handleWordDocChange}
                  />
                </Form.Group>
              </Col>
              <Col md={3} style={{ display: "contents" }}>
                <Form.Control
                  type="text"
                  placeholder="File Size"
                  value={fileSize}
                  style={{
                    width: "90px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "11px",
                  }}
                  onChange={handleFileSizeChange}
                />
                <span
                  style={{
                    color: "var(--aggrid-text-color)",
                    display: "flex",
                    marginLeft: "1em",
                    alignItems: "anchor-center",
                  }}
                >
                  MB
                </span>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkUIUpload"
                  type="checkbox"
                  label="UI Upload"
                  checked={enableUIUpload}
                  onChange={handleUIUploadChange}
                />
              </Col>
              <Col
                md={3}
                style={{
                  width: "20vh",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Form.Check
                  id="chkZip"
                  type="checkbox"
                  checked={otherFileType !== "" ? true : isZipEnable}
                  onChange={handleZipChange}
                />
                <Form.Group controlId="formZip">
                  <Form.Control
                    type="text"
                    placeholder="Others"
                    value={otherFileType}
                    disabled={!isZipEnable}
                    style={{ marginLeft: "1em", fontSize: "11px" }}
                    onChange={handleOtherFileTypeChange}
                  />
                  {validationZipFile && (
                    <Form.Text style={{ color: "red" }}>
                      {validationZipFile}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Folder Configuration
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>Select path to share folders</Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">FTP Source</Form.Label>
                <Form.Select
                  id="ftpSource"
                  value={ftpSourceFTPLocationId}
                  onChange={handleFtpSourceChange}
                  style={{ fontSize: "11px" }}
                >
                  <option value="0">Select</option>
                  {activeFileLocations.map((activeFileLocation: any) => (
                    <option
                      key={activeFileLocation.ftpFolderId}
                      value={activeFileLocation.ftpFolderId}
                    >
                      {activeFileLocation.folderName}
                    </option>
                  ))}
                </Form.Select>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">Local Share</Form.Label>
                <Tooltip title="Select the Local Share" arrow>
                  <Form.Select
                    id="localShare"
                    value={localShareFTPLocationId}
                    onChange={handleLocalShareChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  To Primary Preflight
                </Form.Label>
                <Tooltip title="Select the To Primary Preflight Location" arrow>
                  <Form.Select
                    id="ToPrimaryPreflight"
                    value={secondaryPreflightFTPLocationId}
                    onChange={handleToPrimaryPreflightChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  From Primary Preflight
                </Form.Label>
                <Tooltip
                  title="Select the From Primary Preflight Location"
                  arrow
                >
                  <Form.Select
                    id="FromPrimaryPreflight"
                    value={fromPreflightFTPLocationId}
                    onChange={handleFromPrimaryPreflightChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">Final Folder</Form.Label>
                <Tooltip title="Select the Final Folder Location" arrow>
                  <Form.Select
                    id="FinalFolder"
                    value={finalFolderFTPLocationId}
                    onChange={handleFinalFolderChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="TriggerProofFlow"
                  type="checkbox"
                  label="TRIGGER PROOF FLOW"
                  checked={isTriggerProofWorkFlowEnabled}
                  onChange={handleTriggerProofWorkFlowEnabledChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location 1 - (With Underscore)
                </Form.Label>
                <Tooltip title="Select the Export Location 1" arrow>
                  <Form.Select
                    id="ExportLocation1"
                    value={triggerProofExport1LocationId}
                    onChange={handleExportLocation1Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location 2 - (No Underscore)
                </Form.Label>
                <Tooltip title="Select the Export Location 2" arrow>
                  <Form.Select
                    id="ExportLocation2"
                    value={triggerProofExport2LocationId}
                    onChange={handleExportLocation2Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkExportPrefix1"
                  type="checkbox"
                  label="Export 1 Can Prefix Job Code"
                  checked={proofExp1CanprefixjobCode}
                  onChange={handleExport1CanPrefixJobCodeChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkExportPrefix2"
                  type="checkbox"
                  label="Export 2 Can Prefix Job Code"
                  checked={proofExp2CanprefixjobCode}
                  onChange={handleExport2CanPrefixJobCodeChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location 3
                </Form.Label>
                <Tooltip title="Select the Export Location 3" arrow>
                  <Form.Select
                    id="ExportLocation2"
                    value={triggerProofExport3LocationId}
                    onChange={handleExportLocation3Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              {isExportLocation3and4Show && (
                <>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location 3 Naming
                    </Form.Label>
                    <Tooltip title="Enter the file name" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the file name"
                        value={triggerProofExport3Naming}
                        onChange={handleExportLocation3NamingChange}
                      />
                    </Tooltip>
                  </Col>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location 3 Metadata Definition
                    </Form.Label>
                    <Tooltip
                      title="Select the Export Location 3 Metadata Definition"
                      arrow
                    >
                      <Form.Select
                        id="ExportLocation2"
                        value={triggerProofExport3MetaDataDefinitionId}
                        onChange={handleExportLocation3MetaDataDefinitionChange}
                        style={{ fontSize: "11px" }}
                      >
                        <option value="0">Select</option>
                        {metadataColumns.map((metadataColumn: any) => (
                          <option
                            key={metadataColumn.metadataDefinitionId}
                            value={metadataColumn.metadataDefinitionId}
                          >
                            {metadataColumn.metadataDefinitionName}
                          </option>
                        ))}
                      </Form.Select>
                    </Tooltip>
                  </Col>
                </>
              )}
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Group
                  controlId="formFileTypes"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Tooltip title="PDF Export to ADO" arrow>
                    <Form.Check
                      id="chkPDFTriggerProofFlow"
                      type="radio"
                      label="PDF"
                      radioGroup="PDFTriggerProofFlow"
                      style={{ marginRight: "10px" }}
                      checked={isExportLocation3and4Show === false}
                      onChange={handlePDFExportLocation3Hide}
                      value="0"
                    />
                  </Tooltip>
                  <Tooltip title="PDF + Metadata Export to ADO" arrow>
                    <Form.Check
                      id="chkPDFMetadataTriggerProofFlow"
                      type="radio"
                      label="PDF + Metadata"
                      radioGroup="PDFTriggerProofFlow"
                      style={{ marginRight: "10px" }}
                      checked={isExportLocation3and4Show === true}
                      onChange={handleExportLocation3Show}
                      value="1"
                    />
                  </Tooltip>
                </Form.Group>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location 4
                </Form.Label>
                <Tooltip title="Select the Export Location 4" arrow>
                  <Form.Select
                    id="ExportLocation4"
                    value={triggerProofExport4LocationId}
                    onChange={handleExportLocation4Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              {isExportLocation3and4ProofShow && (
                <>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location 4 Naming
                    </Form.Label>
                    <Tooltip title="Enter the file name" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the file name"
                        value={triggerProofExport4Naming}
                        onChange={handleExportLocation4NamingChange}
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                  </Col>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location 4 Metadata Definition
                    </Form.Label>
                    <Tooltip
                      title="Select the Export Location 4 Metadata Definition"
                      arrow
                    >
                      <Form.Select
                        id="ExportLocation2"
                        value={triggerProofExport4MetaDataDefinitionId}
                        onChange={handleExportLocation4MetaDataDefinitionChange}
                        style={{ fontSize: "11px" }}
                      >
                        <option value="0">Select</option>
                        {metadataColumns.map((metadataColumn: any) => (
                          <option
                            key={metadataColumn.metadataDefinitionId}
                            value={metadataColumn.metadataDefinitionId}
                          >
                            {metadataColumn.metadataDefinitionName}
                          </option>
                        ))}
                      </Form.Select>
                    </Tooltip>
                  </Col>
                </>
              )}
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Group
                  controlId="formFileTypes"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Tooltip title="PDF Export to ADO" arrow>
                    <Form.Check
                      id="chkPDFExportLocation4"
                      type="radio"
                      label="PDF"
                      radioGroup="PDFExportLocation4"
                      checked={isExportLocation3and4ProofShow === false}
                      style={{ marginRight: "10px" }}
                      onChange={handleTriggerProofPDFExportLocation3Hide}
                      value="0"
                    />
                  </Tooltip>
                  <Tooltip title="PDF + Metadata Export to ADO" arrow>
                    <Form.Check
                      id="chkPDFMetadataExportLocation4"
                      type="radio"
                      label="PDF + Metadata"
                      radioGroup="PDFExportLocation4"
                      style={{ marginRight: "10px" }}
                      checked={isExportLocation3and4ProofShow === true}
                      onChange={handleTriggerProofExportLocation3Show}
                      value="1"
                    />
                  </Tooltip>
                </Form.Group>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location 3 return
                </Form.Label>
                <Tooltip title="Select the Export Location 3 Return" arrow>
                  <Form.Select
                    id="ExportLocation3Return"
                    value={triggerProofExport3ReturnLocationId}
                    onChange={handleExportLocation3ReturnChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location3 return Archive
                </Form.Label>
                <Tooltip
                  title="Select the Export Location 3 Return Archive"
                  arrow
                >
                  <Form.Select
                    id="ExportLocation3Return"
                    value={triggerProofExport3ReturnArchivalLocationId}
                    onChange={handleExportLocation3ReturnArchiveChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location4 return
                </Form.Label>
                <Tooltip title="Select the Export Location 4 Return" arrow>
                  <Form.Select
                    id="ExportLocation3Return"
                    value={triggerProofExport4ReturnLocationId}
                    onChange={handleExportLocation4ReturnChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="TriggerProofFlow"
                  type="checkbox"
                  label="TRIGGER PROD FLOW"
                  checked={isTriggerProdWorkFlowEnabled}
                  onChange={handleTriggerProdWorkFlowEnabledChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location1 - (With Underscore)
                </Form.Label>
                <Tooltip title="Select the Export Location 1" arrow>
                  <Form.Select
                    id="ExportLocation1"
                    value={triggerProdExport1LocationId}
                    onChange={handleProdExport1LocationChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location2 - (No Underscore)
                </Form.Label>
                <Tooltip title="Select the Export Location 2" arrow>
                  <Form.Select
                    id="ExportLocation2"
                    value={triggerProdExport2LocationId}
                    onChange={handleProdExport2LocationChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkExportPrefix1"
                  type="checkbox"
                  label="Export 1 Can Prefix Job Code"
                  checked={prodExp1CanprefixjobCode}
                  onChange={handleProdExport1CanPrefixJobCodeChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkExportPrefix2"
                  type="checkbox"
                  label="Export 2 Can Prefix Job Code"
                  checked={prodExp2CanprefixjobCode}
                  onChange={handleProdExport2CanPrefixJobCodeChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location 3
                </Form.Label>
                <Tooltip title="Select the Export Location 3" arrow>
                  <Form.Select
                    id="ExportLocation3"
                    value={triggerProdExport3LocationId}
                    onChange={handleProdExport3LocationChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              {isExportLocation3and4ProdShow && (
                <>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location 3 Naming
                    </Form.Label>
                    <Tooltip title="Enter the file name" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the file name"
                        value={triggerProdExport3Naming}
                        onChange={handleProdExport3NamingChange}
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                  </Col>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location3 Metadata Definition
                    </Form.Label>
                    <Tooltip
                      title="Select the Export Location 3 Metadata Definition"
                      arrow
                    >
                      <Form.Select
                        id="ExportLocation3"
                        value={triggerProdExport3MetaDataDefinitionId}
                        onChange={handleProdExport3MetaDataDefinitionChange}
                        style={{ fontSize: "11px" }}
                      >
                        <option value="0">Select</option>
                        {metadataColumns.map((metadataColumn: any) => (
                          <option
                            key={metadataColumn.metadataDefinitionId}
                            value={metadataColumn.metadataDefinitionId}
                          >
                            {metadataColumn.metadataDefinitionName}
                          </option>
                        ))}
                      </Form.Select>
                    </Tooltip>
                  </Col>
                </>
              )}
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Group
                  controlId="formFileTypes"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Tooltip title="PDF Export to ADO" arrow>
                    <Form.Check
                      id="chkDSPDFTriggerProofFlow"
                      type="radio"
                      label="PDF"
                      radioGroup="PDFTriggerProofFlow"
                      checked={isExportLocation3and4ProdShow === false}
                      style={{ marginRight: "10px" }}
                      onChange={handleTriggerProdPDFExportLocation3Hide}
                      value="0"
                    />
                  </Tooltip>
                  <Tooltip title="PDF + Metadata Export to ADO" arrow>
                    <Form.Check
                      id="chkDSPDFMetadataTriggerProofFlow"
                      type="radio"
                      label="PDF + Metadata"
                      radioGroup="PDFTriggerProofFlow"
                      style={{ marginRight: "10px" }}
                      checked={isExportLocation3and4ProdShow === true}
                      onChange={handleTriggerProdExportLocation3Show}
                      value="1"
                    />
                  </Tooltip>
                </Form.Group>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export Location4
                </Form.Label>
                <Tooltip title="Select the Export Location 4" arrow>
                  <Form.Select
                    id="ExportLocation4"
                    value={triggerProdExport4LocationId}
                    onChange={handleProdExport4LocationChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>

              {isExportLocation3and4Prod2Show && (
                <>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location 4 Naming
                    </Form.Label>
                    <Tooltip title="Enter the file name" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the file name"
                        value={triggerProd2Export4Naming}
                        onChange={handleExportLocation4Prod2NamingChange}
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                  </Col>
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Export Location 4 Metadata Definition
                    </Form.Label>
                    <Tooltip
                      title="Select the Export Location 4 Metadata Definition"
                      arrow
                    >
                      <Form.Select
                        id="ExportLocation2"
                        value={triggerProd2Export4MetaDataDefinitionId}
                        onChange={
                          handleExportLocation4Prod2MetaDataDefinitionChange
                        }
                        style={{ fontSize: "11px" }}
                      >
                        <option value="0">Select</option>
                        {metadataColumns.map((metadataColumn: any) => (
                          <option
                            key={metadataColumn.metadataDefinitionId}
                            value={metadataColumn.metadataDefinitionId}
                          >
                            {metadataColumn.metadataDefinitionName}
                          </option>
                        ))}
                      </Form.Select>
                    </Tooltip>
                  </Col>
                </>
              )}
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Group
                  controlId="formFileTypes"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Tooltip title="PDF Export to ADO" arrow>
                    <Form.Check
                      id="chkDSPDFTriggerProofFlow"
                      type="radio"
                      label="PDF"
                      radioGroup="PDFTriggerProofFlow"
                      checked={isExportLocation3and4Prod2Show === false}
                      style={{ marginRight: "10px" }}
                      onChange={handleTriggerProd2PDFExportLocation3Hide}
                      value="0"
                    />
                  </Tooltip>
                  <Tooltip title="PDF + Metadata Export to ADO" arrow>
                    <Form.Check
                      id="chkDSPDFMetadataTriggerProofFlow"
                      type="radio"
                      label="PDF + Metadata"
                      radioGroup="PDFTriggerProofFlow"
                      style={{ marginRight: "10px" }}
                      checked={isExportLocation3and4Prod2Show === true}
                      onChange={handleTriggerProd2ExportLocation3Show}
                      value="1"
                    />
                  </Tooltip>
                </Form.Group>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FILE NAME CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>Define the naming nomenclature for File Name.</Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">To Preflight</Form.Label>
                <Tooltip title="Enter the File Name" arrow>
                  <Form.Control
                    type="text"
                    placeholder="Enter the File Name"
                    value={toPreFlightFileNameConvention}
                    onChange={handleToPreFlightFileNameConventionChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col
                md={1}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1.5em",
                }}
              >
                <Tooltip title="<<ClientPseudoName_PDF>>" arrow>
                  <PermDeviceInformationRoundedIcon />
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">From Preflight</Form.Label>
                <Tooltip title="Enter the File Name" arrow>
                  <Form.Control
                    type="text"
                    placeholder="Enter the File Name"
                    value={fromPreFlightFileNameConvention}
                    onChange={handleFromPreFlightFileNameConventionChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col
                md={1}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1.5em",
                }}
              >
                <Tooltip title="<<JobNo_ClientPseudoName_PDF>>" arrow>
                  <PermDeviceInformationRoundedIcon />
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <h4
                  className="form-heading"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "12px",
                  }}
                >
                  EMAIL CONFIGURATION
                </h4>
              </Col>
              <Col md={3}>
                <h4
                  className="form-heading"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "12px",
                  }}
                >
                  ALLOW REPROCESS
                </h4>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>Select checkbox to enable Email triggers </Col>
              <Col md={3}>Select checkbox to enable Allow Reprocess</Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkPreWorkEmail"
                  type="checkbox"
                  label="PreWork Email"
                  checked={preworkEmailRequired}
                  onChange={handlePreWorkEmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkAllow Reprocess"
                  type="checkbox"
                  label="Allow Reprocess"
                  checked={isDSAllowReprocess}
                  onChange={handleDSAllowReprocessChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkExporttoPrimaryPreflight"
                  type="checkbox"
                  label="Export to Primary Preflight"
                  checked={printReadyEmailRequired}
                  onChange={handleExportToPrimaryPreflightChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkPrimaryPreflightReturn"
                  type="checkbox"
                  label="Primary Preflight Return"
                  checked={primaryPreflightReturnEmailRequired}
                  onChange={handlePrimaryPreflightReturnChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkExporToFinal"
                  type="checkbox"
                  label="Export to Final"
                  checked={exportToFinalEmailRequired}
                  onChange={handleExportToFinalChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkPreWorkWarningEmail"
                  type="checkbox"
                  label="PreWork Warning Email"
                  checked={preworkWarningEmailRequired}
                  onChange={handlePreWorkWarningChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkPreWorkExpirationEmail"
                  type="checkbox"
                  label="PreWork Expiration Email"
                  checked={preworkExpirationEmailRequired}
                  onChange={handlePreWorkExpirationChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkDocumentRename"
                  type="checkbox"
                  label="Document Rename"
                  checked={documentRenameEmailRequired}
                  onChange={handleDocumentRenameChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkDocumentReject"
                  type="checkbox"
                  label="Document Reject"
                  checked={documentRejectEmailRequired}
                  onChange={handleDocumentRejectChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkDocumentDelete"
                  type="checkbox"
                  label="Document Delete"
                  checked={documentDeleteEmailRequired}
                  onChange={handleDocumentDeleteChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProofExport1Email"
                  type="checkbox"
                  label="Trigger Proof Export 1 Email"
                  checked={triggerProofExport1EmailRequired}
                  onChange={handleTriggerProofExport1EmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProofExport2Email"
                  type="checkbox"
                  label="Trigger Proof Export 2 Email"
                  checked={triggerProofExport2EmailRequired}
                  onChange={handleTriggerProofExport2EmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProofExport3Email"
                  type="checkbox"
                  label="Trigger Proof Export 3 Email"
                  checked={triggerProofExport3EmailRequired}
                  onChange={handleTriggerProofExport3EmailChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProofExport4Email"
                  type="checkbox"
                  label="Trigger Proof Export 4 Email"
                  checked={triggerProofExport4EmailRequired}
                  onChange={handleTriggerProofExport4EmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProofExport3ReturnEmail"
                  type="checkbox"
                  label="Trigger Proof Export 3 Return Email"
                  checked={triggerProofExport3ReturnEmailRequired}
                  onChange={handleTriggerProofExport3ReturnEmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProofExport4ReturnEmail"
                  type="checkbox"
                  label="Trigger Proof Export 4 Return Email"
                  checked={triggerProofExport4ReturnEmailRequired}
                  onChange={handleTriggerProofExport4ReturnEmailChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProdExport1Email"
                  type="checkbox"
                  label="Trigger Prod Export 1 Email"
                  checked={triggerProdExport1EmailRequired}
                  onChange={handleTriggerProdExport1EmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProdExport2Email"
                  type="checkbox"
                  label="Trigger Prod Export 2 Email"
                  checked={triggerProdExport2EmailRequired}
                  onChange={handleTriggerProdExport2EmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProdExport3Email"
                  type="checkbox"
                  label="Trigger Prod Export 3 Email"
                  checked={triggerProdExport3EmailRequired}
                  onChange={handleTriggerProdExport3EmailChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  id="chkTriggerProdExport4 Email"
                  type="checkbox"
                  label="Trigger Prod Export 4 Email"
                  checked={triggerProdExport4EmailRequired}
                  onChange={handleTriggerProdExport4EmailChange}
                />
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              PREWORK INSTRUCTION
            </h4>

            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Instruction Name
                </Form.Label>
                <Tooltip title="Enter the Instruction Name" arrow>
                  <Form.Control
                    type="text"
                    placeholder="Enter the Instruction Name"
                    value={instructionName}
                    onChange={handleInstructionNameChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
                {validationInstructionName && (
                  <Form.Text style={{ color: "var(--aggrid-text-color)" }}>
                    {validationInstructionName}
                  </Form.Text>
                )}
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">Upload Files</Form.Label>
                <div className="form-inp col-sm-12">
                  <input
                    type="file"
                    multiple
                    onChange={handelSelectFiles}
                    style={{
                      display: "none",
                    }}
                    id="file-upload-input"
                  />
                  <label htmlFor="file-upload-input">
                    <Tooltip title="Click to upload file(s)" arrow>
                      <Button
                        component="span"
                        // style={{
                        //   textTransform: "none",
                        //   borderRadius: "0px",
                        //   backgroundColor: "var(--button-background-color)",
                        //   color: "var(--button-color)",
                        //   fontSize: "11px",
                        //   padding: "5px 12px",
                        //   border: "1px solid #144979",
                        //   margin: "0px 15px 15px -5px",
                        //   whiteSpace: "white-space",
                        //   width: "180%",
                        //   height: "40px",
                        // }}
                        style={{
                          textTransform: "none",
                          borderRadius: "0px",
                          backgroundColor: "var(--button-background-color)",
                          color: "var(--button-color)",
                          fontSize: "11px",
                          padding: "5px 12px",
                          border: "1px solid #144979",
                          margin: "0px 15px 15px 5px",
                          whiteSpace: "white-space",
                          width: "180%",
                          height: "30px",
                        }}
                      >
                        Select file(s)
                      </Button>
                    </Tooltip>
                  </label>
                </div>

                {validationMessage && (
                  <Form.Text style={{ color: "var(--aggrid-text-color)" }}>
                    {validationMessage}
                  </Form.Text>
                )}
              </Col>
            </Row>
            <Row
              className="mb-12"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={12}>
                {/* Ag-Grid */}
                <div className="form-inp col-sm-12">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height: "20vh",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                    <AgGridReact
                      rowData={preworkRowData}
                      columnDefs={columnDefPrework}
                      headerHeight={25}
                      gridOptions={{
                        rowSelection: {
                          mode: "singleRow",
                          enableClickSelection: false,
                        },
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        );
      case "Downstream":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Downstream Summary : Sub-Process Configuration
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable stage
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkDownstreamPreflight"
                  label="Secondary Preflight / DAO"
                  checked={isDAOEnabled}
                  onChange={handleDAOChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkDownstreamDSA"
                  label="Downstream / DSA"
                  checked={isDSAEnabled}
                  onChange={handleDSAChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkNoSubProcess"
                  label="No SubProcess"
                  checked={isNoSubProcessEnabled}
                  onChange={handleNoSubProcessChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkNewProcess"
                  label="New Process"
                  checked={true}
                  onChange={handleNewProcessChange}
                  disabled
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              {isDAOEnabled && (
                <Col md={3}>
                  <Form.Group
                    controlId="formFileTypes"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Tooltip title="PDF Export to ADO" arrow>
                      <Form.Check
                        id="chkDSPDFTriggerProofFlow"
                        type="radio"
                        label="PDF"
                        radioGroup="PDFTriggerProofFlowGroup"
                        style={{ marginRight: "10px" }}
                        checked={isPDFExportLocation3DownstreamShow === false}
                        onChange={handleNewProcessPDFExportLocation3Hide}
                        value="0"
                      />
                    </Tooltip>
                    <Tooltip title="PDF + Metadata Export to ADO" arrow>
                      <Form.Check
                        id="chkDSPDFMetadataTriggerProofFlow"
                        type="radio"
                        label="PDF + Metadata"
                        radioGroup="PDFTriggerProofFlowGroup"
                        style={{ marginRight: "10px" }}
                        checked={isPDFExportLocation3DownstreamShow === true}
                        onChange={handleNewProcessExportLocation3Show}
                        value="1"
                      />
                    </Tooltip>
                  </Form.Group>
                </Col>
              )}

              {isNewProcessEnabled && (
                <Col md={3} style={{ marginTop: "0em", marginLeft: "102em" }}>
                  <Form.Group
                    controlId="formFileTypes"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                     <Tooltip title="PDF Export to ADO" arrow>
                      <Form.Check
                        id="chkDSPDFTriggerProofFlow"
                        type="radio"
                        label="PDF"
                        radioGroup="PDFTriggerProofFlow"
                        style={{ marginRight: "10px" }}
                        checked={
                          isNewProcessPdfEnabled 
                        }
                        onChange={
                          handleNewProcessPDFExportLocation3DownstreamHide
                        }
                      />
                    </Tooltip>
                    <Tooltip title="PDF + Metadata Export to ADO" arrow>
                      <Form.Check
                        id="chkDSPDFMetadataTriggerProofFlow"
                        type="radio"
                        label="PDF + Metadata"
                        radioGroup="PDFTriggerProofFlow"
                        style={{ marginRight: "10px" }}
                        checked={
                          !isNewProcessPdfEnabled 
                        }
                        onChange={handleNewProcessExportLocation3DownstreamShow}
                      />
                    </Tooltip>
                  </Form.Group>
                </Col>
              )}
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkPDFSplit"
                  label="PDF Split"
                  checked={isPdfSplitEnabled}
                  onChange={handlePdfSplitChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkBulkZipUpload"
                  label="Bulk Zip Upload(PDF + Metadata)"
                  checked={isBulkUploadEnabled}
                  onChange={handleBulkUploadChange}
                />
              </Col>
              <Col md={3}>
                {isNoSubProcessEnabled && (
                  <Form.Select
                    id="level"
                    value={level}
                    onChange={handleLevelChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                  </Form.Select>
                )}
              </Col>
            </Row>
            {isNewProcessEnabled && (
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "11px",
                }}
              >
                <Col md={3}>
                  <Form.Label className="input-labels">
                    NewProcess Export Folder
                  </Form.Label>
                  <Tooltip title="Select the New Process Export Folder" arrow>
                    <Form.Select
                      id="NewProcessExportFolder"
                      value={newProcessExportFTPLocationId}
                      onChange={handleNewProcessExportFolderChange}
                      style={{ fontSize: "11px" }}
                    >
                      <option value="0">Select</option>
                      {activeFileLocations.map((activeFileLocation: any) => (
                        <option
                          key={activeFileLocation.ftpFolderId}
                          value={activeFileLocation.ftpFolderId}
                        >
                          {activeFileLocation.folderName}
                        </option>
                      ))}
                    </Form.Select>
                  </Tooltip>
                </Col>
                {isNewProcessPDFExportLocation3DownstreamShow && (
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      New Process Export Naming Convention
                    </Form.Label>
                    <Tooltip title="Enter the file name" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Enter the file name"
                        value={newProcessExportNamingConvention}
                        onChange={handleNewProcessExportNamingConventionChange}
                      />
                    </Tooltip>
                  </Col>
                )}
                {isNewProcessPDFExportLocation3DownstreamShow && (
                  <Col
                    md={3}
                    style={{ marginTop: "2.5em", marginLeft: "-1em" }}
                  >
                    {" "}
                    <Tooltip title="Filename" arrow>
                      <PermDeviceInformationRoundedIcon
                        style={{
                          color: "var(--aggrid-text-color)",
                          alignItems: "center",
                        }}
                      />
                    </Tooltip>
                  </Col>
                )}
              </Row>
            )}
            {isDAOEnabled && (
              <>
                <h4
                  className="form-heading"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "12px",
                  }}
                >
                  Secondary Preflight / DAO Export Folders
                </h4>
                <Row
                  className="mb-3"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "12px",
                  }}
                >
                  <Col md={3}>
                    <Form.Label className="input-labels">
                      Add Export Folders (Level 2\Level 3\...)
                    </Form.Label>
                  </Col>
                </Row>
                <Row
                  className="mb-3"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "12px",
                  }}
                >
                  <Col md={3}>
                    <Tooltip title="Enter the folder name" arrow>
                      <Form.Control
                        type="text"
                        placeholder="Please enter the folder name"
                        value={exportFolderlevel2}
                        onChange={handleAddExportFolderChange}
                        style={{ fontSize: "11px" }}
                      />
                    </Tooltip>
                    {validationExportFolderlevel2 && (
                      <Form.Text style={{ color: "red" }}>
                        {validationExportFolderlevel2}
                      </Form.Text>
                    )}
                  </Col>
                  <Col md={3}>
                    <Tooltip title="Click to Update the Folder Path" arrow>
                      <CheckCircleIcon
                        style={{ color: "var(--aggrid-text-color)" }}
                        onClick={(event) =>
                          handleAddExportFolder(
                            event as React.MouseEvent<
                              SVGSVGElement,
                              MouseEvent
                            >,
                          )
                        }
                      />
                    </Tooltip>
                  </Col>
                </Row>
                <Row
                  className="mb-3"
                  style={{
                    color: "var(--aggrid-text-color)",
                    fontSize: "11px",
                  }}
                >
                  <Col md={6}>
                    <Form.Label className="input-labels">
                      Select Export Folders
                    </Form.Label>
                    <br />
                    <Tooltip title="Select the Export Folders" arrow>
                      <Select
                        renderValue={() => checkedItems.length + " selected"}
                        value={checkedItems}
                        style={{
                          marginTop: "1em",
                          width: "50%",
                          height: "30px",
                          color: "var(--aggrid-text-color)",
                          fontSize: "11px",
                        }}
                      >
                        {Array.isArray(downStreamExportRules) &&
                          downStreamExportRules.map(
                            (downStreamExportRule: any) => (
                              <MenuItem
                                key={
                                  downStreamExportRule.downStreamExportRuleId
                                }
                                value={
                                  downStreamExportRule.downStreamExportRuleId
                                }
                              >
                                <Checkbox
                                  checked={checkedItems.includes(
                                    downStreamExportRule.downStreamExportRuleId,
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(
                                      downStreamExportRule.downStreamExportRuleId,
                                    )
                                  }
                                />
                                <ListItemText
                                  primary={downStreamExportRule.ruleName}
                                />
                                <CloseIcon
                                  style={{ cursor: "pointer", color: "black" }}
                                  onClick={() =>
                                    handleDeleteItem(
                                      downStreamExportRule.downStreamExportRuleId,
                                    )
                                  }
                                />
                              </MenuItem>
                            ),
                          )}
                      </Select>
                    </Tooltip>
                  </Col>
                </Row>
              </>
            )}
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Folder Configuration
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select path to share folders
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  PDF Source Folder
                </Form.Label>
                <Tooltip title="Select the PDF Source Folder" arrow>
                  <Form.Select
                    id="pdfSourceFolder"
                    value={pdfSourceFTPLocationId}
                    onChange={handlePdfSourceFolderChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  PDF Source Archive
                </Form.Label>
                <Tooltip title="Select the PDF Source Archive" arrow>
                  <Form.Select
                    id="pdfSourceArchive"
                    value={pdfArchiveFTPLocationId}
                    onChange={handlePdfArchiveFolderChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Metadata Source Folder
                </Form.Label>
                <Tooltip title="Select the Metadata Source Folder" arrow>
                  <Form.Select
                    id="pdfMetadataSourceFolder"
                    value={metadataSourceFTPLocationId}
                    onChange={handleMetadataSourceFolderChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Metadata Source Archive
                </Form.Label>
                <Tooltip title="Select the Metadata Source Archive" arrow>
                  <Form.Select
                    id="MetadataSourceArchive"
                    value={metadataArchiveFTPLocationId}
                    onChange={handleMetadataArchiveFolderChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Source Metadata Definition
                </Form.Label>
                <Tooltip title="Select the Source Metadata Definition" arrow>
                  <Form.Select
                    id="SourceMetadataDefinition"
                    value={sourceIngestionMetadtaDefinitionID}
                    onChange={handleSourceIngestionMetadataDefinitionChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {metadataColumns.map((metadataColumn: any) => (
                      <option
                        key={metadataColumn.metadataDefinitionId}
                        value={metadataColumn.metadataDefinitionId}
                      >
                        {metadataColumn.metadataDefinitionName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>

              <Col md={3}>
                <Form.Label className="input-labels">Header</Form.Label>
                <Tooltip title="Yes" arrow>
                  <Form.Check
                    type="radio"
                    id="rdoYes"
                    label="Yes"
                    checked={hasHeader === true}
                    radioGroup="dsheader"
                    onChange={handleHasHeadeYesrChange}
                  />
                </Tooltip>
                <Tooltip title="No" arrow>
                  <Form.Check
                    type="radio"
                    id="rdoNo"
                    label="No"
                    checked={hasHeader === false}
                    radioGroup="dsheader"
                    onChange={handleHasHeaderNoChange}
                  />
                </Tooltip>
              </Col>
            </Row>
            {isPDFExportLocation3DownstreamShow && (
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                <Col md={3}>
                  <Form.Label className="input-labels">
                    VIS Export Naming Convention
                  </Form.Label>
                  <Tooltip title="Enter the VIS Export Naming Convention" arrow>
                    <Form.Control
                      type="text"
                      placeholder="<<Metadata file name>>"
                      value={daoExportNamingConvention}
                      onChange={handleDaoExportNamingConventionChange}
                    />
                  </Tooltip>
                </Col>
                <Col
                  md={1}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "1.5em",
                  }}
                >
                  <Tooltip title="DD_VIS_T_EXPORT_IDX.TXT" arrow>
                    <PermDeviceInformationRoundedIcon />
                  </Tooltip>
                </Col>
              </Row>
            )}
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  To Secondary Preflight
                </Form.Label>
                <Tooltip title="Select the To Secondary Preflight" arrow>
                  <Form.Select
                    id="ToSecondaryPreflight"
                    value={toSecondaryFTPLocationId}
                    onChange={handleToSecondaryPreflightChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>

              <Col md={3}>
                <Form.Label className="input-labels">
                  From Secondary Preflight
                </Form.Label>
                <Tooltip title="Select the From Secondary Preflight" arrow>
                  <Form.Select
                    id="FromSecondaryPreflight"
                    value={fromSecondaryFTPLocationId}
                    onChange={handleFromSecondaryPreflightChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  From Secondary Preflight Archive
                </Form.Label>
                <Tooltip
                  title="Select the From Secondary Preflight Archive"
                  arrow
                >
                  <Form.Select
                    id="FromSecondaryPreflightArchive"
                    value={fromSecondaryArchiveFTPLocationId}
                    onChange={handleFromSecondaryArchivePreflightChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Export FilenameWithoutUnderscore
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  id="chkExportFilenameWithoutUnderscore"
                  checked={exportFilenameWithoutUnderscore}
                  onChange={handleExportFilenameWithoutUnderscoreChange}
                />
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Secondary Preflight Metadata Definition
                </Form.Label>
                <Tooltip
                  title="Select the Secondary Preflight Metadata Definition"
                  arrow
                >
                  <Form.Select
                    id="SecondaryPreflightMetadataDefinition"
                    value={daoReturnMetadataDefinitionID}
                    onChange={handleDaoReturnMetadataDefinitionChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {metadataColumns.map((metadataColumn: any) => (
                      <option
                        key={metadataColumn.metadataDefinitionId}
                        value={metadataColumn.metadataDefinitionId}
                      >
                        {metadataColumn.metadataDefinitionName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">To Downsample</Form.Label>
                <Tooltip title="Select the To Downsample Location" arrow>
                  <Form.Select
                    id="ToDownsample"
                    value={toDownSampleFTPLocationId}
                    onChange={handleToDownSampleChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  From Downsample
                </Form.Label>
                <Tooltip title="Select the From Downsample Location" arrow>
                  <Form.Select
                    id="FromDownsample"
                    value={fromDownSamplingFTPLocationId}
                    onChange={handleFromDownSampleChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  From Downsample Archive
                </Form.Label>
                <Tooltip title="Select the From Downsample Archive" arrow>
                  <Form.Select
                    id="FromDownsampleArchive"
                    value={fromDownSamplingArchiveFTPLocationId}
                    onChange={handleFromDownSampleArchiveChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Downsample Metadata Definition
                </Form.Label>
                <Tooltip
                  title="Select the Downsample Metadata Definition"
                  arrow
                >
                  <Form.Select
                    id="DownsampleMetadataDefinition"
                    value={dsaReturnMetadataDefinitionID}
                    onChange={handleDsaReturnMetadataDefinitionChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {metadataColumns.map((metadataColumn: any) => (
                      <option
                        key={metadataColumn.metadataDefinitionId}
                        value={metadataColumn.metadataDefinitionId}
                      >
                        {metadataColumn.metadataDefinitionName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">Web Ready</Form.Label>
                <Tooltip title="Please Select the Web Ready Location" arrow>
                  <Form.Select
                    id="WebReady"
                    value={webReadyFtpLocationId}
                    onChange={handleWebReadyChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Web Ready Archive
                </Form.Label>
                <Tooltip
                  title="Please Select the Web Ready Archive Location"
                  arrow
                >
                  <Form.Select
                    id="WebReadyArchive"
                    value={webReadyArchiveFtpLocationId}
                    onChange={handleWebReadyArchiveChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">Export Doc</Form.Label>
                <Tooltip title="Please Select the Export Doc Location" arrow>
                  <Form.Select
                    id="ExportDoc"
                    value={exportFtpLocationId}
                    onChange={handleExportDocChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Allow Reprocess
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable Allow Reprocess
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkAllowReprocess"
                  label="Allow Reprocess"
                  checked={isDSAllowReprocess}
                  onChange={handleDSAllowReprocessChange}
                />
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Document Display Rule
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable Document Display Rule
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkDocumentDisplayRule"
                  label="Document Display Rule"
                  checked={isDisplayRuleMapping}
                  onChange={handleDisplayRuleMappingChange}
                />
              </Col>
              {isDisplayRuleMapping && (
                <Col md={3}>
                  <Form.Label className="input-labels">
                    Document Display Rule
                  </Form.Label>
                  <Form.Select
                    id="DocumentDisplayRule"
                    value={displayRuleMappingId}
                    onChange={handleDocumentDisplayRuleChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                  </Form.Select>
                </Col>
              )}
            </Row>
            <Row
              className="mb-1"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              <Col md={1}>
                <Form.Label className="input-labels">
                  Display Recent Record
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="0"
                  value={recentRecordDays}
                  onChange={handleRecentRecordDaysChange}
                  style={{ fontSize: "11px" }}
                />{" "}
                days
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Email Configuration
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable Email triggers
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkEmailTrigger"
                  label="Index file processed"
                  checked={indexFileProcessedMailRequired}
                  onChange={handleIndexFileProcessedChange}
                />
              </Col>
            </Row>

            {isDAOEnabled && (
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkExporttoSecondaryPreflight"
                    label="Export to Secondary Preflight"
                    checked={exportSecondaryPreFlightMailRequired}
                    onChange={handleExportSecondaryPreFlightChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkSecondaryPreflightReturn"
                    label="Secondary Preflight Return"
                    checked={secondaryPreFlightReturnMailRequired}
                    onChange={handleSecondaryPreFlightReturnChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkSecondaryPreflightWarning"
                    label="Secondary Preflight Warning"
                    checked={secondaryPreFlightWarningMailRequired}
                    onChange={handleSecondaryPreFlightWarningChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkSecondary Preflight Failure"
                    label="Secondary Preflight Failure"
                    checked={secondaryPreflightFailureRequired}
                    onChange={handleSecondaryPreflightFailureChange}
                  />
                </Col>
              </Row>
            )}
            {isDSAEnabled && (
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
              >
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkExporttoDownsample"
                    label="Export to Downsample"
                    checked={exportDownSampleMailRequired}
                    onChange={handleExportDownSampleChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkDownsampleReturn"
                    label="Downsample Return"
                    checked={downStreamReturnMailRequired}
                    onChange={handleDownStreamReturnChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkDownsampleWarning"
                    label="Downsample Warning"
                    checked={downsampleWarningMailRequired}
                    onChange={handleDownsampleWarningChange}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    type="checkbox"
                    id="chkDownsampleFailure"
                    label="Downsample Failure"
                    checked={downsampleFailureMailRequired}
                    onChange={handleDownsampleFailureChange}
                  />
                </Col>
              </Row>
            )}
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkExporttoWebReady"
                  label="Metadata Rejection Reasons"
                  checked={metadataRejectedReasonsMailRequired}
                  onChange={handleMetadataRejectedReasonsChange}
                />
              </Col>
            </Row>
          </div>
        );
      case "eDelivery":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              Folder Configuration
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select path to map to shared folder
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  eDelivery Folder 1
                </Form.Label>
                <Tooltip title="Please Select the eDelivery Folder 1" arrow>
                  <Form.Select
                    id="eDeliveryFolder1"
                    value={eDeliveryFtpLocationId}
                    onChange={handleEDeliveryFolder1Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">Option</Form.Label>
                <Tooltip title="Please Select the Option" arrow>
                  <Form.Select
                    id="eDeliveryFolder1Option"
                    value={fundFolderType}
                    onChange={handleFundFolderTypeChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    <option value="1">Web Ready</option>
                    <option value="2">Print Ready</option>
                    <option value="3">Print Ready & Web Ready</option>
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  eDelivery Folder 2
                </Form.Label>
                <Tooltip title="Please Select the eDelivery Folder 2" arrow>
                  <Form.Select
                    id="eDeliveryFolder2"
                    value={secondaryeDeliveryFTPLocationId}
                    onChange={handleSecondaryEDeliveryFolder2Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">Option</Form.Label>
                <Tooltip title="Please Select the Option" arrow>
                  <Form.Select
                    id="eDeliveryFolder1Option2"
                    value={secondaryFundFolderType}
                    onChange={handleSecondaryFundFolderTypeChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    <option value="1">Web Ready</option>
                    <option value="2">Print Ready</option>
                    <option value="3">Print Ready & Web Ready</option>
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  eDelivery Return - Print Ready
                </Form.Label>
                <Tooltip
                  title="Please Select the eDelivery Return - Print Ready"
                  arrow
                >
                  <Form.Select
                    id="eDeliveryRetrunPrintReady"
                    value={printReadyEdeliveryReturnFTPLocationId}
                    onChange={handlePrintReadyEdeliveryReturnChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  eDelivery Return - Web Ready
                </Form.Label>
                <Tooltip
                  title="Please Select the eDelivery Return - Web Ready"
                  arrow
                >
                  <Form.Select
                    id="eDeliveryReturnWebReady"
                    value={webReadyEdeliveryReturnFTPLocationId}
                    onChange={handleWebReadyEdeliveryReturnChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  eDelivery Return - Print Ready Archive
                </Form.Label>
                <Tooltip
                  title="Please Select the eDelivery Return - Print Ready Archive"
                  arrow
                >
                  <Form.Select
                    id="eDeliveryRetrunPrintReadyArchive"
                    value={printReadyEdeliveryReturnArchiveFTPLocationId}
                    onChange={handlePrintReadyEdeliveryReturnArchiveChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  eDelivery Return - Web Ready Archive
                </Form.Label>
                <Tooltip
                  title="Please Select the eDelivery Return - Web Ready Archive"
                  arrow
                >
                  <Form.Select
                    id="eDeliveryReturnWebReadyArchive"
                    value={webReadyEdeliveryReturnArchiveFTPLocationId}
                    onChange={handleWebReadyEdeliveryReturnArchiveChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  edelivery Return - PrintReady Metadata Definition
                </Form.Label>
                <Tooltip
                  title="Please Select the edelivery Return - PrintReady Metadata Definition"
                  arrow
                >
                  <Form.Select
                    id="edeliveryReturnPrintReadyMetadataDefinition"
                    value={edeliveryReturnPrintReadyMetadataDefinitionID}
                    onChange={
                      handleEdeliveryReturnPrintReadyMetadataDefinitionChange
                    }
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {metadataColumns.map((metadataColumn: any) => (
                      <option
                        key={metadataColumn.metadataDefinitionId}
                        value={metadataColumn.metadataDefinitionId}
                      >
                        {metadataColumn.metadataDefinitionName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  edelivery Return - Webready Metadata Definition
                </Form.Label>
                <Tooltip
                  title="Please Select the edelivery Return - Webready Metadata Definition"
                  arrow
                >
                  <Form.Select
                    id="eDeliveryReturnWebReadyArchive"
                    value={edeliveryReturnWebreadyMetadatadefinitionID}
                    onChange={
                      handleEdeliveryReturnWebreadyMetadatadefinitionChange
                    }
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {metadataColumns.map((metadataColumn: any) => (
                      <option
                        key={metadataColumn.metadataDefinitionId}
                        value={metadataColumn.metadataDefinitionId}
                      >
                        {metadataColumn.metadataDefinitionName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              EDELIVERY RETURN CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable eDelivery Return
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkEDeliveryReturn"
                  label="eDelivery Return"
                  checked={edeliveryReturn}
                  onChange={handleEDeliveryReturnChange}
                />
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              EMAIL CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable Email trigger
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkEmailTrigger"
                  label="eDelivery Export - Print Ready"
                  checked={secondaryEmailexportRequired}
                  onChange={handleSecondaryEmailexportChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkEmailTrigger"
                  label="eDelivery Export - Web Ready"
                  checked={exportEmailRequired}
                  onChange={handleExportEmailChange}
                />
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FILE NAMING CONVENTION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Define the file naming nomenclature for eDelivery folder
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">Print Ready</Form.Label>
                <Tooltip
                  title="Please Enter the Print Ready File Name Convention"
                  arrow
                >
                  <Form.Control
                    type="text"
                    placeholder="<<ClinetName_docid>>"
                    value={secondaryFileNameConvention}
                    onChange={handleSecondaryFileNameConventionChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col
                md={1}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1.5em",
                }}
              >
                <Tooltip
                  title="FBU<Application #>P WebDFS<Prod, Stage, or Test>_001"
                  arrow
                >
                  <PermDeviceInformationRoundedIcon />
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">Web Ready</Form.Label>
                <Tooltip
                  title="Please Enter the Web Ready File Name Convention"
                  arrow
                >
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={edeliveryFileNameConvention}
                    onChange={handleEDeliveryFileNameConventionChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col
                md={1}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1.5em",
                }}
              >
                <Tooltip
                  title="FBU<Application #>P WebDFS<Prod, Stage, or Test>_001"
                  arrow
                >
                  <PermDeviceInformationRoundedIcon />
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Form.Label className="input-labels">
                Set eDelivery Frequency :
              </Form.Label>
            </Row>
            <Row
              className="mb-4"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Col md={1}>
                <Form.Control
                  type="Number"
                  placeholder="0"
                  value={frequencyHrs}
                  onChange={handleFrequencyHrsChange}
                  style={{ fontSize: "11px" }}
                />
              </Col>
              <Col md={1} style={{ marginLeft: "-10px" }}>
                Hour
              </Col>
              <Col md={1} style={{ marginLeft: "-60px" }}>
                <Form.Control
                  type="Number"
                  placeholder="0"
                  value={frequencyMins}
                  onChange={handleFrequencyMinsChange}
                  style={{ fontSize: "11px" }}
                />
              </Col>
              <Col md={1} style={{ marginLeft: "-10px" }}>
                Minutes
              </Col>
            </Row>
          </div>
        );
      case "Active DocID export":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              ACTIVE DOCID EXPORT
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select Active DocID Export criteria.
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">Field</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">Value</Form.Label>
              </Col>
            </Row>

            {(!searchCriterias || searchCriterias.length === 0
              ? [
                  {
                    field: "",
                    value: "",
                  },
                ]
              : searchCriterias
            ).map((searchCriteria: any, index: number) => (
              <Row
                className="mb-3"
                style={{
                  color: "var(--aggrid-text-color)",
                  fontSize: "12px",
                }}
                key={searchCriteria?.field}
              >
                <Col md={3}>
                  <Tooltip title="Please Select the Field" arrow>
                    <Form.Select
                      id="ActiveDocIDExportField"
                      value={searchCriteria?.field || "0"}
                      onChange={(e) =>
                        handleSearchCriteriaFieldNameChange(e, index)
                      }
                      style={{ fontSize: "11px" }}
                    >
                      <option value="0">Select</option>
                      {categories.map((category) => (
                        <optgroup key={category.label} label={category.label}>
                          {category.options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </Form.Select>
                  </Tooltip>
                </Col>
                <Col md={3}>
                  <Tooltip title="Please Enter the Value" arrow>
                    <Form.Control
                      type="text"
                      placeholder="0"
                      value={searchCriteria?.value1 || ""}
                      onChange={(e) => handleFieldValueChange(e, index)}
                      style={{ fontSize: "11px" }}
                    />
                  </Tooltip>
                </Col>
                <Col md={3}>
                  {!searchCriterias ||
                    (index === searchCriterias.length - 1 && (
                      <Tooltip title="Click to add row" arrow>
                        <AddBoxIcon
                          style={{
                            marginTop: "10px",
                            marginLeft: "10px",
                            color: "var(--aggrid-text-color)",
                          }}
                          onClick={handleActiveDocIDAddRow}
                        />
                      </Tooltip>
                    ))}
                  {(!searchCriterias ||
                    searchCriterias.length > 1 ||
                    (index === 0 && searchCriterias.length !== 1)) && (
                    <Tooltip title="Click to delete row" arrow>
                      <DeleteForeverIcon
                        style={{
                          marginLeft: "10px",
                          marginTop: "10px",
                          color: "var(--button-color)",
                        }}
                        onClick={() => handleActiveDocIDRemoveRow(index)}
                      ></DeleteForeverIcon>
                    </Tooltip>
                  )}
                </Col>
              </Row>
            ))}

            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FOLDER CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select path to map to shared folder
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  DOC ID list folder 1
                </Form.Label>
                <Tooltip title="Please Select the DOC ID list folder 1" arrow>
                  <Form.Select
                    id="docIDListFolder1"
                    value={exportDocFTPLocationId}
                    onChange={handleExportDocFTPLocationIdChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  DOC ID list folder 2
                </Form.Label>
                <Tooltip title="Please Select the DOC ID list folder 2" arrow>
                  <Form.Select
                    id="docIDListFolder2"
                    value={exportDocFTPLocationId2}
                    onChange={handleExportDocFTPLocationId2Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  DOC ID list folder 3
                </Form.Label>
                <Tooltip title="Please Select the DOC ID list folder 3" arrow>
                  <Form.Select
                    id="docIDListFolder3"
                    value={exportDocFTPLocationId3}
                    onChange={handleExportDocFTPLocationId3Change}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              EMAIL CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable Email trigger
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkDOCIDexport"
                  label="DOC ID export"
                  checked={exportEmailRequiredActiveDocId}
                  onChange={handleExportEmailRequiredActiveDocIdChange}
                />
              </Col>
            </Row>

            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FILE NAMING CONVENTION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Please define file naming nomenclature
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Tooltip title="Please Enter the File Name Convention" arrow>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={exportFileNameConvention}
                    onChange={handleExportFileNameConventionChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col md={3}>
                <Tooltip
                  title="Data file name: DOCID_<P>_MASTER.txt Where <P> = “P”rod"
                  arrow
                >
                  <PermDeviceInformationRoundedIcon
                    style={{
                      marginTop: "5px",
                      marginLeft: "-20px",
                      color: "var(--aggrid-text-color)",
                      alignItems: "center",
                    }}
                  />
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Form.Label className="input-labels">
                Export active Doc IDs every:
              </Form.Label>
            </Row>
            <Row
              className="mb-4"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Col md={1}>
                <Form.Control
                  type="Number"
                  placeholder="0"
                  value={exportFrequencyHour}
                  onChange={handleExportFrequencyHourChange}
                  style={{ fontSize: "11px" }}
                />
              </Col>
              <Col md={1} style={{ marginLeft: "-10px" }}>
                Hour
              </Col>
              <Col md={1} style={{ marginLeft: "-60px" }}>
                <Form.Control
                  type="Number"
                  placeholder="0"
                  value={exportFrequencyMin}
                  onChange={handleExportFrequencyMinChange}
                  style={{ fontSize: "11px" }}
                />
              </Col>
              <Col md={1} style={{ marginLeft: "-10px" }}>
                Minutes
              </Col>
            </Row>
          </div>
        );
      case "Archival Report":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FOLDER CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select path to share folders
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Archival Location
                </Form.Label>
                <Tooltip title="Please Select the Archival Location" arrow>
                  <Form.Select
                    id="ArchivalLocation"
                    value={archivalLocationId}
                    onChange={handleArchivalLocationChange}
                    style={{ fontSize: "11px" }}
                  >
                    <option value="0">Select</option>
                    {activeFileLocations.map((activeFileLocation: any) => (
                      <option
                        key={activeFileLocation.ftpFolderId}
                        value={activeFileLocation.ftpFolderId}
                      >
                        {activeFileLocation.folderName}
                      </option>
                    ))}
                  </Form.Select>
                </Tooltip>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FILE NAMING CONVENTION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Define the file naming nomenclature for Archival Report Zip
                </Form.Label>
              </Col>
            </Row>

            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">Zip File Name</Form.Label>
                <Tooltip title="Please Enter the Zip File Name" arrow>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={archivalFileNameConvention}
                    onChange={handleArchivalFileNameConventionChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col md={3}>
                <Tooltip
                  title="FBU<Application #>P WebDFS<Prod, Stage, or Test>_001"
                  arrow
                >
                  <PermDeviceInformationRoundedIcon
                    style={{
                      marginTop: "30px",
                      marginLeft: "-20px",
                      color: "var(--aggrid-text-color)",
                      alignItems: "center",
                    }}
                  />
                </Tooltip>
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              EMAIL CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select checkbox to enable Email triggers
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkArchivalExport"
                  label="Archival Export"
                  checked={archivalEmailRequired}
                  onChange={handleArchivalEmailRequiredChange}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chArchivalRequestApproval"
                  label="Archival Request Approval"
                  checked={archivalReqApprovalEmailRequired}
                  onChange={handleArchivalReqApprovalEmailRequiredChange}
                />
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              ARCHIVAL LOCATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Web Ready (Level 2)
                </Form.Label>
                <Tooltip title="Please Enter the Web Ready (Level 2)" arrow>
                  <Form.Control
                    type="text"
                    placeholder="Please enter folder name"
                    value={archivalWebReadyLevel2}
                    onChange={handleWebReadyLevel2Change}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
                {validationWebReadyLevel2 && (
                  <Form.Text style={{ color: "red" }}>
                    {validationWebReadyLevel2}
                  </Form.Text>
                )}
              </Col>
              <Col md={1}>
                <Tooltip title="Click to Update the Folder Path" arrow>
                  <CheckCircleIcon
                    style={{
                      marginTop: "30px",
                      marginLeft: "-20px",
                      color: "var(--aggrid-text-color)",
                      alignItems: "center",
                    }}
                    onClick={(event) =>
                      handleUpdateWebReadyLevel2FolderClick(
                        event as React.MouseEvent<SVGSVGElement, MouseEvent>,
                      )
                    }
                  />
                </Tooltip>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Print Ready (Level 2)
                </Form.Label>
                <Tooltip title="Please Enter the Print Ready (Level 2)" arrow>
                  <Form.Control
                    type="text"
                    placeholder="Please enter folder name"
                    value={archivalPrintReadyLevel2}
                    onChange={handlePrintReadyLevel2Change}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
                {validationPrintReadyLevel2 && (
                  <Form.Text style={{ color: "red" }}>
                    {validationPrintReadyLevel2}
                  </Form.Text>
                )}
              </Col>
              <Col md={3}>
                <Tooltip title="" arrow>
                  <CheckCircleIcon
                    style={{
                      marginTop: "30px",
                      marginLeft: "-20px",
                      color: "var(--aggrid-text-color)",
                      alignItems: "center",
                    }}
                    onClick={(event) =>
                      handleUpdatePrintReadyLevel2FolderClick(
                        event as React.MouseEvent<SVGSVGElement, MouseEvent>,
                      )
                    }
                  />
                </Tooltip>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select Export Folders
                </Form.Label>
                <br />
                <Tooltip title="Please Select the Export Folders" arrow>
                  <Select
                    renderValue={() =>
                      checkedItemsArchiveWebReady.length + " selected"
                    }
                    value={checkedItemsArchiveWebReady}
                    style={{
                      marginTop: "1em",
                      width: "100%",
                      height: "30px",
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    {Array.isArray(exportFolderData) &&
                      exportFolderData
                        .filter((x) => x.isEnabled === true)
                        .map((exportFolder: any) => (
                          <MenuItem
                            key={exportFolder.archivalLevelId}
                            value={exportFolder.archivalLevelId}
                          >
                            <Checkbox
                              checked={checkedItemsArchiveWebReady.includes(
                                exportFolder.archivalLevelId,
                              )}
                              onChange={() =>
                                handleWebreadyCheckboxChange(
                                  exportFolder.archivalLevelId,
                                )
                              }
                            />
                            <ListItemText
                              primary={exportFolder.archivalLevelName}
                            />
                            <CloseIcon
                              style={{ cursor: "pointer", color: "black" }}
                              onClick={() =>
                                handleWebreadyDeleteItem(
                                  exportFolder.archivalLevelId,
                                )
                              }
                            />
                          </MenuItem>
                        ))}
                  </Select>
                </Tooltip>
              </Col>
              <Col md={1}></Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select Export Folders
                </Form.Label>
                <br />
                <Tooltip title="Please Select the Export Folders" arrow>
                  <Select
                    renderValue={() =>
                      checkedItemsArchivePrintReady?.length + " selected"
                    }
                    value={checkedItemsArchivePrintReady}
                    style={{
                      marginTop: "1em",
                      width: "100%",
                      height: "30px",
                      color: "var(--aggrid-text-color)",
                      fontSize: "11px",
                    }}
                  >
                    {Array.isArray(exportFolderData) &&
                      exportFolderData
                        .filter((x) => x.isEnabled === false)
                        .map((exportFolder: any) => (
                          <MenuItem
                            key={exportFolder.archivalLevelId}
                            value={exportFolder.archivalLevelId}
                          >
                            <Checkbox
                              checked={checkedItemsArchivePrintReady.includes(
                                exportFolder.archivalLevelId,
                              )}
                              onChange={() =>
                                handlePrintreadyCheckboxChange(
                                  exportFolder.archivalLevelId,
                                )
                              }
                            />
                            <ListItemText
                              primary={exportFolder.archivalLevelName}
                            />
                            <CloseIcon
                              style={{ cursor: "pointer", color: "black" }}
                              onClick={() =>
                                handlePrintreadyDeleteItem(
                                  exportFolder.archivalLevelId,
                                )
                              }
                            />
                          </MenuItem>
                        ))}
                  </Select>
                </Tooltip>
              </Col>
            </Row>
          </div>
        );
      case "Turbo Proofs":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              UPLOAD SETTINGS
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Upload Settings:
                </Form.Label>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">File formats:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  File size allowed:
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkFTPFolderUpload"
                  label="FTP Folder Upload"
                  checked={turboCanFTPFolderUpload}
                  onChange={handleTurboCanFTPFolderUploadChange}
                />
              </Col>
              <Col md={3}>
                <Form.Group
                  controlId="formFileTypes"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Check
                    id="chkPDF"
                    type="checkbox"
                    label="PDF"
                    checked={turboPdfType}
                    style={{ marginRight: "10px" }}
                    onChange={handleTurboPdfTypeChange}
                  />
                  <Form.Check
                    id="chkExcel"
                    type="checkbox"
                    label="Excel"
                    checked={turboExcelType}
                    style={{ marginRight: "10px" }}
                    onChange={handleTurboExcelTypeChange}
                  />
                  <Form.Check
                    id="chkWordDoc"
                    type="checkbox"
                    label="Word Doc"
                    checked={turboWordDocType}
                    onChange={handleTurboWordDocTypeChange}
                  />
                </Form.Group>
              </Col>
              <Col md={1}>
                <Tooltip title="Please Enter the File Size" arrow>
                  <Form.Control
                    type="Number"
                    placeholder="0"
                    value={turbofileSize}
                    onChange={handleTurbofileSizeChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col md={1}>
                <Form.Label className="input-labels">MB</Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkUIUpload"
                  label="UI Upload"
                  checked={turboEnableUIUpload}
                  onChange={handleTurboEnableUIUploadChange}
                />
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FOLDER CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select path to map to shared folders.
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">FTP Source</Form.Label>
                <Form.Select
                  id="FTPSource"
                  value={turboftpSourceLocationId}
                  onChange={handleTurboftpSourceLocationIdChange}
                  disabled={true}
                  style={{ fontSize: "11px" }}
                >
                  <option value="0">Select</option>
                  {activeFileLocations.map((activeFileLocation: any) => (
                    <option
                      key={activeFileLocation.ftpFolderId}
                      value={activeFileLocation.ftpFolderId}
                    >
                      {activeFileLocation.folderName}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={11} style={{ display: "flex", alignItems: "center" }}>
                <Form.Control
                  type="text"
                  placeholder="TURBO PROOFS"
                  value={turboLevel1Folder}
                  readOnly={true}
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  onChange={handleTurboLevel1FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 2 folder"
                  value={turboLevel2Folder}
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  onChange={handleTurboLevel2FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 3 folder"
                  value={turboLevel3Folder}
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  onChange={handleTurboLevel3FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 4 folder"
                  value={turboLevel4Folder}
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  onChange={handleTurboLevel4FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 5 folder"
                  value={turboLevel5Folder}
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  onChange={handleTurboLevel5FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 6 folder"
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  value={turboLevel6Folder}
                  onChange={handleTurboLevel6FolderChange}
                />
              </Col>

              <Col md={1}>
                <Button
                  variant="outlined"
                  type="button"
                  color="primary"
                  className="btnClass"
                  onClick={handleAddTurboProofsFolderClick}
                  style={{
                    textTransform: "none",
                    borderRadius: "0px",
                    backgroundColor: "var(--button-background-color)",
                    color: "var(--button-color)",
                    fontSize: "11px",
                    padding: "5px 12px",
                    border: "1px solid #144979",
                    margin: "0px 15px 15px 5px",
                    whiteSpace: "white-space",
                    width: "50%",
                    height: "30px",
                  }}
                >
                  {textAddOrUpdateTurbo}
                </Button>
              </Col>
            </Row>
            <Row
              className="mb-12"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              <Col md={12}>
                {/* Ag-Grid */}
                <div className="form-inp col-sm-12">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height: "20vh",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                    <AgGridReact
                      rowData={rowDataTurbo}
                      columnDefs={columnDefTurboTab}
                      headerHeight={25}
                      gridOptions={{
                        rowSelection: {
                          mode: "singleRow",
                          enableClickSelection: false,
                        },
                      }}
                      context={rowDataTurbo}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        );
      case "Post-Work":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              UPLOAD SETTINGS
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Upload Settings:
                </Form.Label>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">File formats:</Form.Label>
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  File size allowed:
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkFTPFolderUpload"
                  label="FTP Folder Upload"
                  checked={postWorkCanFTPFolderUpload}
                  onChange={handleCanFTPFolderUploadChange}
                />
              </Col>
              <Col md={3}>
                <Form.Group
                  controlId="formFileTypes"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Check
                    id="chkPDF"
                    type="checkbox"
                    label="PDF"
                    style={{ marginRight: "10px" }}
                    checked={postWorkPdfType}
                    onChange={handlePdfTypeChange}
                  />
                  <Form.Check
                    id="chkExcel"
                    type="checkbox"
                    label="Excel"
                    style={{ marginRight: "10px" }}
                    checked={postWorkExcelType}
                    onChange={handleExcelTypeChange}
                  />
                  <Form.Check
                    id="chkWordDoc"
                    type="checkbox"
                    label="Word Doc"
                    checked={postWorkWordDocType}
                    onChange={handleWordDocTypeChange}
                  />
                </Form.Group>
              </Col>
              <Col md={1}>
                <Tooltip title="Please Enter the File Size" arrow>
                  <Form.Control
                    type="Number"
                    placeholder="0"
                    value={postWorkfileSize}
                    onChange={handlePostWorkfileSizeChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
              </Col>
              <Col md={1}>
                <Form.Label className="input-labels">MB</Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chkUIUpload"
                  label="UI Upload"
                  checked={postWorkEnableUIUpload}
                  onChange={handlePostWorkEnableUIUploadChange}
                />
              </Col>
            </Row>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              FOLDER CONFIGURATION
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Select path to map to shared folders.
                </Form.Label>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">FTP Source</Form.Label>
                <Form.Select
                  id="FTPSource"
                  value={postWorkftpSourceLocationId}
                  onChange={handlePostWorkftpSourceLocationIdChange}
                  disabled={true}
                  style={{ fontSize: "11px" }}
                >
                  <option value="0">Select</option>
                  {activeFileLocations.map((activeFileLocation: any) => (
                    <option
                      key={activeFileLocation.ftpFolderId}
                      value={activeFileLocation.ftpFolderId}
                    >
                      {activeFileLocation.folderName}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={11} style={{ display: "flex", alignItems: "center" }}>
                <Form.Control
                  type="text"
                  value={postWorkLevel1Folder}
                  placeholder="Enter Level 1 folder"
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  readOnly={true}
                  onChange={handlePostWorkLevel1FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 2 folder"
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  value={postWorkLevel2Folder}
                  onChange={handlePostWorkLevel2FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 3 folder"
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  value={postWorkLevel3Folder}
                  onChange={handlePostWorkLevel3FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 4 folder"
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  value={postWorkLevel4Folder}
                  onChange={handlePostWorkLevel4FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 5 folder"
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  value={postWorkLevel5Folder}
                  onChange={handlePostWorkLevel5FolderChange}
                />
                <Form.Control
                  type="text"
                  placeholder="Enter Level 6 folder"
                  style={{ marginRight: "20px", fontSize: "11px" }}
                  value={postWorkLevel6Folder}
                  onChange={handlePostWorkLevel6FolderChange}
                />
              </Col>

              <Col md={1}>
                <Button
                  variant="outlined"
                  type="button"
                  color="primary"
                  className="btnClass"
                  style={{
                    textTransform: "none",
                    borderRadius: "0px",
                    backgroundColor: "var(--button-background-color)",
                    color: "var(--button-color)",
                    fontSize: "11px",
                    padding: "5px 12px",
                    border: "1px solid #144979",
                    margin: "0px 15px 15px 5px",
                    whiteSpace: "white-space",
                    width: "50%",
                    height: "30px",
                  }}
                  onClick={handleAddPostWorkFolderClick}
                >
                  {textAddOrUpdatePostWork}
                </Button>
              </Col>
            </Row>
            <Row
              className="mb-12"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              <Col md={12}>
                {/* Ag-Grid */}
                <div className="form-inp col-sm-12">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height: "20vh",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                    <AgGridReact
                      rowData={rowDataPostWork}
                      columnDefs={columnDefPostWorkTab}
                      headerHeight={25}
                      gridOptions={{
                        rowSelection: {
                          mode: "singleRow",
                          enableClickSelection: false,
                        },
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        );
      case "Metadata Configuration":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              CONFIGURE METADATA *
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col
                md={3}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <Form.Label className="input-labels">
                  Select fields to map Metadata properties
                </Form.Label>
              </Col>
              <Col
                md={9}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                  justifyContent: "flex-end",
                  gap: "10px",
                }}
              >
                <Button
                  variant="outlined"
                  type="button"
                  color="primary"
                  style={{
                    backgroundColor: "var(--button-background-color)",
                    color: "var(--button-color)",
                    fontSize: "11px",
                    borderRadius: "4px",
                    border: "1px solid #858c94",
                    height: "25px",
                  }}
                  onClick={handleCollapseAll}
                >
                  Collapse All
                </Button>

                <Button
                  variant="outlined"
                  type="button"
                  color="primary"
                  style={{
                    backgroundColor: "var(--button-background-color)",
                    color: "var(--button-color)",
                    fontSize: "11px",
                    borderRadius: "4px",
                    border: "1px solid #858c94",
                    height: "25px",
                  }}
                  onClick={handleExpandeAll}
                >
                  Expand All
                </Button>
              </Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={12}>
                <Accordion activeKey={activeKeys} className="custom-accordion">
                  {metadataFields.map((metadataField, index) => (
                    <div
                      key={
                        metadataField.group[0]?.category ||
                        metadataField.group[0]?.field
                      }
                    >
                      <Accordion.Item
                        eventKey={index.toString()}
                        key={
                          metadataField.group[0]?.category ||
                          metadataField.group[0]?.field
                        }
                        style={{ marginTop: "5px" }}
                      >
                        <Accordion.Header
                          className="accordian-head-bg"
                          onClick={() => handleToggle(index.toString())}
                        >
                          <Form.Check
                            type="checkbox"
                            className="accordinag-heding"
                            label={metadataField.group[0].category}
                            value={metadataField.group[0].categorychecked}
                            checked={metadataField.categorychecked}
                            onChange={() =>
                              handleCategoryCheckboxChange(
                                metadataField.group[0].category,
                                index,
                              )
                            }
                          />
                          {activeKeys?.includes(index.toString()) ? (
                            <IndeterminateCheckBoxIcon className="accordian-icons" />
                          ) : (
                            <AddBoxIcon className="accordian-icons" />
                          )}
                        </Accordion.Header>
                        <Accordion.Body>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "space-between",
                            }}
                          >
                            {metadataField.group.map((groupItem: any) => (
                              <div
                                key={`${groupItem.field}@`}
                                style={{
                                  flex: "0 0 calc(25% - 20px)",
                                  marginBottom: "20px",
                                }}
                              >
                                <Row>
                                  <Col md={12}>
                                    <strong>
                                      <Form.Check
                                        id={`Chk${groupItem.field}`}
                                        type="checkbox"
                                        label={`${groupItem.field} @`}
                                        checked={groupItem.active}
                                        value={groupItem.active}
                                        onChange={(event) =>
                                          handleDetailCheckboxChange(
                                            `Chk${groupItem.field}`,
                                            event,
                                          )
                                        }
                                      />
                                    </strong>
                                    <Form.Control
                                      type="text"
                                      placeholder=""
                                      style={{
                                        width: "20em",
                                        marginRight: "10px",
                                      }}
                                    />
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </div>
                  ))}
                </Accordion>
              </Col>
            </Row>
          </div>
        );
      case "Help Documents":
        return (
          <div>
            <h4
              className="form-heading"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              HELP Documents
            </h4>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col
                md={3}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <Form.Label className="input-labels">
                  Select fields to map Metadata properties
                </Form.Label>
              </Col>
              <Col
                md={9}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                  justifyContent: "flex-end",
                }}
              ></Col>
            </Row>
            <Row
              className="mb-3"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "11px",
              }}
            >
              <Col md={3}>
                <Form.Label className="input-labels">
                  Document Name{" "}
                  <span style={{ color: "var(--aggrid-text-color)" }}>*</span>
                </Form.Label>
                <Tooltip title="Please Enter the Document Name" arrow>
                  <Form.Control
                    type="text"
                    placeholder="Enter the Document Name"
                    value={helpDocName}
                    onChange={handleHelpDocNameChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
                {validationHelpDocName && (
                  <Form.Text style={{ color: "var(--aggrid-text-color)" }}>
                    {validationHelpDocName}
                  </Form.Text>
                )}
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Description{" "}
                  <span style={{ color: "var(--aggrid-text-color)" }}>*</span>
                </Form.Label>
                <Tooltip title="Please Enter the Description" arrow>
                  <Form.Control
                    type="text"
                    placeholder="Enter the Description"
                    value={helpDocDescription}
                    onChange={handleHelpDocDescriptionChange}
                    style={{ fontSize: "11px" }}
                  />
                </Tooltip>
                {validationHelpDocDescription && (
                  <Form.Text style={{ color: "var(--aggrid-text-color)" }}>
                    {validationHelpDocDescription}
                  </Form.Text>
                )}
              </Col>
              <Col md={3}>
                <Form.Label className="input-labels">
                  Upload Files{" "}
                  <span style={{ color: "var(--aggrid-text-color)" }}>*</span>
                </Form.Label>
                <div className="form-inp col-sm-12">
                  <input
                    type="file"
                    multiple
                    onChange={handelSelectHelpDocumentFiles}
                    style={{
                      display: "none",
                    }}
                    id="file-upload-input"
                  />
                  <label htmlFor="file-upload-input">
                    <Tooltip title="Click to upload the document" arrow>
                      <Button
                        style={{
                          textTransform: "none",
                          borderRadius: "0px",
                          backgroundColor: "var(--button-background-color)",
                          color: "var(--button-color)",
                          fontSize: "11px",
                          padding: "5px 12px",
                          border: "1px solid #144979",
                          margin: "0px 15px 15px 5px",
                          whiteSpace: "white-space",
                          width: "180%",
                          height: "30px",
                        }}
                      >
                        Select file(s)
                      </Button>
                    </Tooltip>
                  </label>
                </div>
                {validationMessage && (
                  <Form.Text style={{ color: "var(--aggrid-text-color)" }}>
                    {validationMessage}
                  </Form.Text>
                )}
              </Col>
            </Row>
            <Row
              className="mb-12"
              style={{
                color: "var(--aggrid-text-color)",
                fontSize: "12px",
              }}
            >
              <Col md={12}>
                {/* Ag-Grid */}
                <div className="form-inp col-sm-12">
                  <div
                    className="ag-theme-quartz-dark"
                    style={{
                      height: "20vh",
                      width: "100%",
                      marginTop: "10px",
                    }}
                  >
                    <AgGridReact
                      rowData={helpDocRowData}
                      columnDefs={columnDefDocumentTab}
                      headerHeight={25}
                      gridOptions={{
                        rowSelection: {
                          mode: "singleRow",
                          enableClickSelection: false,
                        },
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        );
      default:
        return <div>Unknown Step</div>;
    }
  };

  const getAccountData = async (retryCount: number = 3) => {
    try {
      setLoading(true);
      const params: AccountModel = {
        AccountId: undefined,
        AccountName: undefined,
        Active: undefined,
        LogoPath: undefined,
        IsDefault: undefined,
        AccountCode: undefined,
        CanExpandLevel: undefined,
        Timezone: undefined,
        IsDashboard: undefined,
        FolderRights: undefined,
        UserId: undefined,
        PrimaryGroupId: undefined,
        IsSuperAdmin: undefined,
        BusinessUnitId: businessUnitId,
        ContextName: contextName,
        CanPrefixLevel1: undefined,
        IsUserPreferences: undefined,
        PsuedoName: undefined,
        ApiKey: undefined,
        ServiceName: undefined,
      };
      const response = await GetAccountDetails(params);

      if (response) {
        getActiveFileLocation(businessUnitId, contextName);
        getMetadataColumns(businessUnitId, contextName);
        //#region Basic Information Tab 1
        if (response.basicAccountDetail !== null) {
          setBasicAccountDetails(response.basicAccountDetail);
          updateStepsBasedOnAccount(response.basicAccountDetail.processStages);
          setProcessStages(response.basicAccountDetail.processStages);
          setProcessAllStage(response.basicAccountDetail.processAllStages);
          setResponsedAccountId(response.basicAccountDetail.accountId);
          getAccountLogo(response.basicAccountDetail.accountId);
          setSelectedAccountDetails(response);
          setAccountName(response.basicAccountDetail.accountName);
          setCustomerCode(response.basicAccountDetail.accountCode);
          setApiKeys(response.basicAccountDetail.apiKey);
          setContactName(response.basicAccountDetail.contactName);
          setContactPhoneNumber(response.basicAccountDetail.phone);
          setContactEmail(response.basicAccountDetail.email);
          setIsMenuExpand(response.basicAccountDetail.canExpandLevel);
          setIsDashboardCountShow(response.basicAccountDetail.isDashBoard);
          setIsFolderAccessRightsShow(
            response.basicAccountDetail.isFolderRights,
          );
          setIsPasswordNotificationShow(
            response.basicAccountDetail.isPasswordNotification,
          );
          setIsUserPreferencesShow(
            response.basicAccountDetail.isUserPreferences,
          );
          setPasswordNotificationDays(
            response.basicAccountDetail.userPasswordNotification,
          );
          setUserExpiryNoticationDays(
            response.basicAccountDetail.userExpireNotification,
          );
          setDashboardInterval(response.basicAccountDetail.dashboardInterval);
          setAvailableFolderData(
            response.basicAccountDetail.fundFolder.availableFundFolders,
          );
          setEnabledFolderData(
            response.basicAccountDetail.fundFolder.enabledFundFolders,
          );
          setIsLevelOneCheck(response.basicAccountDetail.canPrefixLevel1);
        }

        //#endregion

        //#region Prework Tab 2
        if (response.accountPreWorks !== null) {
          setPreworkAccountDetails(response.accountPreWorks);
          setResponsedAccountPreworkId(
            response.accountPreWorks.accountPreworkId,
          );
          setIsSecondrayPreFlightEnable(
            response.accountPreWorks.isSecondrayPreFlightEnable,
          );
          setDocIdFormat(response.accountPreWorks.docIdNomenclature);
          setIsFtpFolderEnable(response.accountPreWorks.ftpFolderEnable);
          setIsPdfEnable(response.accountPreWorks.pdfType);
          setIsExcelEnable(response.accountPreWorks.exceltype);
          setIsWordEnable(response.accountPreWorks.wordDocType);
          setFileSize(response.accountPreWorks.fileSize);
          setIsOtherFileFormat(!!response.accountPreWorks.otherFileType);
          setOtherFileType(response.accountPreWorks.otherFileType);
          setEnableUIUpload(response.accountPreWorks.enableUIUpload);
          setFtpSourceFTPLocationId(
            response.accountPreWorks.ftpSourceFTPLocationId,
          );
          setLocalShareFTPLocationId(
            response.accountPreWorks.localShareFTPLocationId,
          );
          setSecondaryPreflightFTPLocationId(
            response.accountPreWorks.secondaryPreflightFTPLocationId,
          );
          setFromPreflightFTPLocationId(
            response.accountPreWorks.fromPreflightFTPLocationId,
          );
          setFinalFolderFTPLocationId(
            response.accountPreWorks.finalFolderFTPLocationId,
          );
          setIsTriggerProofWorkFlowEnabled(
            response.accountPreWorks.isTriggerProofWorkFlowEnabled,
          );
          setIsTriggerProdWorkFlowEnabled(
            response.accountPreWorks.isTriggerProdWorkFlowEnabled,
          );
          setTriggerProofExport1LocationId(
            response.accountPreWorks.triggerProofExport1LocationId,
          );
          setTriggerProofExport2LocationId(
            response.accountPreWorks.triggerProofExport2LocationId,
          );
          setProofExp1CanprefixjobCode(
            response.accountPreWorks.proofExp1CanprefixjobCode,
          );
          setProofExp2CanprefixjobCode(
            response.accountPreWorks.proofExp2CanprefixjobCode,
          );
          setTriggerProofExport3LocationId(
            response.accountPreWorks.triggerProofExport3LocationId,
          );
          setTriggerProofExport3Naming(
            response.accountPreWorks.triggerProofExport3Naming,
          );
          setTriggerProofExport3MetaDataDefinitionId(
            response.accountPreWorks.triggerProofExport3MetaDataDefinitionId,
          );
          setTriggerProofExport4LocationId(
            response.accountPreWorks.triggerProofExport4LocationId,
          );
          setTriggerProofExport4Naming(
            response.accountPreWorks.triggerProofExport4Naming,
          );
          setTriggerProofExport4MetaDataDefinitionId(
            response.accountPreWorks.triggerProofExport4MetaDataDefinitionId,
          );
          setTriggerProofExport3ReturnLocationId(
            response.accountPreWorks.triggerProofExport3ReturnLocationId,
          );
          setTriggerProofExport3ReturnArchivalLocationId(
            response.accountPreWorks
              .triggerProofExport3ReturnArchivalLocationId,
          );
          setTriggerProofExport4ReturnLocationId(
            response.accountPreWorks.triggerProdExport1LocationId,
          );
          setTriggerProdExport1LocationId(
            response.accountPreWorks.triggerProdExport1LocationId,
          );
          setProdExp1CanprefixjobCode(
            response.accountPreWorks.prodExp1CanprefixjobCode,
          );
          setTriggerProdExport2LocationId(
            response.accountPreWorks.triggerProdExport2LocationId,
          );
          setProdExp2CanprefixjobCode(
            response.accountPreWorks.prodExp2CanprefixjobCode,
          );
          setTriggerProdExport3LocationId(
            response.accountPreWorks.triggerProdExport3LocationId,
          );
          setTriggerProdExport3Naming(
            response.accountPreWorks.triggerProdExport3Naming,
          );
          setTriggerProdExport3MetaDataDefinitionId(
            response.accountPreWorks.triggerProdExport3MetaDataDefinitionId,
          );
          setTriggerProdExport4LocationId(
            response.accountPreWorks.triggerProdExport4LocationId,
          );
          setToPreFlightFileNameConvention(
            response.accountPreWorks.toPreFlightFileNameConvention,
          );
          setFromPreFlightFileNameConvention(
            response.accountPreWorks.fromPreFlightFileNameConvention,
          );
          setPreworkEmailRequired(
            response.accountPreWorks.preworkEmailRequired,
          );
          setIsAllowReprocess(response.accountPreWorks.isAllowReprocess);
          setPrintReadyEmailRequired(
            response.accountPreWorks.printReadyEmailRequired,
          );
          setPrimaryPreflightReturnEmailRequired(
            response.accountPreWorks.primaryPreflightReturnEmailRequired,
          );
          setExportToFinalEmailRequired(
            response.accountPreWorks.exportToFinalEmailRequired,
          );
          setPreworkWarningEmailRequired(
            response.accountPreWorks.preworkWarningEmailRequired,
          );
          setPreworkExpirationEmailRequired(
            response.accountPreWorks.preworkExpirationEmailRequired,
          );
          setDocumentRenameEmailRequired(
            response.accountPreWorks.documentRenameEmailRequired,
          );
          setDocumentRejectEmailRequired(
            response.accountPreWorks.documentRejectEmailRequired,
          );
          setDocumentDeleteEmailRequired(
            response.accountPreWorks.documentDeleteEmailRequired,
          );
          setTriggerProofExport1EmailRequired(
            response.accountPreWorks.triggerProofExport1EmailRequired,
          );
          setTriggerProofExport2EmailRequired(
            response.accountPreWorks.triggerProofExport2EmailRequired,
          );
          setTriggerProofExport3EmailRequired(
            response.accountPreWorks.triggerProofExport3EmailRequired,
          );
          setTriggerProofExport4EmailRequired(
            response.accountPreWorks.triggerProofExport4EmailRequired,
          );
          setTriggerProofExport3ReturnEmailRequired(
            response.accountPreWorks.triggerProofExport3ReturnEmailRequired,
          );
          setTriggerProofExport4ReturnEmailRequired(
            response.accountPreWorks.triggerProofExport4ReturnEmailRequired,
          );
          setTriggerProdExport1EmailRequired(
            response.accountPreWorks.triggerProdExport1EmailRequired,
          );
          setTriggerProdExport2EmailRequired(
            response.accountPreWorks.triggerProdExport2EmailRequired,
          );
          setTriggerProdExport3EmailRequired(
            response.accountPreWorks.triggerProdExport3EmailRequired,
          );
          setTriggerProdExport4EmailRequired(
            response.accountPreWorks.triggerProdExport4EmailRequired,
          );
          setPreworkRowData(response.accountPreWorks.preworkInstruction);
        }
        //#endregion

        // #region Downstream Summary Tab 3
        if (response.accountDownStreams !== null) {
          setResponsedAccountDownStreamId(
            response.accountDownStreams.accountDownStreamId,
          );
          setDownstreamAccountDetails(response.accountDownStreams);
          setMetaddataSourceDefinitions(response.activeDocIdFieldNames);
          setIsDAOEnabled(response.accountDownStreams.isDAOEnabled);
          setIsDSAEnabled(response.accountDownStreams.isDSAEnabled);
          if (
            response.accountDownStreams.daOoldProcessEnabled === true ||
            response.accountDownStreams.daoNewProcessEnabled === true
          ) {
            setIsPDFExportLocation3DownstreamShow(true);
          }

          if (
            response.accountDownStreams.newProcessPdfEnabled === true ||
            response.accountDownStreams.newProcessPdfMetadataEnabled === true
          ) {
            setIsNewProcessPDFExportLocation3DownstreamShow(true);
          }

          setIsNoSubProcessEnabled(
            response.accountDownStreams.isNoSubProcessEnabled,
          );
          setIsNewProcessEnabled(
            response.accountDownStreams.isNewProcessEnabled,
          );
          setIsNewProcessPdfEnabled(
            response.accountDownStreams.newProcessPdfEnabled,
          );
          setIsNewProcessPdfMetadataEnabled(
            response.accountDownStreams.newProcessPdfMetadataEnabled,
          );
          setIsPdfSplitEnabled(response.accountDownStreams.isPdfSplitEnabled);
          setIsBulkUploadEnabled(
            response.accountDownStreams.isBulkUploadEnabled,
          );
          setNewProcessExportFTPLocationId(
            response.accountDownStreams.newProcessExportFTPLocationId,
          );
          setNewProcessExportNamingConvention(
            response.accountDownStreams.newProcessExportNamingConvention,
          );
          setPdfSourceFTPLocationId(
            response.accountDownStreams.pdfSourceFTPLocationId,
          );
          setPdfArchiveFTPLocationId(
            response.accountDownStreams.pdfArchiveFTPLocationId,
          );
          setMetadataSourceFTPLocationId(
            response.accountDownStreams.metadataSourceFTPLocationId,
          );
          setMetadataArchiveFTPLocationId(
            response.accountDownStreams.metadataArchiveFTPLocationId,
          );
          setSourceIngestionMetadtaDefinitionID(
            response.accountDownStreams.sourceIngestionMetadtaDefinitionID,
          );
          setHasHeader(response.accountDownStreams.hasHeader);
          setDaoExportNamingConvention(
            response.accountDownStreams.daoExportNamingConvention,
          );
          setToSecondaryFTPLocationId(
            response.accountDownStreams.toSecondaryFTPLocationId,
          );
          setFromSecondaryFTPLocationId(
            response.accountDownStreams.fromSecondaryFTPLocationId,
          );
          setFromSecondaryArchiveFTPLocationId(
            response.accountDownStreams.fromSecondaryArchiveFTPLocationId,
          );
          setExportFilenameWithoutUnderscore(
            response.accountDownStreams.exportFilenameWithoutUnderscore,
          );
          setDaoReturnMetadataDefinitionID(
            response.accountDownStreams.daoReturnMetadataDefinitionID,
          );
          setToDownSampleFTPLocationId(
            response.accountDownStreams.toDownSampleFTPLocationId,
          );
          setFromDownSamplingFTPLocationId(
            response.accountDownStreams.fromDownSamplingFTPLocationId,
          );
          setFromDownSamplingArchiveFTPLocationId(
            response.accountDownStreams.fromDownSamplingArchiveFTPLocationId,
          );
          setDsaReturnMetadataDefinitionID(
            response.accountDownStreams.dsaReturnMetadataDefinitionID,
          );
          setWebReadyFtpLocationId(
            response.accountDownStreams.webReadyFtpLocationId,
          );
          setWebReadyArchiveFtpLocationId(
            response.accountDownStreams.webReadyArchiveFtpLocationId,
          );
          setExportFtpLocationId(
            response.accountDownStreams.exportFtpLocationId,
          );
          setIsDSAllowReprocess(response.accountDownStreams.isAllowReprocess);
          setDisplayRuleMappingId(
            response.accountDownStreams.displayRuleMappingId,
          );
          setRecentRecordDays(response.accountDownStreams.recentRecordDays);
          setIndexFileProcessedMailRequired(
            response.accountDownStreams.indexFileProcessedMailRequired,
          );
          setExportSecondaryPreFlightMailRequired(
            response.accountDownStreams.exportSecondaryPreFlightMailRequired,
          );
          setSecondaryPreFlightReturnMailRequired(
            response.accountDownStreams.secondaryPreFlightReturnMailRequired,
          );
          setSecondaryPreFlightWarningMailRequired(
            response.accountDownStreams.secondaryPreFlightWarningMailRequired,
          );
          setSecondaryPreflightFailureRequired(
            response.accountDownStreams.secondaryPreflightFailureRequired,
          );
          setExportDownSampleMailRequired(
            response.accountDownStreams.exportDownSampleMailRequired,
          );
          setDownStreamReturnMailRequired(
            response.accountDownStreams.downStreamReturnMailRequired,
          );
          setDownsampleWarningMailRequired(
            response.accountDownStreams.downsampleWarningMailRequired,
          );
          setDownsampleFailureMailRequired(
            response.accountDownStreams.downsampleFailureMailRequired,
          );
          setMetadataRejectedReasonsMailRequired(
            response.accountDownStreams.metadataRejectedReasonsMailRequired,
          );
          setDownStreamExportRules(
            response.accountDownStreams.downStreamExportRules,
          );
          //Fund folder
          const initialCheckedItems =
            response.accountDownStreams.downStreamExportRules.map(
              (rule: { downStreamExportRuleId: number }) =>
                rule.downStreamExportRuleId,
            );
          setCheckedItems(initialCheckedItems);

          setLevel(response.accountDownStreams.level1Folder);
        }

        // #endregion

        // #region e-Delivery Tab 4
        if (response.accountEDeliveries !== null) {
          setEdeliveryAccountDetails(response.accountEDeliveries);
          setAccountEdeliveryId(response.accountEDeliveries.accountEdeliveryId);
          setEDeliveryFtpLocationId(
            response.accountEDeliveries.eDeliveryFtpLocationId,
          );
          setFundFolderType(response.accountEDeliveries.fundFolderType);
          setSecondaryeDeliveryFTPLocationId(
            response.accountEDeliveries.secondaryeDeliveryFTPLocationId,
          );
          setSecondaryFundFolderType(
            response.accountEDeliveries.secondaryFundFolderType,
          );
          setPrintReadyEdeliveryReturnFTPLocationId(
            response.accountEDeliveries.printReadyEdeliveryReturnFTPLocationId,
          );
          setWebReadyEdeliveryReturnFTPLocationId(
            response.accountEDeliveries.webReadyEdeliveryReturnFTPLocationId,
          );
          setPrintReadyEdeliveryReturnArchiveFTPLocationId(
            response.accountEDeliveries
              .printReadyEdeliveryReturnArchiveFTPLocationId,
          );
          setWebReadyEdeliveryReturnArchiveFTPLocationId(
            response.accountEDeliveries
              .webReadyEdeliveryReturnArchiveFTPLocationId,
          );
          setEdeliveryReturnPrintReadyMetadataDefinitionID(
            response.accountEDeliveries
              .edeliveryReturnPrintReadyMetadataDefinitionID,
          );
          setEdeliveryReturnWebreadyMetadatadefinitionID(
            response.accountEDeliveries
              .edeliveryReturnWebreadyMetadatadefinitionID,
          );
          setEdeliveryReturn(response.accountEDeliveries.edeliveryReturn);
          setSecondaryEmailexportRequired(
            response.accountEDeliveries.secondaryEmailexportRequired,
          );
          setExportEmailRequired(
            response.accountEDeliveries.exportEmailRequired,
          );
          setSecondaryFileNameConvention(
            response.accountEDeliveries.secondaryFileNameConvention,
          );
          setEdeliveryFileNameConvention(
            response.accountEDeliveries.edeliveryFileNameConvention,
          );
          setFrequencyHrs(response.accountEDeliveries.frequencyHrs);
          setFrequencyMins(response.accountEDeliveries.frequencyMins);
        }

        // #endregion

        // #region Active DocID Export Tab 5
        if (response.accountActiveDocExports !== null) {
          setActiveDocIdExportAccountDetails(response.accountActiveDocExports);
          setSearchCriterias(
            response.accountActiveDocExports.activeDocIdQuery?.searchCriterias,
          );
          setSearchCriteriaID(
            response.accountActiveDocExports.searchCriteriaID,
          );
          setFieldValue(response.accountActiveDocExports.fieldValue);
          setAccountActiveDocExportId(
            response.accountActiveDocExports.accountActiveDocExportId,
          );
          setExportDocFTPLocationId(
            response.accountActiveDocExports.exportDocFTPLocationId,
          );
          setExportDocFTPLocationId2(
            response.accountActiveDocExports.exportDocFTPLocationId2,
          );
          setExportDocFTPLocationId3(
            response.accountActiveDocExports.exportDocFTPLocationId3,
          );
          setExportEmailRequiredActiveDocId(
            response.accountActiveDocExports.exportEmailRequired,
          );
          setExportFileNameConvention(
            response.accountActiveDocExports.exportFileNameConvention,
          );
          setExportFrequencyHour(
            response.accountActiveDocExports.exportFrequencyHour,
          );
          setExportFrequencyMin(
            response.accountActiveDocExports.exportFrequencyMin,
          );
        }

        // #endregion

        // #region Archival Report Tab 6
        if (response.accountArchives !== null) {
          setArchivalReportAccountDetails(response.accountArchives);
          setArchivalFolderConfigId(
            response.accountArchives.archivalFolderConfigId,
          );

          setArchivalLocationId(response.accountArchives.archivalLocationId);
          setArchivalFileNameConvention(
            response.accountArchives.archivalFileNameConvention,
          );
          setArchivalEmailRequired(
            response.accountArchives.archivalEmailRequired,
          );
          setArchivalReqApprovalEmailRequired(
            response.accountArchives.archivalReqApprovalEmailRequired,
          );
          setExportFolderData(response.accountArchives.archiveLevelRules);

          //Fund folder Web ready
          const initialCheckedItemsWebready =
            response.accountArchives.archiveLevelRules
              .filter(
                (rule: { isEnabled: boolean; archivalLevelId: number }) =>
                  rule.isEnabled === true,
              )
              .map((rule: { archivalLevelId: number }) => rule.archivalLevelId);
          setCheckedItemsArchiveWebReady(initialCheckedItemsWebready);

          //Fund folder Print ready
          const initialCheckedItemsPrintready =
            response.accountArchives.archiveLevelRules
              .filter(
                (rule: { isEnabled: boolean; archivalLevelId: number }) =>
                  rule.isEnabled === false,
              )
              .map((rule: { archivalLevelId: number }) => rule.archivalLevelId);
          setCheckedItemsArchivePrintReady(initialCheckedItemsPrintready);
        }

        // #endregion

        // #region Turbo Proofs Tab 7
        if (
          response.accountCustomProcesses !== null &&
          response.accountCustomProcesses.length > 0
        ) {
          setTurboProofsAccountDetails(response.accountCustomProcesses[0]);
          setAccountCustomProcessId(
            response.accountCustomProcesses[0].accountCustomProcessId,
          );
          setProcessStageId(response.accountCustomProcesses[0].processStageId);
          setFundFolderId(
            response.accountCustomProcesses[0].folderLevels[0].level1.folderId,
          );
          setTurboCanFTPFolderUpload(
            response.accountCustomProcesses[0].canFTPFolderUpload,
          );
          setTurboPdfType(response.accountCustomProcesses[0].pdfType);
          setTurboExcelType(response.accountCustomProcesses[0].exceltype);
          setTurboWordDocType(response.accountCustomProcesses[0].wordDocType);
          setTurbofileSize(response.accountCustomProcesses[0].fileSize % 1024);
          setTurboEnableUIUpload(
            response.accountCustomProcesses[0].enableUIUpload,
          );
          setTurboftpSourceLocationId(
            response.accountCustomProcesses[0].ftpSourceLocationId,
          );
          setRowDataTurbo(response.accountCustomProcesses[0].folderLevels);
        }
        // #endregion

        // #region Post work tab 8
        if (
          response.accountCustomProcesses !== null &&
          response.accountCustomProcesses.length > 0
        ) {
          setPostWorkAccountDetails(response.accountCustomProcesses[1]);
          setPostworkAccountCustomProcessId(
            response.accountCustomProcesses[1].accountCustomProcessId,
          );
          setPostworkProcessStageId(
            response.accountCustomProcesses[1].processStageId,
          );
          setPostworkfundFolderId(
            response.accountCustomProcesses[1].folderLevels[0].level1.folderId,
          );
          setPostWorkCanFTPFolderUpload(
            response.accountCustomProcesses[1].canFTPFolderUpload,
          );
          setPostWorkPdfType(response.accountCustomProcesses[1].pdfType);
          setPostWorkExceltype(response.accountCustomProcesses[1].exceltype);
          setPostWorkWordDocType(
            response.accountCustomProcesses[1].wordDocType,
          );
          setPostWorkfileSize(
            response.accountCustomProcesses[1].fileSize % 1024,
          );
          setPostWorkEnableUIUpload(
            response.accountCustomProcesses[1].enableUIUpload,
          );
          setPostWorkftpSourceLocationId(
            response.accountCustomProcesses[1].ftpSourceLocationId,
          );
          setRowDataPostWork(response.accountCustomProcesses[1].folderLevels);
        }

        // #endregion

        // #region Metadata Configuration Tab 9
        if (response.metaDataFields !== null) {
          setMetadataFields(response.metaDataFields);
        }
        // #endregion

        // #region Help Documents Tab 10
        if (response.helpDoc !== null) {
          setHelpDocumentId(response.helpDoc[0].helpDocumentId);
          setHelpDocRowData(response.helpDoc);
        }
        // #endregion
      }
    } catch (error: any) {
      if (
        (error.response?.status === 500 ||
          error.response?.status === undefined) &&
        retryCount > 0
      ) {
        await getAccountData(retryCount - 1);
      } else {
        showSnackbar("Error getting account data: " + error.message, true);
      }
    } finally {
      setLoading(false);
    }
  };

  const getAccountLogo = async (selectedAccountId: number) => {
    try {
      const params: AccountModel = {
        AccountId: selectedAccountId,
        AccountName: undefined,
        Active: undefined,
        LogoPath: undefined,
        IsDefault: undefined,
        AccountCode: undefined,
        CanExpandLevel: undefined,
        Timezone: undefined,
        IsDashboard: undefined,
        FolderRights: undefined,
        UserId: undefined,
        PrimaryGroupId: undefined,
        IsSuperAdmin: undefined,
        BusinessUnitId: undefined,
        ContextName: contextName,
        CanPrefixLevel1: undefined,
        IsUserPreferences: undefined,
        PsuedoName: undefined,
        ApiKey: undefined,
        ServiceName: undefined,
      };
      const response = await GetAccountLogo(params);
      if (response) {
        setLogoBase64(response);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      console.log("Logo fetched successfully");
    }
  };

  //#region  Basic tinformation tab- Next button event

  const handleAddRow = () => {
    setRows([...rows, { name: "", phoneNumber: "", email: "" }]);
  };

  const handleRemoveRow = (index: number) => {
    const newRows = rows.filter((_, rowsIndex) => rowsIndex !== index);
    setRows(newRows);
  };

  const getClientData = async () => {
    try {
      setLoading(true);
      const response = await GetClients();
      if (response) {
        setClientName(response);
        getMetadataColumns(businessUnitId, contextName);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const getFolderData = async () => {
    setLoading(true);
    try {
      let folderRightsModel = {
        AccountId: 0,
        FolderRights: "",
        SuperAdmin: 0,
        UserId: 0,
        FolderId: 0,
        BusinessUnitId: selectedClientId,
        DepthPath: "",
        ContextName: contextName,
      };
      const response = await GetFolders(folderRightsModel);
      if (response) {
        setAvailableFolderData(response.availableFundFolders);
        setEnabledFolderData(response.enabledFundFolders);
      }
    } catch (error) {
      console.error("Error in getFolderData to fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAccountNameChange = async (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    try {
      setLoading(true);
      selectedClientId = Number(event.target.value);
      if (selectedClientId > 0) {
        setValidationClientId(null);
        setClientId(selectedClientId);
        const response = await GetClientDetails(selectedClientId);
        setLogoBase64(response.logo);
        setCustomerCode(response.accountCode);
        setApiKeys(response.apiKey);
        getFolderData();
      } else {
        setClientId(0);
      }
    } catch (error) {
      console.error("Error in handleAccountNameChange", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setCustomerCode(value);
      setValidationCustomerCode(null);
    } else {
      setCustomerCode("");
    }
  };

  const handleApiKeyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setApiKeys(value);
      setValidationApiKeys(null);
    } else {
      setApiKeys("");
    }
  };

  const handleContactNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setContactName(value);
      setValidationContactName(null);
    } else {
      setContactName("");
    }
  };

  const handleContactPhoneChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setContactPhoneNumber(value);
      setValidationContactPhoneNumber(null);
    } else {
      setContactPhoneNumber("");
    }
  };

  const handleContactEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    const emailRegex =
      /^(?:[a-zA-Z0-9._%+-]+)@(?:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;

    if (value !== undefined && value !== "") {
      if (emailRegex.test(value)) {
        setContactEmail(value);
        setValidationContactEmail(null);
      } else {
        setContactEmail(value);
        setValidationContactEmail("Invalid email format");
      }
    } else {
      setContactEmail("");
      setValidationContactEmail("Email is required");
    }
  };

  const handleDynamicContactNameChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      const updateRow = [...rows];
      updateRow[index].name = value;
      setRows(updateRow);
    }
  };

  const handleDynamicContactPhoneChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      const updateRow = [...rows];
      updateRow[index].phoneNumber = value;
      setRows(updateRow);
    }
  };

  const handleDynamicContactEmailChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      const updateRow = [...rows];
      updateRow[index].email = value;
      setRows(updateRow);
    }
  };

  const handlePasswordNotificationDaysChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      // Only allow numeric values
      if (Number(value) > 30) {
        setValidationPasswordNotificationDays(
          "Password Notification Days should not exceed 30 days",
        );
        setPasswordNotificationDays("");
      } else {
        setValidationPasswordNotificationDays(null);
        setPasswordNotificationDays(value);
      }
    }
  };

  const handleUserExpirydNotificationDaysChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      // Only allow numeric values
      if (Number(value) > 30) {
        setValidationUserExpireNotificationDays(
          "Password Notification Days should not exceed 30 days",
        );
        setUserExpiryNoticationDays("");
      } else {
        setValidationUserExpireNotificationDays(null);
        setUserExpiryNoticationDays(value);
      }
    }
  };

  const handleDashboardIntervalChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      if (Number(value) > 60) {
        setValidationDashboardInterval(
          "Please note maximum number of seconds allowed is 60",
        );
        setDashboardInterval("");
      } else {
        setValidationDashboardInterval(null);
        setDashboardInterval(value);
      }
    }
  };

  const handleCustmerNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setAccountName(value);
    } else {
      setAccountName("");
    }
  };

  const handleDownloadByDefaultChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsDownloadByDefault(value);
  };

  const handleLevelOneCheckChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsLevelOneCheck(value);
  };

  const handleMenuExpandChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsMenuExpand(value);
  };

  const handleDashboardCountChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsDashboardCountShow(value);
  };

  const handleFolderAccessRightsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsFolderAccessRightsShow(value);
  };

  const handlePasswordNotificationChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsPasswordNotificationShow(value);
  };

  const handleUserPreferencesChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsUserPreferencesShow(value);
  };

  const handelUploadIcon = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    let selectedFiles: File[] = [];
    if (files) {
      selectedFiles = Array.from(files).filter(
        (file) =>
          file.name.toLowerCase().endsWith(".png") ||
          file.name.toLowerCase().endsWith(".jpeg") ||
          file.name.toLowerCase().endsWith(".jpg") ||
          file.name.toLowerCase().endsWith(".gif") ||
          file.name.toLowerCase().endsWith(".tiff"),
      );
      if (selectedFiles.length > 0) {
        const file = selectedFiles[0];
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64 = e.target?.result;
          setLogoBase64(base64 as string);
        };
        reader.readAsDataURL(file);
      } else {
        showSnackbar("Please select a .png|.jpeg|.gif|.jpg|.tiff file", true);
      }
    }
  };

  const handleResetFundFolder = () => {
    getFolderData();
  };
  //#endregion

  //#region  Prework tab 2

  //Action Cell Renderer
  const preworkActionCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <Tooltip title="Click to Delete" placement="top" arrow>
          <IconButton
            style={{ padding: "2px" }}
            onClick={() => handelDeleteRowPrework(params.data.fileName)}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      );
    }
  };

  //Defined grid column
  const [columnDefPrework] = useState<ColDef[]>([
    {
      headerName: "#",
      field: "id",
      sortable: true,
      filter: true,
      resizable: true,
      width: 100,
      valueGetter: (params: any) => {
        return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
      },
    },
    {
      headerName: "Instruction Name",
      field: "instructionName",
      sortable: true,
      filter: true,
      resizable: true,
      width: 300,
    },
    {
      headerName: "File Name",
      field: "fileName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "File Size",
      field: "fileSize",
      sortable: true,
      filter: true,
      resizable: true,
      width: 200,
      valueFormatter: (params: any) => {
        return params.value
          ? Math.round(params.value / 1024).toLocaleString() + " KB"
          : "";
      },
    },
    {
      headerName: "Uploaded On",
      field: "createdDate",
      sortable: true,
      filter: true,
      resizable: true,
      width: 200,
      valueFormatter: (params) => {
        return params.value
          ? moment.utc(params.value).local().format("MM-DD-YYYY HH:mm:ss")
          : "";
      },
    },
    {
      headerName: "Action",
      width: 110,
      sortable: false,
      resizable: false,
      cellRenderer: preworkActionCellRenderer,
    },
  ]);

  //Handle delete row
  const handelDeleteRowPrework = (fileName: string) => {
    setPreworkRowData((prevRowData) =>
      prevRowData.filter((row) => row.fileName !== fileName),
    );
  };

  const getActiveFileLocation = async (
    accountNameId: number,
    accountName: string,
  ) => {
    setLoading(true);
    const payload: any = {
      businessUnitId: Number(accountNameId),
      contextName: accountName,
    };
    try {
      const activeFileLocationData = await GetActiveFileLocation(payload);
      setActiveFileLocations(activeFileLocationData);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const getMetadataColumns = async (
    businessUnitId: number,
    databaseName: string,
  ) => {
    setLoading(true);
    const payload: any = {
      businessUnitId: businessUnitId,
      contextName: databaseName,
    };
    try {
      const metadataColumnsData = await GetMetadataColumns(payload);
      setMetadataColumns(metadataColumnsData);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  //Handle select files using open file dialog box
  const handelSelectFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    let selectedFiles: File[] = [];
    if (instructionName === undefined || instructionName === "") {
      setValidationInstructionName("Please enter the Instruction Name");
    } else if (files) {
      selectedFiles = Array.from(files).filter((file) =>
        file.name.toLowerCase().endsWith(".txt"),
      );

      const newRowData = selectedFiles.map((file) => ({
        accountPreworkId: responsedAccountPreworkId,
        preWorkInstructionId: 0,
        instructionName: instructionName,
        fileName: file.name,
        instructionStream: null,
        createdDate: new Date(),
        createdBy: 0,
        fileSize: file.size,
      }));
      if (newRowData.length > 0) {
        setPreworkRowData((prevRowData) => [...prevRowData, ...newRowData]);
        setValidationMessage(null);
        setInstructionName("");
      } else {
        setValidationMessage("Please select only .txt files");
      }
    }
  };

  const handleInstructionNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setInstructionName(value);
      setValidationInstructionName(null);
    } else {
      setValidationInstructionName("Please enter the Instruction Name");
    }
  };

  const handleExportLocation3Show = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4Show(value);
  };

  const handlePDFExportLocation3Hide = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4Show(!value);
  };

  const handlePreworkPreflightChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsSecondrayPreFlightEnable(value);
  };

  const handleDolcIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setDocIdFormat(Number(value));
    } else {
      setDocIdFormat(0);
    }
  };

  const handleFtpFolderUploadChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsFtpFolderEnable(value);
  };

  const handlePdfChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setIsPdfEnable(value);
  };

  const handleExcelChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setIsExcelEnable(value);
  };

  const handleWordDocChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setIsWordEnable(value);
  };

  const handleFileSizeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      if (Number(value) > 1024) {
        setValidationFileSize("File size should not exceed 1024");
        setFileSize("");
      } else {
        setValidationFileSize(null);
        setFileSize(value);
      }
    }
  };

  const handleUIUploadChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setEnableUIUpload(value);
  };

  const handleZipChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    if (value) {
      setIsZipEnable(value);
      setValidationZipFile("Please enter the other File Name");
    } else {
      setOtherFileType("");
      setIsZipEnable(false);
      setValidationZipFile(null);
    }
  };

  const handleOtherFileTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setOtherFileType(value);
      setValidationZipFile(null);
    } else {
      setOtherFileType("");
      setIsZipEnable(false);
    }
  };

  const handleFtpSourceChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFtpSourceFTPLocationId(Number(value));
    } else {
      setFtpSourceFTPLocationId(0);
    }
  };

  const handleLocalShareChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setLocalShareFTPLocationId(Number(value));
    } else {
      setLocalShareFTPLocationId(0);
    }
  };

  const handleToPrimaryPreflightChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setSecondaryPreflightFTPLocationId(Number(value));
    } else {
      setSecondaryPreflightFTPLocationId(0);
    }
  };

  const handleFromPrimaryPreflightChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFromPreflightFTPLocationId(Number(value));
    } else {
      setFromPreflightFTPLocationId(0);
    }
  };

  const handleFinalFolderChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFinalFolderFTPLocationId(Number(value));
    } else {
      setFinalFolderFTPLocationId(0);
    }
  };

  const handleTriggerProofWorkFlowEnabledChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsTriggerProofWorkFlowEnabled(value);
  };

  const handleExportLocation1Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport1LocationId(Number(value));
    } else {
      setTriggerProofExport1LocationId(0);
    }
  };

  const handleExportLocation2Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport2LocationId(Number(value));
    } else {
      setTriggerProofExport2LocationId(0);
    }
  };

  const handleExport1CanPrefixJobCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setProofExp1CanprefixjobCode(value);
  };

  const handleExport2CanPrefixJobCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setProofExp2CanprefixjobCode(value);
  };

  const handleExportLocation3Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport3LocationId(Number(value));
    } else {
      setTriggerProofExport3LocationId(0);
    }
  };

  const handleExportLocation3NamingChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport3Naming(value);
    } else {
      setTriggerProofExport3Naming("");
    }
  };

  const handleExportLocation3MetaDataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport3MetaDataDefinitionId(Number(value));
    } else {
      setTriggerProofExport3MetaDataDefinitionId(0);
    }
  };

  const handleExportLocation4Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport4LocationId(Number(value));
    } else {
      setTriggerProofExport4LocationId(0);
    }
  };

  const handleExportLocation4NamingChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport4Naming(value);
    } else {
      setTriggerProofExport4Naming("");
    }
  };

  const handleExportLocation4MetaDataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport4MetaDataDefinitionId(Number(value));
    } else {
      setTriggerProofExport4MetaDataDefinitionId(0);
    }
  };

  const handleTriggerProofExportLocation3Show = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4ProofShow(value);
  };

  const handleTriggerProofPDFExportLocation3Hide = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4ProofShow(!value);
  };

  const handleExportLocation3ReturnChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport3ReturnLocationId(Number(value));
    } else {
      setTriggerProofExport3ReturnLocationId(0);
    }
  };

  const handleExportLocation3ReturnArchiveChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    setTriggerProofExport3ReturnLocationId(0);
    if (value !== undefined && value !== "") {
      setTriggerProofExport3ReturnLocationId(Number(value));
    } else {
      setTriggerProofExport3ReturnLocationId(0);
    }
  };

  const handleExportLocation4ReturnChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProofExport4ReturnLocationId(Number(value));
    } else {
      setTriggerProofExport4ReturnLocationId(0);
    }
  };

  const handleTriggerProdExportLocation3Show = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4ProdShow(value);
  };

  const handleTriggerProdPDFExportLocation3Hide = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4ProdShow(!value);
  };

  const handleTriggerProdWorkFlowEnabledChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsTriggerProdWorkFlowEnabled(value);
  };

  const handleProdExport1LocationChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProdExport1LocationId(Number(value));
    } else {
      setTriggerProdExport1LocationId(0);
    }
  };

  const handleProdExport2LocationChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProdExport2LocationId(Number(value));
    } else {
      setTriggerProdExport2LocationId(0);
    }
  };

  const handleProdExport1CanPrefixJobCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setProdExp1CanprefixjobCode(value);
  };

  const handleProdExport2CanPrefixJobCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setProdExp2CanprefixjobCode(value);
  };

  const handleProdExport3LocationChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProdExport3LocationId(Number(value));
    } else {
      setTriggerProdExport3LocationId(0);
    }
  };

  const handleProdExport3NamingChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProdExport3Naming(value);
    } else {
      setTriggerProdExport3Naming("");
    }
  };

  const handleProdExport3MetaDataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProdExport3MetaDataDefinitionId(Number(value));
    } else {
      setTriggerProdExport3MetaDataDefinitionId(0);
    }
  };

  const handleProdExport4LocationChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProdExport4LocationId(Number(value));
    } else {
      setTriggerProdExport4LocationId(0);
    }
  };

  const handleExportLocation4Prod2NamingChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProd2Export4Naming(value);
    } else {
      setTriggerProd2Export4Naming("");
    }
  };

  const handleExportLocation4Prod2MetaDataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTriggerProd2Export4MetaDataDefinitionId(Number(value));
    } else {
      setTriggerProd2Export4MetaDataDefinitionId(0);
    }
  };

  const handleTriggerProd2ExportLocation3Show = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4Prod2Show(value);
  };

  const handleTriggerProd2PDFExportLocation3Hide = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsExportLocation3and4Prod2Show(!value);
  };

  const handleToPreFlightFileNameConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setToPreFlightFileNameConvention(value);
    } else {
      setToPreFlightFileNameConvention("");
    }
  };

  const handleFromPreFlightFileNameConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFromPreFlightFileNameConvention(value);
    } else {
      setFromPreFlightFileNameConvention("");
    }
  };

  const handlePreWorkEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setPreworkEmailRequired(value);
    } else {
      setPreworkEmailRequired(false);
    }
  };

  const handleDSAllowReprocessChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setIsDSAllowReprocess(value);
    } else {
      setIsDSAllowReprocess(false);
    }
  };

  const handleExportToPrimaryPreflightChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setPrintReadyEmailRequired(value);
    } else {
      setPrintReadyEmailRequired(false);
    }
  };

  const handlePrimaryPreflightReturnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setPrimaryPreflightReturnEmailRequired(value);
    } else {
      setPrimaryPreflightReturnEmailRequired(false);
    }
  };

  const handleExportToFinalChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setExportToFinalEmailRequired(value);
    } else {
      setExportToFinalEmailRequired(false);
    }
  };

  const handlePreWorkWarningChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setPreworkWarningEmailRequired(value);
    } else {
      setPreworkWarningEmailRequired(false);
    }
  };

  const handlePreWorkExpirationChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setPreworkExpirationEmailRequired(value);
    } else {
      setPreworkExpirationEmailRequired(false);
    }
  };

  const handleDocumentRenameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setDocumentRenameEmailRequired(value);
    } else {
      setDocumentRenameEmailRequired(false);
    }
  };

  const handleDocumentRejectChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setDocumentRejectEmailRequired(value);
    } else {
      setDocumentRejectEmailRequired(false);
    }
  };

  const handleDocumentDeleteChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setDocumentDeleteEmailRequired(value);
    } else {
      setDocumentDeleteEmailRequired(false);
    }
  };

  const handleTriggerProofExport1EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProofExport1EmailRequired(value);
    } else {
      setTriggerProofExport1EmailRequired(false);
    }
  };

  const handleTriggerProofExport2EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProofExport2EmailRequired(value);
    } else {
      setTriggerProofExport2EmailRequired(false);
    }
  };

  const handleTriggerProofExport3EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProofExport3EmailRequired(value);
    } else {
      setTriggerProofExport3EmailRequired(false);
    }
  };

  const handleTriggerProofExport4EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProofExport4EmailRequired(value);
    } else {
      setTriggerProofExport4EmailRequired(false);
    }
  };

  const handleTriggerProofExport3ReturnEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProofExport3ReturnEmailRequired(value);
    } else {
      setTriggerProofExport3ReturnEmailRequired(false);
    }
  };

  const handleTriggerProofExport4ReturnEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProofExport4ReturnEmailRequired(value);
    } else {
      setTriggerProofExport4ReturnEmailRequired(false);
    }
  };

  const handleTriggerProdExport1EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProdExport1EmailRequired(value);
    } else {
      setTriggerProdExport1EmailRequired(false);
    }
  };

  const handleTriggerProdExport2EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProdExport2EmailRequired(value);
    } else {
      setTriggerProdExport2EmailRequired(false);
    }
  };

  const handleTriggerProdExport3EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProdExport3EmailRequired(value);
    } else {
      setTriggerProdExport3EmailRequired(false);
    }
  };

  const handleTriggerProdExport4EmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    if (value !== undefined) {
      setTriggerProdExport4EmailRequired(value);
    } else {
      setTriggerProdExport4EmailRequired(false);
    }
  };

  // #endregion

  //#region Downstream Summary tab 3

  const handleNewProcessChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsNewProcessEnabled(value);
  };

  const handleNewProcessPDFExportLocation3DownstreamHide = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    debugger;
    const value = event.target.checked;
    setIsNewProcessPdfEnabled(value);
    setIsNewProcessPdfMetadataEnabled(!value);
    setIsNewProcessPDFExportLocation3DownstreamShow(!value);
  };

  const handleNewProcessExportLocation3DownstreamShow = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    debugger;
    const value = event.target.checked;
    setIsNewProcessPdfEnabled(!value);
    setIsNewProcessPdfMetadataEnabled(value);
    setIsNewProcessPDFExportLocation3DownstreamShow(value);
  };

  const handleNewProcessPDFExportLocation3Hide = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsPDFExportLocation3DownstreamShow(!value);
  };

  const handleNewProcessExportLocation3Show = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsPDFExportLocation3DownstreamShow(value);
  };

  const handleDAOChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setIsDAOEnabled(value);
  };

  const handleDSAChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setIsDSAEnabled(value);
  };

  const handleNoSubProcessChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsNoSubProcessEnabled(value);
  };

  const handlePdfSplitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setIsPdfSplitEnabled(value);
  };

  const handleBulkUploadChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsBulkUploadEnabled(value);
  };

  const handleLevelChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setLevel(Number(value));
    } else {
      setLevel(0);
    }
  };

  const handleNewProcessExportFolderChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setNewProcessExportFTPLocationId(Number(value));
    } else {
      setNewProcessExportFTPLocationId(0);
    }
  };

  const handleNewProcessExportNamingConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setNewProcessExportNamingConvention(value);
    } else {
      setNewProcessExportNamingConvention("");
    }
  };

  const handleAddExportFolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setExportFolderlevel2(value);
      setValidationExportFolderlevel2(null);
    } else {
      setExportFolderlevel2("");
    }
  };

  const handleAddExportFolder = (
    event: React.MouseEvent<SVGSVGElement, MouseEvent>,
  ) => {
    if (exportFolderlevel2 !== undefined && exportFolderlevel2 !== "") {
      setValidationExportFolderlevel2(null);
      setDownStreamExportRules((prevRules) => [
        ...prevRules,
        {
          downStreamExportRules: prevRules.length + 1,
          ruleName: exportFolderlevel2,
          downStreamExportRuleId: prevRules.length + 1,
        },
      ]);

      setExportFolderlevel2("");
    } else {
      setValidationExportFolderlevel2("Please enter the Export Folder");
    }
  };

  const handleCheckboxChange = (ruleId: number) => {
    setCheckedItems((prevCheckedItems) => {
      if (prevCheckedItems.includes(ruleId)) {
        // If the item is already checked, uncheck it
        return prevCheckedItems.filter((id) => id !== ruleId);
      } else {
        // If the item is not checked, check it
        return [...prevCheckedItems, ruleId];
      }
    });
  };

  const handleDeleteItem = (index: number) => {
    const updatedRules = downStreamExportRules.filter(
      (rule) => rule.downStreamExportRuleId !== index,
    );

    // Update the checked items to remove the deleted item's ID
    const updatedCheckedItems = checkedItems.filter((id) => id !== index);
    // Update the state with the filtered data
    setDownStreamExportRules(updatedRules);
    setCheckedItems(updatedCheckedItems);
  };

  const handlePdfSourceFolderChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPdfSourceFTPLocationId(Number(value));
    } else {
      setPdfSourceFTPLocationId(0);
    }
  };

  const handlePdfArchiveFolderChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPdfArchiveFTPLocationId(Number(value));
    } else {
      setPdfArchiveFTPLocationId(0);
    }
  };

  const handleMetadataSourceFolderChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setMetadataSourceFTPLocationId(Number(value));
    } else {
      setMetadataSourceFTPLocationId(0);
    }
  };

  const handleMetadataArchiveFolderChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setMetadataArchiveFTPLocationId(Number(value));
    } else {
      setMetadataArchiveFTPLocationId(0);
    }
  };

  const handleSourceIngestionMetadataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setSourceIngestionMetadtaDefinitionID(Number(value));
    } else {
      setSourceIngestionMetadtaDefinitionID(0);
    }
  };

  const handleDaoExportNamingConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setDaoExportNamingConvention(value);
    } else {
      setDaoExportNamingConvention("");
    }
  };

  const handleHasHeadeYesrChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setHasHeader(value);
  };

  const handleHasHeaderNoChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setHasHeader(!value);
  };

  const handleToSecondaryPreflightChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setToSecondaryFTPLocationId(Number(value));
    } else {
      setToSecondaryFTPLocationId(0);
    }
  };

  const handleFromSecondaryPreflightChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFromSecondaryFTPLocationId(Number(value));
    } else {
      setFromSecondaryFTPLocationId(0);
    }
  };

  const handleFromSecondaryArchivePreflightChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFromSecondaryArchiveFTPLocationId(Number(value));
    } else {
      setFromSecondaryArchiveFTPLocationId(0);
    }
  };

  const handleExportFilenameWithoutUnderscoreChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setExportFilenameWithoutUnderscore(value);
  };

  const handleDaoReturnMetadataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setDaoReturnMetadataDefinitionID(Number(value));
    } else {
      setDaoReturnMetadataDefinitionID(0);
    }
  };

  const handleToDownSampleChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setToDownSampleFTPLocationId(Number(value));
    } else {
      setToDownSampleFTPLocationId(0);
    }
  };

  const handleFromDownSampleChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFromDownSamplingFTPLocationId(Number(value));
    } else {
      setFromDownSamplingFTPLocationId(0);
    }
  };

  const handleFromDownSampleArchiveChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFromDownSamplingArchiveFTPLocationId(Number(value));
    } else {
      setFromDownSamplingArchiveFTPLocationId(0);
    }
  };

  const handleDsaReturnMetadataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setDsaReturnMetadataDefinitionID(Number(value));
    } else {
      setDsaReturnMetadataDefinitionID(0);
    }
  };

  const handleWebReadyChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setWebReadyFtpLocationId(Number(value));
    } else {
      setWebReadyFtpLocationId(0);
    }
  };

  const handleWebReadyArchiveChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setWebReadyArchiveFtpLocationId(Number(value));
    } else {
      setWebReadyArchiveFtpLocationId(0);
    }
  };

  const handleExportDocChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setExportFtpLocationId(Number(value));
    } else {
      setExportFtpLocationId(0);
    }
  };

  const handleDisplayRuleMappingChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIsDisplayRuleMapping(value);
  };

  const handleDocumentDisplayRuleChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setDisplayRuleMappingId(Number(value));
    } else {
      setDisplayRuleMappingId(0);
    }
  };

  const handleRecentRecordDaysChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      if (Number(value) > 365) {
        setRecentRecordDays(Number(value));
      } else {
        setRecentRecordDays(0);
      }
    }
  };

  const handleIndexFileProcessedChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setIndexFileProcessedMailRequired(value);
  };

  const handleExportSecondaryPreFlightChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setExportSecondaryPreFlightMailRequired(value);
  };

  const handleSecondaryPreFlightReturnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setSecondaryPreFlightReturnMailRequired(value);
  };

  const handleSecondaryPreFlightWarningChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setSecondaryPreFlightWarningMailRequired(value);
  };

  const handleSecondaryPreflightFailureChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setSecondaryPreflightFailureRequired(value);
  };

  const handleExportDownSampleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setExportDownSampleMailRequired(value);
  };

  const handleDownsampleWarningChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setDownsampleWarningMailRequired(value);
  };

  const handleDownStreamReturnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setDownStreamReturnMailRequired(value);
  };

  const handleDownsampleFailureChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setDownsampleFailureMailRequired(value);
  };

  const handleMetadataRejectedReasonsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setMetadataRejectedReasonsMailRequired(value);
  };

  //#endregion

  //#region eDelivery tab 4
  const handleEDeliveryFolder1Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setEDeliveryFtpLocationId(Number(value));
    } else {
      setEDeliveryFtpLocationId(0);
    }
  };

  const handleFundFolderTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setFundFolderType(Number(value));
    } else {
      setFundFolderType(0);
    }
  };

  const handleSecondaryEDeliveryFolder2Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setSecondaryeDeliveryFTPLocationId(Number(value));
    } else {
      setSecondaryeDeliveryFTPLocationId(0);
    }
  };

  const handleSecondaryFundFolderTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setSecondaryFundFolderType(Number(value));
    } else {
      setSecondaryFundFolderType(0);
    }
  };

  const handlePrintReadyEdeliveryReturnChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPrintReadyEdeliveryReturnFTPLocationId(Number(value));
    } else {
      setPrintReadyEdeliveryReturnFTPLocationId(0);
    }
  };

  const handleWebReadyEdeliveryReturnChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setWebReadyEdeliveryReturnFTPLocationId(Number(value));
    } else {
      setWebReadyEdeliveryReturnFTPLocationId(0);
    }
  };

  const handlePrintReadyEdeliveryReturnArchiveChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPrintReadyEdeliveryReturnArchiveFTPLocationId(Number(value));
    } else {
      setPrintReadyEdeliveryReturnArchiveFTPLocationId(0);
    }
  };

  const handleWebReadyEdeliveryReturnArchiveChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setWebReadyEdeliveryReturnArchiveFTPLocationId(Number(value));
    } else {
      setWebReadyEdeliveryReturnArchiveFTPLocationId(0);
    }
  };

  const handleEdeliveryReturnPrintReadyMetadataDefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setEdeliveryReturnPrintReadyMetadataDefinitionID(Number(value));
    } else {
      setEdeliveryReturnPrintReadyMetadataDefinitionID(0);
    }
  };

  const handleEdeliveryReturnWebreadyMetadatadefinitionChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setEdeliveryReturnWebreadyMetadatadefinitionID(Number(value));
    } else {
      setEdeliveryReturnWebreadyMetadatadefinitionID(0);
    }
  };

  const handleEDeliveryReturnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setEdeliveryReturn(value);
  };

  const handleSecondaryEmailexportChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setSecondaryEmailexportRequired(value);
  };

  const handleExportEmailChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setExportEmailRequired(value);
  };
  const handleSecondaryFileNameConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setSecondaryFileNameConvention(value);
    } else {
      setSecondaryFileNameConvention("");
    }
  };

  const handleEDeliveryFileNameConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setEdeliveryFileNameConvention(value);
    } else {
      setEdeliveryFileNameConvention("");
    }
  };

  const handleFrequencyHrsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      if (Number(value) <= 23) {
        setFrequencyHrs(Number(value));
      } else {
        setFrequencyHrs(0);
      }
    }
  };

  const handleFrequencyMinsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      if (Number(value) <= 59) {
        setFrequencyMins(Number(value));
      } else {
        setFrequencyMins(0);
      }
    }
  };

  //#endregion

  // #region Active DocID export tab 5

  const handleActiveDocIDAddRow = () => {
    const newSearchCriterias = [...searchCriterias];
    newSearchCriterias.push({ field: "", value: "" });
    setSearchCriterias(newSearchCriterias);
  };

  const handleActiveDocIDRemoveRow = (index: number) => {
    const newSearchCriterias = [...searchCriterias];
    const newSearchCriterias1 = newSearchCriterias.filter(
      (_: any, i: number) => i !== index,
    );
    setSearchCriterias(newSearchCriterias1);
  };

  const handleSearchCriteriaFieldNameChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number,
  ) => {
    const updatedSearchCriterias = [...(searchCriterias || [])];
    if (!updatedSearchCriterias[index]) {
      updatedSearchCriterias[index] = { field: "", value1: "" };
    }
    updatedSearchCriterias[index].field = e.target.value;
    setSearchCriterias(updatedSearchCriterias);
  };

  const handleFieldValueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number,
  ) => {
    const updatedSearchCriterias = [...searchCriterias];
    updatedSearchCriterias[index].value1 = e.target.value;
    setSearchCriterias(updatedSearchCriterias);
  };

  const handleExportDocFTPLocationIdChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setExportDocFTPLocationId(Number(value));
    } else {
      setExportDocFTPLocationId(0);
    }
  };

  const handleExportDocFTPLocationId2Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setExportDocFTPLocationId2(Number(value));
    } else {
      setExportDocFTPLocationId2(0);
    }
  };

  const handleExportDocFTPLocationId3Change = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setExportDocFTPLocationId3(Number(value));
    } else {
      setExportDocFTPLocationId3(0);
    }
  };

  const handleExportEmailRequiredActiveDocIdChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setExportEmailRequiredActiveDocId(value);
  };

  const handleExportFileNameConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setExportFileNameConvention(value);
    } else {
      setExportFileNameConvention("");
    }
  };

  const handleExportFrequencyHourChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      if (Number(value) <= 23) {
        setExportFrequencyHour(Number(value));
      } else {
        setExportFrequencyHour(0);
      }
    }
  };

  const handleExportFrequencyMinChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      if (Number(value) <= 59) {
        setExportFrequencyMin(Number(value));
      } else {
        setExportFrequencyMin(0);
      }
    }
  };

  const getMetadataFields = async () => {
    try {
      setLoading(true);
      const params: AccountModel = {
        AccountId: undefined,
        AccountName: undefined,
        Active: undefined,
        LogoPath: undefined,
        IsDefault: undefined,
        AccountCode: undefined,
        CanExpandLevel: undefined,
        Timezone: undefined,
        IsDashboard: undefined,
        FolderRights: undefined,
        UserId: undefined,
        PrimaryGroupId: undefined,
        IsSuperAdmin: undefined,
        BusinessUnitId: businessUnitId,
        ContextName: contextName,
        CanPrefixLevel1: undefined,
        IsUserPreferences: undefined,
        PsuedoName: undefined,
        ApiKey: undefined,
        ServiceName: undefined,
      };
      const response = await GetAccountMetaDataFields(params);
      const transformedData = transformData(response);
      setCategories(transformedData);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const transformData = (data: any[]): Category[] => {
    const categoryMap: { [key: string]: Category } = {};
    data.forEach((item) => {
      item.group.forEach((group1: any) => {
        const { category, mappingAutoId, field } = group1;
        if (!categoryMap[category]) {
          categoryMap[category] = {
            label: category,
            options: [],
          };
        }
        categoryMap[category].options.push({
          value: mappingAutoId,
          label: field,
        });
      });
    });
    return Object.values(categoryMap);
  };

  // #endregion

  // #region Archival Report tab 6

  const handleArchivalLocationChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setArchivalLocationId(Number(value));
    } else {
      setArchivalLocationId(0);
    }
  };

  const handleArchivalFileNameConventionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setArchivalFileNameConvention(value);
    } else {
      setArchivalFileNameConvention("");
    }
  };

  const handleArchivalEmailRequiredChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setArchivalEmailRequired(value);
  };

  const handleArchivalReqApprovalEmailRequiredChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setArchivalReqApprovalEmailRequired(value);
  };

  //  #region Archival Web Ready
  const handleWebReadyLevel2Change = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setArchivalWebReadyLevel2(value);
      setValidationWebReadyLevel2(null);
    } else {
      setArchivalWebReadyLevel2("");
    }
  };

  const handleUpdateWebReadyLevel2FolderClick = (
    event: React.MouseEvent<SVGSVGElement, MouseEvent>,
  ) => {
    if (archivalWebReadyLevel2 !== undefined && archivalWebReadyLevel2 !== "") {
      setValidationWebReadyLevel2(null);
      setExportFolderData((prevRules) => [
        ...prevRules,
        {
          downStreamExportRules: prevRules.length + 1,
          archivalLevelName: archivalWebReadyLevel2,
          archivalLevelId: prevRules.length + 1,
          isEnabled: true,
        },
      ]);

      setArchivalWebReadyLevel2("");
    } else {
      setValidationWebReadyLevel2("Please enter the Export Folder");
    }
  };

  const handleWebreadyCheckboxChange = (ruleId: number) => {
    setCheckedItemsArchiveWebReady((prevCheckedItems) => {
      if (prevCheckedItems.includes(ruleId)) {
        // If the item is already checked, uncheck it
        return prevCheckedItems.filter((id) => id !== ruleId);
      } else {
        // If the item is not checked, check it
        return [...prevCheckedItems, ruleId];
      }
    });
  };

  const handleWebreadyDeleteItem = (index: number) => {
    const updatedRules = exportFolderData.filter(
      (rule) => rule.archivalLevelId !== index,
    );

    // Update the checked items to remove the deleted item's ID
    const updatedCheckedItems = checkedItemsArchiveWebReady.filter(
      (id) => id !== index,
    );
    // Update the state with the filtered data
    setExportFolderData(updatedRules);
    setCheckedItemsArchiveWebReady(updatedCheckedItems);
  };
  //#endregion

  // #region Archival Print Ready
  const handlePrintReadyLevel2Change = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setArchivalPrintReadyLevel2(value);
      setValidationPrintReadyLevel2(null);
    } else {
      setArchivalPrintReadyLevel2("");
    }
  };

  const handleUpdatePrintReadyLevel2FolderClick = (
    event: React.MouseEvent<SVGSVGElement, MouseEvent>,
  ) => {
    if (
      archivalPrintReadyLevel2 !== undefined &&
      archivalPrintReadyLevel2 !== ""
    ) {
      setValidationPrintReadyLevel2(null);
      setExportFolderData((prevRules) => [
        ...prevRules,
        {
          downStreamExportRules: prevRules.length + 1,
          archivalLevelName: archivalPrintReadyLevel2,
          archivalLevelId: prevRules.length + 1,
          isEnabled: false,
        },
      ]);
      setArchivalPrintReadyLevel2("");
    } else {
      setValidationPrintReadyLevel2("Please enter the Export Folder");
    }
  };

  const handlePrintreadyCheckboxChange = (ruleId: number) => {
    setCheckedItemsArchivePrintReady((prevCheckedItems) => {
      if (prevCheckedItems.includes(ruleId)) {
        // If the item is already checked, uncheck it
        return prevCheckedItems.filter((id) => id !== ruleId);
      } else {
        // If the item is not checked, check it
        return [...prevCheckedItems, ruleId];
      }
    });
  };

  const handlePrintreadyDeleteItem = (index: number) => {
    const updatedRules = exportFolderData.filter(
      (rule) => rule.archivalLevelId !== index,
    );

    // Update the checked items to remove the deleted item's ID
    const updatedCheckedItems = checkedItemsArchivePrintReady.filter(
      (id) => id !== index,
    );
    // Update the state with the filtered data
    setExportFolderData(updatedRules);
    setCheckedItemsArchivePrintReady(updatedCheckedItems);
  };

  //#endregion

  //#endregion

  //#region Turbo Proofs tab 7

  const handleEditRowTurbo = (params: any) => {
    setTextAddOrUpdateTurbo("Update");
    setTurboLevel2FolderEdit(params.level2.folderName);
    setTurboLevel2Folder(params.level2.folderName);
    setTurboLevel3Folder(params.level3.folderName);
    setTurboLevel4Folder(params.level4.folderName);
    setTurboLevel5Folder(params.level5.folderName);
    setTurboLevel6Folder(params.level6.folderName);
  };

  const handleDeleteRowTurbo = (fileName: string) => {
    setTurboDeleteFile(fileName);
    setConfirmDialogOpen(true);
    setConfirmDialogMessage(
      "Please note that there are documents available under the folder. Are you sure you want to delete? Imp: Deleted documents will not be available for future purpose.",
    );
    setDialogBoxTitle("TURBO PROOFS");
  };

  const turboActionCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <>
          <IconButton
            style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
            onClick={() => handleEditRowTurbo(params.data)}
          >
            <Tooltip title="Click to edit the path">
              <EditIcon />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
          >
            <Tooltip title="Click to duplicate the path">
              <ContentCopyIcon />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
            onClick={() => handleDeleteRowTurbo(params.data.level2.folderName)}
          >
            <Tooltip title="Click to delete the path">
              <CloseIcon />
            </Tooltip>
          </IconButton>
        </>
      );
    }
  };

  //Defined grid column
  const [columnDefTurboTab] = useState<ColDef[]>([
    {
      headerName: "Level 1",
      field: "level1.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 2",
      field: "level2.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 3",
      field: "level3.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 4",
      field: "level4.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 5",
      field: "level5.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 6",
      field: "level6.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Settings",
      field: "action",
      width: 130,
      sortable: false,
      resizable: false,
      cellRenderer: turboActionCellRenderer,
    },
  ]);

  const handleTurboCanFTPFolderUploadChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setTurboCanFTPFolderUpload(value);
  };

  const handleTurboPdfTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setTurboPdfType(value);
  };

  const handleTurboExcelTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setTurboExcelType(value);
  };

  const handleTurboWordDocTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setTurboWordDocType(value);
  };

  const handleTurbofileSizeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setTurbofileSize(Number(value));
    } else {
      setTurbofileSize(0);
    }
  };

  const handleTurboEnableUIUploadChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setTurboEnableUIUpload(value);
  };

  const handleTurboftpSourceLocationIdChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTurboftpSourceLocationId(Number(value));
    } else {
      setTurboftpSourceLocationId(0);
    }
  };

  const handleTurboLevel1FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTurboLevel1Folder(value);
    } else {
      setTurboLevel1Folder("");
    }
  };

  const handleTurboLevel2FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTurboLevel2Folder(value);
    } else {
      setTurboLevel2Folder("");
    }
  };

  const handleTurboLevel3FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTurboLevel3Folder(value);
    } else {
      setTurboLevel3Folder("");
    }
  };

  const handleTurboLevel4FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTurboLevel4Folder(value);
    } else {
      setTurboLevel4Folder("");
    }
  };

  const handleTurboLevel5FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTurboLevel5Folder(value);
    } else {
      setTurboLevel5Folder("");
    }
  };

  const handleTurboLevel6FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setTurboLevel6Folder(value);
    } else {
      setTurboLevel6Folder("");
    }
  };

  const handleAddTurboProofsFolderClick = () => {
    if (textAddOrUpdateTurbo.toLocaleLowerCase() === "update") {
      const updatedRowData = rowDataTurbo.map((row) => {
        if (row.level2.folderName === turboLevel2FolderEdit) {
          return {
            level1: {
              folderid: 0,
              folderName: turboLevel1Folder,
              active: false,
            },
            level2: {
              folderid: 0,
              folderName: turboLevel2Folder,
              active: false,
            },
            level3: {
              folderid: 0,
              folderName: turboLevel3Folder,
              active: false,
            },
            level4: {
              folderid: 0,
              folderName: turboLevel4Folder,
              active: false,
            },
            level5: {
              folderid: 0,
              folderName: turboLevel5Folder,
              active: false,
            },
            level6: {
              folderid: 0,
              folderName: turboLevel6Folder,
              active: false,
            },
          };
        } else {
          return row;
        }
      });
      setRowDataTurbo(updatedRowData);
      setTextAddOrUpdateTurbo("Add");
      setTurboLevel1Folder("TURBO PROOFS");
      setTurboLevel2Folder("");
      setTurboLevel3Folder("");
      setTurboLevel4Folder("");
      setTurboLevel5Folder("");
      setTurboLevel6Folder("");
    } else {
      setRowDataTurbo([
        ...rowDataTurbo,
        {
          level1: { folderid: 0, folderName: turboLevel1Folder, active: false },
          level2: { folderid: 0, folderName: turboLevel2Folder, active: false },
          level3: { folderid: 0, folderName: turboLevel3Folder, active: false },
          level4: { folderid: 0, folderName: turboLevel4Folder, active: false },
          level5: { folderid: 0, folderName: turboLevel5Folder, active: false },
          level6: { folderid: 0, folderName: turboLevel6Folder, active: false },
        },
      ]);

      setTurboLevel1Folder("TURBO PROOFS");
      setTurboLevel2Folder("");
      setTurboLevel3Folder("");
      setTurboLevel4Folder("");
      setTurboLevel5Folder("");
      setTurboLevel6Folder("");
    }
  };
  //#endregion

  //#region Post Work tab 8

  const handleEditRowPostWork = (params: any) => {
    setTextAddOrUpdatePostWork("Update");
    setPostWorkLevel2FolderEdit(params.level2.folderName);
    setPostWorkLevel2Folder(params.level2.folderName);
    setPostWorkLevel3Folder(params.level3.folderName);
    setPostWorkLevel4Folder(params.level4.folderName);
    setPostWorkLevel5Folder(params.level5.folderName);
    setPostWorkLevel6Folder(params.level6.folderName);
  };

  const handleDeleteRowPostWork = (fileName: string) => {
    setConfirmDialogOpen(true);
    setPostWorkDeleteFile(fileName);
    setConfirmDialogMessage(
      "Please note that there are documents available under the folder. Are you sure you want to delete? Imp: Deleted documents will not be available for future purpose.",
    );
    setDialogBoxTitle("POST-WORK");
  };

  const postWorkActionCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <>
          <IconButton
            style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
            onClick={() => handleEditRowPostWork(params.data)}
          >
            <Tooltip title="Click to edit the path">
              <EditIcon />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
          >
            <Tooltip title="Click to duplicate the path">
              <ContentCopyIcon />
            </Tooltip>
          </IconButton>

          <IconButton
            style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
            onClick={() =>
              handleDeleteRowPostWork(params.data.level2.folderName)
            }
          >
            <Tooltip title="Click to delete the path">
              <CloseIcon />
            </Tooltip>
          </IconButton>
        </>
      );
    }
  };

  //Defined grid column
  const [columnDefPostWorkTab] = useState<ColDef[]>([
    {
      headerName: "Level 1",
      field: "level1.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 2",
      field: "level2.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 3",
      field: "level3.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 4",
      field: "level4.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 5",
      field: "level5.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Level 6",
      field: "level6.folderName",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "Settings",
      field: "action",
      width: 130,
      sortable: false,
      resizable: false,
      cellRenderer: postWorkActionCellRenderer,
    },
  ]);

  const handlePostWorkftpSourceLocationIdChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPostWorkftpSourceLocationId(Number(value));
    } else {
      setPostWorkftpSourceLocationId(0);
    }
  };

  const handleCanFTPFolderUploadChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setPostWorkCanFTPFolderUpload(value);
  };

  const handlePdfTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked;
    setPostWorkPdfType(value);
  };

  const handleExcelTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setPostWorkExceltype(value);
  };

  const handleWordDocTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setPostWorkWordDocType(value);
  };

  const handlePostWorkfileSizeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setPostWorkfileSize(Number(value));
    } else {
      setPostWorkfileSize(0);
    }
  };

  const handlePostWorkEnableUIUploadChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.checked;
    setPostWorkEnableUIUpload(value);
  };

  const handlePostWorkLevel1FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPostWorkLevel1Folder(value);
    } else {
      setPostWorkLevel1Folder("");
    }
  };

  const handlePostWorkLevel2FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPostWorkLevel2Folder(value);
    } else {
      setPostWorkLevel2Folder("");
    }
  };

  const handlePostWorkLevel3FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPostWorkLevel3Folder(value);
    } else {
      setPostWorkLevel3Folder("");
    }
  };

  const handlePostWorkLevel4FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPostWorkLevel4Folder(value);
    } else {
      setPostWorkLevel4Folder("");
    }
  };

  const handlePostWorkLevel5FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPostWorkLevel5Folder(value);
    } else {
      setPostWorkLevel5Folder("");
    }
  };

  const handlePostWorkLevel6FolderChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setPostWorkLevel6Folder(value);
    } else {
      setPostWorkLevel6Folder("");
    }
  };

  const handleAddPostWorkFolderClick = () => {
    if (textAddOrUpdatePostWork.toLocaleLowerCase() === "update") {
      const updatedRowData = rowDataPostWork.map((row) => {
        if (row.level2.folderName === postWorkLevel2FolderEdit) {
          return {
            level1: {
              folderid: 0,
              folderName: postWorkLevel1Folder,
              active: false,
            },
            level2: {
              folderid: 0,
              folderName: postWorkLevel2Folder,
              active: false,
            },
            level3: {
              folderid: 0,
              folderName: postWorkLevel3Folder,
              active: false,
            },
            level4: {
              folderid: 0,
              folderName: postWorkLevel4Folder,
              active: false,
            },
            level5: {
              folderid: 0,
              folderName: postWorkLevel5Folder,
              active: false,
            },
            level6: {
              folderid: 0,
              folderName: postWorkLevel6Folder,
              active: false,
            },
          };
        } else {
          return row;
        }
      });
      setRowDataPostWork(updatedRowData);
      setTextAddOrUpdatePostWork("Add");
      setPostWorkLevel1Folder("POST-WORK");
      setPostWorkLevel2Folder("");
      setPostWorkLevel3Folder("");
      setPostWorkLevel4Folder("");
      setPostWorkLevel5Folder("");
      setPostWorkLevel6Folder("");
    } else {
      setRowDataPostWork([
        ...rowDataPostWork,
        {
          level1: {
            folderid: 0,
            folderName: postWorkLevel1Folder,
            active: false,
          },
          level2: {
            folderid: 0,
            folderName: postWorkLevel2Folder,
            active: false,
          },
          level3: {
            folderid: 0,
            folderName: postWorkLevel3Folder,
            active: false,
          },
          level4: {
            folderid: 0,
            folderName: postWorkLevel4Folder,
            active: false,
          },
          level5: {
            folderid: 0,
            folderName: postWorkLevel5Folder,
            active: false,
          },
          level6: {
            folderid: 0,
            folderName: postWorkLevel6Folder,
            active: false,
          },
        },
      ]);
      setPostWorkLevel1Folder("POST-WORK");
      setPostWorkLevel2Folder("");
      setPostWorkLevel3Folder("");
      setPostWorkLevel4Folder("");
      setPostWorkLevel5Folder("");
      setPostWorkLevel6Folder("");
    }
  };

  //#endregion

  //#region Metadata Configuration tab 9
  const [detailChecked, setDetailChecked] = useState<{
    [key: string]: boolean;
  }>({});

  const handleCategoryCheckboxChange = (categoryId: any, index: number) => {
    const newMetadataFields = [...metadataFields];
    const newCheckedCategories = { ...checkedCategories };
    const newDetailChecked = { ...detailChecked };
    const isChecked = !newCheckedCategories[categoryId];
    newCheckedCategories[categoryId] = isChecked;
    metadataFields.forEach((metadataField: any, categoryIndex: number) => {
      if (metadataField.group[0].category === categoryId) {
        metadataField.group.forEach((field: any, fieldIndex: number) => {
          newMetadataFields[categoryIndex].group[fieldIndex].categorychecked =
            isChecked;
          newMetadataFields[categoryIndex].group[fieldIndex].active = isChecked;
        });
      }
    });
    setCheckedCategories(newCheckedCategories);
    setDetailChecked(newDetailChecked);
    setMetadataFields(newMetadataFields);
  };

  const handleDetailCheckboxChange = (
    key: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const checked = event.target.checked;
    setDetailChecked((prevState) => ({
      ...prevState,
      [key]: checked,
    }));
    setMetadataFields((prevFields) =>
      prevFields.map((metadataField) => ({
        ...metadataField,
        group: metadataField.group.map((groupItem: any) =>
          `Chk${groupItem.field}` === key
            ? { ...groupItem, active: checked }
            : groupItem,
        ),
      })),
    );
  };

  const handleToggle = (key: string) => {
    setActiveKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
  };

  const handleExpandeAll = () => {
    setActiveKeys(
      Array.from({ length: metadataFields.length }, (_, i) => i.toString()),
    );
  };

  const handleCollapseAll = () => {
    setActiveKeys([]);
  };

  //#endregion

  //#region Help Documents tab 10
  const handleHelpDocNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setHelpDocName(value);
      setValidationHelpDocName(null);
    } else {
      setHelpDocName("");
    }
  };

  const handleHelpDocDescriptionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    if (value !== undefined && value !== "") {
      setHelpDocDescription(value);
      setValidationHelpDocDescription(null);
    } else {
      setHelpDocDescription("");
    }
  };

  //Handle delete row
  const handleDeleteRowHelpDoc = (fileName: string) => {
    setHelpDocRowData((prevRowData) =>
      prevRowData.filter((row) => row.fileName !== fileName),
    );
  };

  const handelSelectHelpDocumentFiles = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target.files;
    let selectedFiles: File[] = [];
    if (helpDocName === undefined || helpDocName === "") {
      setValidationHelpDocName("Please enter the Document Name");
    } else if (helpDocDescription === undefined || helpDocDescription === "") {
      setValidationHelpDocDescription("Please enter the Description");
    } else if (files) {
      selectedFiles = Array.from(files).filter(
        (file) =>
          file.name.toLowerCase().endsWith(".txt") ||
          file.name.toLowerCase().endsWith(".pdf"),
      );

      const newRowData = selectedFiles.map((file) => ({
        helpDocumentId: helpDocumentId,
        accountId: responsedAccountId,
        accountName: accountName,
        documentName: helpDocName,
        documentStream: null,
        description: helpDocDescription,
        fileType: getFileExtension(file.name),
        phone: null,
        contactName: null,
        email: null,
        createdBy: 0,
        filesize: file.size,
        fileName: file.name,
        createdOn: new Date(),
        noOfRecords: 0,
        currentPage: 0,
        sortColumn: null,
        sortOrder: null,
        totalRecords: 0,
        isexporttpExcel: false,
        contextName: contextName,
      }));
      if (newRowData.length > 0) {
        setHelpDocRowData((prevRowData) => [...prevRowData, ...newRowData]);
        setHelpDocName("");
        setHelpDocDescription("");
        setValidationHelpDocName(null);
        setValidationHelpDocDescription(null);
        setValidationMessage("");
      } else {
        setValidationMessage("Please select only .txt or .pdf files");
      }
    }
  };

  //Action Cell Renderer
  const helpDocActionCellRenderer = (params: any) => {
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <IconButton
          style={{ padding: "2px", color: "var(--aggrid-text-color)" }}
          onClick={() => handleDeleteRowHelpDoc(params.data.fileName)}
        >
          <CloseIcon />
        </IconButton>
      );
    }
  };

  //Defined grid column
  const [columnDefDocumentTab] = useState<ColDef[]>([
    {
      headerName: "Document Name",
      field: "documentName",
      sortable: true,
      filter: true,
      resizable: true,
      width: 300,
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
    },
    {
      headerName: "File Size",
      field: "filesize",
      sortable: true,
      filter: true,
      resizable: true,
      width: 200,
      valueFormatter: (params: any) => {
        return params.value
          ? Math.round(params.value / 1024).toLocaleString() + " KB"
          : "";
      },
    },
    {
      headerName: "Uploaded On",
      field: "createdOn",
      sortable: true,
      filter: true,
      resizable: true,
      width: 200,
      valueFormatter: (params) => {
        return params.value
          ? moment.utc(params.value).local().format("MM-DD-YYYY HH:mm:ss")
          : "";
      },
    },
    {
      headerName: "Action",
      width: 110,
      sortable: false,
      resizable: false,
      cellRenderer: helpDocActionCellRenderer,
    },
  ]);

  const getFileExtension = (filename: string): string => {
    const parts = filename.split(".");
    return parts.length > 1 ? `.${parts.pop()}` : "";
  };

  const handleConfirmDialogClose = (confirm: boolean) => {
    setConfirmDialogOpen(false);
    if (confirm) {
      if (dialogBoxTitle.toLocaleLowerCase() === "post-work") {
        setRowDataPostWork((prevRowData) =>
          prevRowData.filter(
            (row) => row.level2.folderName !== postWorkDeleteFile,
          ),
        );
      } else if (dialogBoxTitle.toLocaleLowerCase() === "turbo proofs") {
        setRowDataTurbo((prevRowData) =>
          prevRowData.filter(
            (row) => row.level2.folderName !== turboDeleteFile,
          ),
        );
      } else {
        navigation("/account");
      }
    } else {
      setConfirmDialogOpen(false);
    }
  };

  const handleCancelClick = () => {
    setConfirmDialogOpen(true);
    setConfirmDialogMessage("Are you sure you want to cancel the changes?");
    setDialogBoxTitle("HELP DOCUMENTS");
  };

  const handleSubmitClick = async () => {
    try {
      setLoading(true);
      let ProcessStagesList: AccountProcessStageModel[] = [];
      processStages.forEach((stage) => {
        const processStage: AccountProcessStageModel = {
          processStageId: stage.processStageId,
          stageName: stage.stageName,
          accountId: responsedAccountId,
          type: stage.stageName,
          isDefault: false,
          aliasName: stage.aliasName,
          isChecked: true,
        };
        ProcessStagesList.push(processStage);
      });

      let ProcessAllStagesList: AccountProcessStageModel[] = [];
      processAllStage.forEach((stage) => {
        const processStage: AccountProcessStageModel = {
          processStageId: stage.processStageId,
          stageName: stage.stageName,
          accountId: 0,
          type: null,
          isDefault: false,
          aliasName: stage.aliasName,
          isChecked: stage.isChecked,
        };
        ProcessAllStagesList.push(processStage);
      });

      let availableFundList: FundFoldersModel[] = [];
      availableFolderData.forEach((folder: any) => {
        const fundFolder: FundFoldersModel = {
          fundFolderId: folder.fundFolderId,
          folderName: folder.folderName,
          levels: folder.levels,
          parentFundFolderId: folder.parentFundFolderId,
          orderby: folder.orderby,
          accountId: folder.accountId,
          icon: folder.icon,
          createdBy: folder.createdBy,
          active: folder.active,
          processStageType: folder.processStageType,
          accessPermission: folder.accessPermission,
          contextName: folder.contextName,
          children: folder.children,
          isParent: folder.isParent,
          depthPath: folder.depthPath,
          breadCrumbs: folder.breadCrumbs,
        };
        availableFundList.push(fundFolder);
      });

      let enableFundList: FundFoldersModel[] = [];
      enabledFolderData.forEach((folder: any) => {
        const fundFolder: FundFoldersModel = {
          fundFolderId: folder.fundFolderId,
          folderName: folder.folderName,
          levels: folder.levels,
          parentFundFolderId: folder.parentFundFolderId,
          orderby: folder.orderby,
          accountId: folder.accountId,
          icon: folder.icon,
          createdBy: folder.createdBy,
          active: folder.active,
          processStageType: folder.processStageType,
          accessPermission: folder.accessPermission,
          contextName: folder.contextName,
          children: folder.children,
          isParent: folder.isParent,
          depthPath: folder.depthPath,
          breadCrumbs: folder.breadCrumbs,
        };
        enableFundList.push(fundFolder);
      });
      const fundFolderList: AccountEnabledAvailableFundFolder = {
        availableFundFolders: availableFundList,
        enabledFundFolders: enableFundList,
      };

      let preworkInstructionData: AccountPreWorkInstructionModel[] = [];
      preworkRowData.forEach((instruction) => {
        const preworkInstruction: AccountPreWorkInstructionModel = {
          accountPreworkId: responsedAccountPreworkId,
          preWorkInstructionId: instruction.preWorkInstructionId,
          instructionName: instruction.instructionName,
          fileName: instruction.fileName,
          instructionStream: instruction.instructionStream,
          createdDate: instruction.createdDate,
          createdBy: instruction.createdBy,
          fileSize: instruction.fileSize,
        };
        preworkInstructionData.push(preworkInstruction);
      });

      let exportRuleList: DownStreamExportRule[] = [];
      downStreamExportRules.forEach((rule) => {
        const exportRule: DownStreamExportRule = {
          downStreamExportRuleId: rule.downStreamExportRuleId,
          ruleName: rule.ruleName,
          createdBy: rule.createdBy,
          accountId: rule.accountId,
          isEnabled: rule.isEnabled,
          processType: rule.processType,
          createdDate: rule.createdDate,
          active: rule.active,
        };
        exportRuleList.push(exportRule);
      });

      let archiveLevelRulesList: ArchiveLevelRules[] = [];
      (exportFolderData ?? []).forEach((rule) => {
        const archiveLevelRule: ArchiveLevelRules = {
          archivalLevelId: rule.archivalLevelId,
          archivalLevelName: rule.archivalLevelName,
          archivalStageId: rule.archivalStageId,
          createdBy: rule.createdBy,
          accountId: rule.accountId,
          createdDate: rule.createdDate,
          isEnabled: rule.isEnabled,
        };
        archiveLevelRulesList.push(archiveLevelRule);
      });

      let searchCriteriasList: QueryModel[] = [];
      (searchCriterias ?? []).forEach((criteria) => {
        const searchCriteria: QueryModel = {
          searchQueryID: criteria.searchQueryID,
          searchCriteriaID: criteria.searchCriteriaID,
          metadataFieldName: criteria.fieldName,
          field: criteria.field,
          value1: criteria.value1,
          value2: criteria.value2,
          fieldName: criteria.fieldName,
          operator: criteria.operator,
          logicalOperator: criteria.logicalOperator,
        };
        searchCriteriasList.push(searchCriteria);
      });
      let accountCustomProcess: CustomProcessModel = {
        customProcessId: "0",
        accountCustomProcessId: accountCustomProcessId,
        accountId: responsedAccountId,
        processStageId: processStageId,
        canFTPFolderUpload: turboCanFTPFolderUpload,
        enableUIUpload: turboEnableUIUpload,
        pdfType: turboPdfType,
        excelType: turboExcelType,
        wordDocType: turboWordDocType,
        fileSize: turbofileSize,
        otherFileType: null,
        othersChecked: false,
        ftpSourceLocationId: turboftpSourceLocationId,
        ftpShareLocationId: 0,
        stageName: "TURBO PROOFS",
        fundFolderId: fundFolderId,
        aliasName: "TURBO PROOFS",
        accountCustProcEmails: [],
        accountCustProcessFolders: [],
        folderLevels: rowDataTurbo.map((folder) => ({
          level1: {
            folderId: folder.level1.folderId,
            folderName: folder.level1.folderName,
            active: folder.level1.active,
          },
          level2: {
            folderId: folder.level2.folderId,
            folderName: folder.level2.folderName,
            active: folder.level2.active,
          },
          level3: {
            folderId: folder.level3.folderId,
            folderName: folder.level3.folderName,
            active: folder.level3.active,
          },
          level4: {
            folderId: folder.level4.folderId,
            folderName: folder.level4.folderName,
            active: folder.level4.active,
          },
          level5: {
            folderId: folder.level5.folderId,
            folderName: folder.level5.folderName,
            active: folder.level5.active,
          },
          level6: {
            folderId: folder.level6.folderId,
            folderName: folder.level6.folderName,
            active: folder.level6.active,
          },
        })),
        foldersToDelete: null,
      };

      let accountCustomProcessPostWork: CustomProcessModel = {
        customProcessId: "0",
        accountCustomProcessId: accountPostworkAccountCustomProcessId,
        accountId: responsedAccountId,
        processStageId: postworkProcessStageId,
        canFTPFolderUpload: postWorkCanFTPFolderUpload,
        enableUIUpload: postWorkEnableUIUpload,
        pdfType: postWorkPdfType,
        excelType: postWorkExcelType,
        wordDocType: postWorkWordDocType,
        fileSize: postWorkfileSize,
        otherFileType: null,
        othersChecked: false,
        ftpSourceLocationId: postWorkftpSourceLocationId,
        ftpShareLocationId: 0,
        stageName: "POST-WORK",
        fundFolderId: postworkfundFolderId,
        aliasName: "POST-WORK",
        accountCustProcEmails: [],
        accountCustProcessFolders: [],
        folderLevels: rowDataPostWork.map((folder) => ({
          level1: {
            folderId: folder.level1.folderId,
            folderName: folder.level1.folderName,
            active: folder.level1.active,
          },
          level2: {
            folderId: folder.level2.folderId,
            folderName: folder.level2.folderName,
            active: folder.level2.active,
          },
          level3: {
            folderId: folder.level3.folderId,
            folderName: folder.level3.folderName,
            active: folder.level3.active,
          },
          level4: {
            folderId: folder.level4.folderId,
            folderName: folder.level4.folderName,
            active: folder.level4.active,
          },
          level5: {
            folderId: folder.level5.folderId,
            folderName: folder.level5.folderName,
            active: folder.level5.active,
          },
          level6: {
            folderId: folder.level6.folderId,
            folderName: folder.level6.folderName,
            active: folder.level6.active,
          },
        })),
        foldersToDelete: null,
      };

      let helpDocument: HelpModel[] = [];
      helpDocRowData.forEach((doc) => {
        const helpDoc: HelpModel = {
          helpDocumentId: doc.helpDocumentId,
          accountId: responsedAccountId,
          accountName: null,
          documentName: doc.documentName,
          documentStream: doc.documentStream,
          description: doc.description,
          fileType: doc.fileType,
          phone: doc.phone,
          contactName: doc.contactName,
          email: doc.email,
          createdBy: doc.createdBy,
          filesize: doc.filesize,
          fileName: doc.fileName,
          createdOn: doc.createdOn,
          noOfRecords: doc.noOfRecords,
          currentPage: doc.currentPage,
          sortColumn: doc.sortColumn,
          sortOrder: doc.sortOrder,
          totalRecords: doc.totalRecords,
          isexporttpExcel: doc.isexporttpExcel,
          contextName: doc.contextName,
        };
        helpDocument.push(helpDoc);
      });

      let activeDocIdFieldNames: FieldModel[] = [];
      MetaddataSourceDefinitions.forEach((field) => {
        const activeDocIdField: FieldModel = {
          metaDataFieldId: field.metaDataFieldId,
          field: field.field,
          customField: field.customField,
          categoryName: field.categoryName,
          fieldMappingId: field.fieldMappingId,
        };
        activeDocIdFieldNames.push(activeDocIdField);
      });

      const updatedMetadataFields = metadataFields.map((metadataField) => {
        return {
          ...metadataField,
          group: metadataField.group.map((groupItem: any) => ({
            ...groupItem,
            active: detailChecked.hasOwnProperty(`Chk${groupItem.field}`)
              ? detailChecked[`Chk${groupItem.field}`]
              : groupItem.active,
          })),
        };
      });

      let metaDataFields: AccountMetadataFieldsModel[] = [];
      updatedMetadataFields.forEach((metadataField) => {
        const metadataFieldCategory: AccountMetadataFieldsModel = {
          category: metadataField.category,
          categoryId: metadataField.categoryId,
          categorychecked: metadataField.categorychecked,
          accountId: 0,
          field: metadataField.field,
          orderBy: metadataField.orderBy,
          createdDate: metadataField.createdDate,
          active: metadataField.active,
          rowGuid: metadataField.rowGuid,
          aliasName: metadataField.aliasName,
          metaDataFieldId: metadataField.metaDataFieldId,
          mappingAutoId: metadataField.mappingAutoId,
          iscustomizable: metadataField.iscustomizable,
          key: metadataField.key,
          group: metadataField.group,
        };
        metaDataFields.push(metadataFieldCategory);
      });
      const params: AccountDetailsContext = {
        ContextName: contextName,
        AccountDetails: {
          basicAccountDetail:
            !basicAccountDetails || basicAccountDetails.length === 0
              ? null
              : {
                  accountId: responsedAccountId,
                  accountName: accountName,
                  accountCode: customerCode,
                  contactName: contactName,
                  phone: contactPhoneNumber,
                  email: contactEmail,
                  logoPath: logoBase64,
                  active: true,
                  createdBy: 0,
                  canExpandLevel: isMenuExpand,
                  isDashboard: isDashboardCountShow,
                  isUserPreferences: isUserPreferencesShow,
                  userPasswordNotification:
                    Number(passwordNotificationDays) === 0
                      ? null
                      : Number(passwordNotificationDays),
                  dashBoardInterval: Number(dashboardInterval),
                  userSessionNotification: 0,
                  processStages: ProcessStagesList,
                  processAllStages: ProcessAllStagesList,
                  accountContactDetails: [],
                  fundFolder: fundFolderList,
                  isFolderRights: isFolderAccessRightsShow,
                  userExpireNotification:
                    Number(userExpiryNoticationDays) === 0
                      ? null
                      : Number(userExpiryNoticationDays),
                  createdDate: new Date(),
                  businessUnitId: businessUnitId,
                  isPasswordNotification: isPasswordNotificationShow,
                  canPrefixLevel1: isLevelOneCheck,
                  accountIdentityId: 0,
                  apiKey: apiKeys,
                  downloadByDefault: isDownloadByDefault,
                  processStage: ProcessStagesList,
                },
          accountPreWorks:
            !preworkAccountDetails || preworkAccountDetails.length === 0
              ? null
              : {
                  accountPreworkId: responsedAccountPreworkId,
                  accountId: responsedAccountId,
                  isPrimaryPreFlightEnable: isSecondrayPreFlightEnable,
                  isSecondrayPreFlightEnable: isSecondrayPreFlightEnable,
                  ftpFolderEnable: isFtpFolderEnable,
                  enableUIUpload: enableUIUpload,
                  pdfType: isPdfEnable,
                  excelType: isExcelEnable,
                  wordDocType: isWordEnable,
                  isOtherFileFormat: isOtherFileFormat,
                  otherFileType: otherFileType,
                  fileSize: Number(fileSize),
                  ftpSourceFTPLocationId: ftpSourceFTPLocationId,
                  localShareFTPLocationId: localShareFTPLocationId,
                  secondaryPreflightFTPLocationId:
                    secondaryPreflightFTPLocationId,
                  finalFolderFTPLocationId: finalFolderFTPLocationId,
                  preworkEmailRequired: preworkEmailRequired,
                  preworkWarningEmailRequired: preworkWarningEmailRequired,
                  preworkExpirationEmailRequired:
                    preworkExpirationEmailRequired,
                  printReadyEmailRequired: printReadyEmailRequired,
                  toPreFlightFileNameConvention: toPreFlightFileNameConvention,
                  fromPreFlightFileNameConvention:
                    fromPreFlightFileNameConvention,
                  fromPreflightFTPLocationId: fromPreflightFTPLocationId,
                  primaryPreflightReturnEmailRequired:
                    primaryPreflightReturnEmailRequired,
                  exportToFinalEmailRequired: exportToFinalEmailRequired,
                  documentRenameEmailRequired: documentRenameEmailRequired,
                  documentRejectEmailRequired: documentRejectEmailRequired,
                  documentDeleteEmailRequired: documentDeleteEmailRequired,
                  preworkExport1: null,
                  preworkExport2: null,
                  preworkExport3: null,
                  preworkExport3Naming: null,
                  triggerProofExport1LocationId:
                    triggerProofExport1LocationId ?? 0,
                  triggerProofExport2LocationId:
                    triggerProofExport2LocationId ?? 0,
                  triggerProofExport3LocationId:
                    triggerProofExport3LocationId ?? 0,
                  triggerProofExport3FileType: 1,
                  triggerProofExport3Naming: triggerProofExport3Naming,
                  triggerProofExport3ReturnLocationId:
                    triggerProofExport3ReturnLocationId ?? 0,
                  triggerProofExport4LocationId:
                    triggerProofExport4LocationId ?? 0,
                  triggerProofExport4FileType: 1,
                  triggerProofExport4Naming: triggerProofExport4Naming,
                  triggerProofExport4ReturnLocationId:
                    triggerProofExport4ReturnLocationId ?? 0,
                  triggerProdExport1LocationId:
                    triggerProdExport1LocationId ?? 0,
                  triggerProdExport2LocationId:
                    triggerProdExport2LocationId ?? 0,
                  triggerProdExport3LocationId:
                    triggerProdExport3LocationId ?? 0,
                  triggerProdExport3FileType: 1,
                  triggerProdExport3Naming: triggerProdExport3Naming,
                  triggerProdExport3ReturnLocationId:
                    triggerProdExport3MetaDataDefinitionId ?? 0,
                  triggerProdExport4LocationId:
                    triggerProdExport4LocationId ?? 0,
                  triggerProdExport4FileType: 1,
                  triggerProdExport4Naming: triggerProd2Export4Naming,
                  triggerProdExport4ReturnLocationId:
                    triggerProd2Export4MetaDataDefinitionId,
                  triggerProofExport1EmailRequired:
                    triggerProofExport1EmailRequired,
                  triggerProofExport2EmailRequired:
                    triggerProofExport2EmailRequired,
                  triggerProofExport3EmailRequired:
                    triggerProofExport3EmailRequired,
                  triggerProofExport4EmailRequired:
                    triggerProofExport4EmailRequired,
                  triggerProofExport3ReturnEmailRequired:
                    triggerProofExport3ReturnEmailRequired,
                  triggerProofExport4ReturnEmailRequired:
                    triggerProofExport4ReturnEmailRequired,
                  triggerProdExport1EmailRequired:
                    triggerProdExport1EmailRequired,
                  triggerProdExport2EmailRequired:
                    triggerProdExport2EmailRequired,
                  triggerProdExport3EmailRequired:
                    triggerProdExport3EmailRequired,
                  triggerProdExport4EmailRequired:
                    triggerProdExport4EmailRequired,
                  triggerProofExport3ReturnArchivalLocationId:
                    triggerProofExport3ReturnArchivalLocationId ?? 0,
                  preworkInstruction: preworkInstructionData,
                  proofExp1CanprefixjobCode: proofExp1CanprefixjobCode,
                  proofExp2CanprefixjobCode: proofExp2CanprefixjobCode,
                  prodExp1CanprefixjobCode: prodExp1CanprefixjobCode,
                  prodExp2CanprefixjobCode: prodExp2CanprefixjobCode,
                  isAllowReprocess: isAllowReprocess,
                  docIdNomenclature: docIdFormat,
                  isTriggerProofWorkFlowEnabled: isTriggerProofWorkFlowEnabled,
                  isTriggerProdWorkFlowEnabled: isTriggerProdWorkFlowEnabled,
                  triggerProofExport3MetaDataDefinitionId:
                    triggerProofExport3MetaDataDefinitionId,
                  triggerProofExport4MetaDataDefinitionId:
                    triggerProofExport4MetaDataDefinitionId,
                  triggerProdExport3MetaDataDefinitionId:
                    triggerProdExport3MetaDataDefinitionId,
                  triggerProdExport4MetaDataDefinitionId:
                    triggerProd2Export4MetaDataDefinitionId,
                  metadataDefinitionId: triggerProofExport3MetaDataDefinitionId,
                },
          accountDownStreams:
            !downstreamAccountDetails || downstreamAccountDetails.length === 0
              ? null
              : {
                  accountDownStreamId: responsedAccountDownStreamId,
                  accountId: responsedAccountId,
                  isDAOEnabled: isDAOEnabled,
                  isDSAEnabled: isDSAEnabled,
                  exceptionEnabled: false,
                  pdfSourceFTPLocationId: pdfSourceFTPLocationId,
                  metadataSourceFTPLocationId: metadataSourceFTPLocationId,
                  toSecondaryFTPLocationId: toSecondaryFTPLocationId,
                  toDownSampleFTPLocationId: toDownSampleFTPLocationId,
                  fromSecondaryFTPLocationId: fromSecondaryFTPLocationId,
                  fromDownSamplingFTPLocationId: fromDownSamplingFTPLocationId,
                  webReadyFtpLocationId: webReadyFtpLocationId,
                  indexFileProcessedMailRequired:
                    indexFileProcessedMailRequired,
                  exportSecondaryPreFlightMailRequired:
                    exportSecondaryPreFlightMailRequired,
                  secondaryPreFlightWarningMailRequired:
                    secondaryPreFlightWarningMailRequired,
                  secondaryPreFlightReturnMailRequired:
                    secondaryPreFlightReturnMailRequired,
                  exportDownSampleMailRequired: exportDownSampleMailRequired,
                  downStreamReturnMailRequired: downStreamReturnMailRequired,
                  downsampleWarningMailRequired: downsampleWarningMailRequired,
                  downsampleFailureMailRequired: downsampleFailureMailRequired,
                  secondaryPreflightFailureRequired:
                    secondaryPreflightFailureRequired,
                  exportFtpLocationId: exportFtpLocationId,
                  downStreamExportRules: exportRuleList,
                  isNoSubProcessEnabled: isNoSubProcessEnabled,
                  isPdfSplitEnabled: isPdfSplitEnabled,
                  daoOldProcessEnabled: 1,
                  daoNewProcessEnabled: 0,
                  daoExportNamingConvention: daoExportNamingConvention,
                  isNewProcessEnabled: isNewProcessEnabled,
                  newProcessPdfEnabled: isNewProcessPdfEnabled,
                  newProcessPdfMetadataEnabled: isNewProcessPdfMetadataEnabled,
                  newProcessExportNamingConvention:
                    newProcessExportNamingConvention,
                  newProcessExportFTPLocationId: newProcessExportFTPLocationId,
                  pdfArchiveFTPLocationId: pdfArchiveFTPLocationId,
                  metadataArchiveFTPLocationId: metadataArchiveFTPLocationId,
                  webReadyArchiveFtpLocationId: webReadyArchiveFtpLocationId,
                  fromDownSamplingArchiveFTPLocationId:
                    fromDownSamplingArchiveFTPLocationId,
                  fromSecondaryArchiveFTPLocationId:
                    fromSecondaryArchiveFTPLocationId,
                  isAllowReprocess: isAllowReprocess,
                  exportFilenameWithoutUnderscore:
                    exportFilenameWithoutUnderscore,
                  isBulkUploadEnabled: isBulkUploadEnabled,
                  displayRuleMappingId: displayRuleMappingId,
                  hasHeader: hasHeader,
                  metadataRejectedReasonsMailRequired:
                    metadataRejectedReasonsMailRequired,
                  level1Folder: level,
                  recentRecordDays: recentRecordDays,
                  sourceIngestionMetadtaDefinitionID:
                    sourceIngestionMetadtaDefinitionID,
                  dsaReturnMetadataDefinitionID: dsaReturnMetadataDefinitionID,
                  daoReturnMetadataDefinitionID: daoReturnMetadataDefinitionID,
                },
          accountProofings: null,
          accountActiveDocExports:
            !activeDocIdExportAccountDetails ||
            activeDocIdExportAccountDetails.length === 0
              ? null
              : {
                  accountActiveDocExportId: accountActiveDocExportId,
                  accountId: responsedAccountId,
                  exportDocFTPLocationId: exportDocFTPLocationId,
                  exportDocFTPLocationId2: exportDocFTPLocationId2,
                  exportDocFTPLocationId3: exportDocFTPLocationId3,
                  exportEmailRequired: exportEmailRequired,
                  exportFileNameConvention: exportFileNameConvention,
                  exportFrequencyHour: exportFrequencyHour,
                  exportFrequencyMin: exportFrequencyMin,
                  activeDocIdQuery: {
                    searchCriterias: searchCriteriasList,
                    seachQrueryName: null,
                    isPublic: false,
                    isActive: true,
                    reportType: null,
                    moduleType: 0,
                    searchQueryID:
                      searchCriteriasList.length > 0
                        ? searchCriteriasList[0].searchQueryID
                        : 0,
                    createdBy: Number(LocalStorageUtil.getItem("userId")),
                  },
                },
          accountEDeliveries:
            !edeliveryAccountDetails || edeliveryAccountDetails.length === 0
              ? null
              : {
                  accountEdeliveryId: accountEdeliveryId,
                  accountId: responsedAccountId,
                  eDeliveryFtpLocationId: eDeliveryFtpLocationId,
                  exportEmailRequired: exportEmailRequired,
                  frequencyHrs: frequencyHrs,
                  frequencyMins: frequencyMins,
                  edeliveryFileNameConvention: edeliveryFileNameConvention,
                  fundFolderType: fundFolderType,
                  secondaryeDeliveryFTPLocationId:
                    secondaryeDeliveryFTPLocationId,
                  secondaryFundFolderType: secondaryFundFolderType,
                  secondaryEmailexportRequired: secondaryEmailexportRequired,
                  secondaryFileNameConvention: secondaryFileNameConvention,
                  edeliveryReturn: edeliveryReturn,
                  printReadyEdeliveryReturnFTPLocationId:
                    printReadyEdeliveryReturnFTPLocationId,
                  webReadyEdeliveryReturnFTPLocationId:
                    webReadyEdeliveryReturnFTPLocationId,
                  printReadyEdeliveryReturnArchiveFTPLocationId:
                    printReadyEdeliveryReturnArchiveFTPLocationId,
                  webReadyEdeliveryReturnArchiveFTPLocationId:
                    webReadyEdeliveryReturnArchiveFTPLocationId,
                  edeliveryReturnPrintReadyMetadataDefinitionID:
                    edeliveryReturnPrintReadyMetadataDefinitionID,
                  edeliveryReturnWebreadyMetadatadefinitionID:
                    edeliveryReturnWebreadyMetadatadefinitionID,
                },
          accountCustomProcesses:
            !turboProofsAccountDetails || turboProofsAccountDetails.length === 0
              ? []
              : [accountCustomProcess, accountCustomProcessPostWork],
          metaDataFields:
            !metadataFields || metadataFields.length === 0
              ? null
              : metaDataFields,
          metaDataSourceDefinitions: [],
          helpDoc:
            !helpDocRowData || helpDocRowData.length === 0
              ? null
              : helpDocument,
          activeDocIdFieldNames: activeDocIdFieldNames,
          accountArchives:
            !archivalReportAccountDetails ||
            archivalReportAccountDetails.length === 0
              ? null
              : {
                  archivalFolderConfigId: archivalFolderConfigId,
                  archivalLocationId: archivalLocationId,
                  archivalFileNameConvention: archivalFileNameConvention,
                  createdBy: Number(LocalStorageUtil.getItem("userId")),
                  accountId: responsedAccountId,
                  createdDate: new Date(),
                  archivalEmailRequired: archivalEmailRequired,
                  archivalReqApprovalEmailRequired:
                    archivalReqApprovalEmailRequired,
                  archiveLevelRules: archiveLevelRulesList,
                },
          mainsourcedetails: null,
          subsourcedetails: null,
          accountReconcilliationdetails: null,
          accountMode: accountId === 0 ? "create" : "edit",
        },
      };
      console.log("Params to submit", params);
      debugger;
      const response = await Add(params);
      if (response.message.toLowerCase() === "success create") {
        showSnackbar("Account configuration saved successfully.");
        getAccountData();
      } else {
        console.log("Error in response", response);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  //#endregion

  return (
    <div style={{ overflow: "hidden" }}>
      <NavigationBar
        menuTitle="Configuration"
        title="Account"
        text={
          accountId !== 0
            ? `Account Configuration - ${accountId}`
            : "Account Configuration - Create New"
        }
        screenTitle={accountId !== 0 ? "Update" : "Create"}
      />
      <Row
        className="mb-6"
        style={{
          color: "var(--aggrid-text-color)",
          fontSize: "8px",
        }}
      >
        <Col xs={12}>
          <div className="box">
            <div
              className="steps"
              style={{ marginLeft: "3em", marginTop: "-20px" }}
            >
              <Stepper
                activeStep={activeStepNew}
                sx={{
                  mt: 3,
                  "& .MuiStepLabel-label": {
                    color: "var(--aggrid-text-color)",
                    fontSize: "15px",
                  },
                }}
              >
                {filteredSteps.map((step, index) => (
                  <Step key={step.key}>
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>{" "}
              <div>
                {activeStepNew === filteredSteps.length ? (
                  <div></div>
                ) : (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "2em",
                        color: "var(--aggrid-text-color)",
                        fontSize: "12px",
                        gap: "10px",
                      }}
                    >
                      {activeStepNew !== 0 && (
                        <Tooltip title="Click to navigate to previous page">
                          <Button
                            disabled={activeStepNew === 0}
                            onClick={handleBack}
                            className={styles.btnClass}
                          >
                            Previous
                          </Button>
                        </Tooltip>
                      )}
                      {activeStepNew !== filteredSteps.length - 1 && (
                        <Tooltip title="Click to navigate to next page">
                          <Button
                            onClick={handleNextSubmitNew}
                            className={styles.btnClass}
                          >
                            Next
                          </Button>
                        </Tooltip>
                      )}
                    </div>
                    <div>
                      {renderStepContent(filteredSteps[activeStepNew]?.key)}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "5em",
                        color: "var(--aggrid-text-color)",
                        fontSize: "12px",
                        gap: "10px",
                      }}
                    >
                      {" "}
                      {activeStepNew !== 0 && (
                        <Tooltip title="Click to navigate to previous page">
                          <Button
                            disabled={activeStepNew === 0}
                            onClick={handleBack}
                            className={styles.btnClass}
                          >
                            Previous
                          </Button>
                        </Tooltip>
                      )}
                      {activeStepNew !== filteredSteps.length - 1 ? (
                        <Tooltip title="Click to navigate to next page">
                          <Button
                            onClick={handleNextSubmitNew}
                            component="span"
                            className={styles.btnClass}
                          >
                            Next
                          </Button>
                        </Tooltip>
                      ) : (
                        <div
                          className="col-md-11"
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            color: "var(--aggrid-text-color)",
                            fontSize: "12px",
                            width: "94%",
                            gap: "10px",
                          }}
                        >
                          <Tooltip title="Click to Submit Account configuration settings">
                            <Button
                              onClick={handleSubmitClick}
                              component="span"
                              className="update-button"
                            >
                              Submit
                            </Button>
                          </Tooltip>
                          <Tooltip title="Click to Cancel">
                            <Button
                              onClick={handleCancelClick}
                              component="span"
                              className="cancel-button"
                            >
                              Cancel
                            </Button>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Confirmation Dialog box to close account configuration */}
            <Dialog
              open={confirmDialogOpen}
              onClose={() => handleConfirmDialogClose(false)}
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle
                style={{
                  backgroundColor: "var(--primary-color)",
                  color: "var(--aggrid-text-color)",
                  fontSize: "14px",
                }}
              >
                {dialogBoxTitle}
              </DialogTitle>
              <DialogContent style={{ fontSize: "14px", marginTop: "20px" }}>
                {confirmDialogMessage}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => handleConfirmDialogClose(true)}
                  color="primary"
                  style={{
                    fontSize: "14px",
                    color: "var(--aggrid-text-color)",
                    backgroundColor: "var(--primary-color)",
                  }}
                >
                  Yes
                </Button>
                <Button
                  onClick={() => handleConfirmDialogClose(false)}
                  color="primary"
                  style={{
                    fontSize: "14px",
                    color: "var(--aggrid-text-color)",
                    backgroundColor: "var(--primary-color)",
                  }}
                >
                  No
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default NewAccountConfiguration;
